export default {
  common: {
    noFace: '얼굴이 없습니다',
    noPermissionTip: '이 기능을 사용할 수 없습니다. 구매 또는 갱신 후 계속하세요.',
    selected: '선택되다',
    continue: '계속',
    open1: '열다',
    doubleClick: '더블 클릭',
    inputKeywordSearch: '키워드 검색 입력',
    inputKeywordStartSearch: '키워드를 입력하여 검색 시작',
    searchHistory: '검색 내역',
    clearHistory: '기록 지우기',
    notFoundRelatedResults: '관련 결과를 찾을 수 없음',
    switch: '전환',
    searchProductionLine: '설비 생산 라인',
    selectProductionLine: '생산 라인 선택',
    rotateAngleTip: '{angle} 회전',
    plankText: '판재',
    sendToEzSort: '컬러 레이블로 보내기',
    downloadEzSort: '지화 채표 다운로드',
    notDownloadTip: '만약 지화채표가 정상적으로 열리지 않으면 다운로드하지 않았기 때문일 수 있습니다. 아래 단추를 눌러 지화채표를 다운로드하십시오',
    updateTip: '소프트웨어 업데이트가 감지되었습니다. 캐비닛을 다시 시작하십시오.',
    betaTest: '내부 테스트 제한 면제',
    ersortSpecail: '컬러 로고 전속',
    exclusiveFeature: '전용 기능',
    elementCanBeDragTip: '요소를 드래그할 수 있습니다.',
    checkPlankIsConflict: '보드 상태를 검사하는 중',
    preferenceSaveErr: '환경 설정 저장 예외',
    guimen: '장문',
    preferenceLoadTip: '환경 설정을 로드하는 중',
    preferenceLoadErrTip: '환경 설정을 로드하지 못했습니다. 환경 설정 오류가 발생하지 않도록 새로 고치고 다시 시도하십시오!',
    localFileIsBeingWrite: '로컬 파일 쓰기 중',
    taskMonitor: '작업 모니터링',
    downloadByType: '{type} 다운로드',
    slotKnifeErr: '특정 슬롯에 대한 가공 도구가 누락되었습니다. 생산 라인 설정을 확인해주세요! 【{msg}】',
    anewChooseCatalog: '디렉토리 다시 선택',
    downloadSetting: '다운로드 설정',
    attention: '주의',
    unit: '덩어리',
    defaultUse: '기본 사용',
    defaultChooseUse: '기본 선택',
    requestFail: '요청 실패',
    downloadDoneByType: '{type} 다운로드 완료',
    sysTip: '시스템 알림',
    pleaseChoose: '선택해 주세요',
    confirmDelete: '삭제 확인',
    notDataTipByType: '데이터가 없습니다. 먼저 {msg}해주세요',
    paginationTotalTip: '{current}-{page} /{total} 개',
    chooseAmountData: '{number} 개의 데이터 선택',
    moreOperate: '더',
    transferByType: '{type} 전송',
    clickCopy: '{type} 복사',
    currentLine: '현재 행',
    remark: '비고',
    customFunction: '사용자 정의 기능',
    limitedTimeTrial: 'Limited Free',
    startDate: '시작 날짜',
    endDate: '종료일',
    startTime: '시작 시간',
    endTime: '종료 시간',
    lastMonth: '최근 한 달',
    lastSixMonth: '최근 반년',
    lastYear: '최근 1년',
    searchByType: '{type} 입력하여 검색',
    addTime: '시간 추가',
    startArrange: '조판을 시작하다',
    select: '선택',
    search: '검색',
    name: '이름',
    plankNo: '보드 번호',
    plankName: '보드 이름',
    orderNo: '주문 번호',
    order: '주문',
    partNameWithoutRoomCabinet: '보드 이름(방/캐비닛 제외)',
    plankRemark: '보드 메모',
    room: '방',
    orderAddress: '프로젝트 주소',
    matCode: '소재',
    matCode2: '재료',
    plankMatCode: '판재 재질',
    count: '수량',
    customer: '고객',
    customerInfo: '고객 자료',
    factoryOrderNo: '공장 번호',
    roomName: '방 이름',
    color: '색깔',
    plankColor: '판재 색상',
    plankThick: '판재 두께',
    plankHighGloss: '하이라이트 속성',
    thick: '두께',
    front: '정면',
    back: '뒷면',
    slot: '구멍',
    hole: '구멍',
    hsInfo: '{hole} 구멍 {slot} 슬롯',
    diameter: '직경',
    finishedWidth: '최종 품목 너비',
    finishedHeight: '최종 품목 길이',
    finishedArea: '완성품 면적(㎡)',
    remarks: '메모',
    remark1: '메모 1',
    remark2: '메모 2',
    remark3: '메모 3',
    remark4: '메모 4',
    remark5: '메모 5',
    remark6: '메모 6',
    remark7: '메모 7',
    remark8: '메모 8',
    remark9: '메모 9',
    remark10: '메모 10',
    remark11: '메모 11',
    remark12: '메모 12',
    remark13: '메모 13',
    remark14: '메모 14',
    remark15: '메모 15',
    remark16: '메모 16',
    texture: '텍스쳐',
    normal: '세로 무늬',
    reverse: '가로무늬',
    notCare: '텍스쳐 없음',
    holeSlotsStastic: '구멍 슬롯 수',
    edge: {
      title: '봉인',
      info: '봉인 정보',
      front: '전면 모서리',
      back: '후면 모서리',
      left: '왼쪽 봉인',
      right: '오른쪽 봉인',
      up: '위쪽 봉인 모서리',
      down: '아래 봉인 모서리'
      },
    isSpecial: '에일리언',
    notSpecial: '비이형',
    textOfDoorPlank: '문짝',
    textOfNotDoorPlank: '비문짝',
    isDoorPlank: '문짝',
    notDoorPlank: '비문판',
    width: '너비',
    long: '길이',
    plankWidth: '판재 너비',
    plankHeight: '판재 길이',
    shortLong: '짧은 모서리 길이',
    shortWidth: '짧은 모서리 폭',
    plankShape: '판재 모양',
    detail: '상세 정보',
    cancel: '취소',
    confirm: '확인',
    alreadyKnow: '나는 이미 알고 있다',
    Noprompts: '더 이상 프롬프트 없음',
    deep: '깊이',
    other: '기타',
    heighGloss: '하이라이터',
    heighGlossPlank: '고광판',
    heighGlossSide: '고광면',
    notHeighGloss: '비고광선',
    notHeighGlossPlank: '비고광판',
    saveSuccess: '저장 성공',
    deleteSuccess: '삭제 성공',
    addSuccess: '추가 성공',
    editSuccess: '수정 성공',
    engraving: '조각기',
    electronicSaw: '전자톱',
    glassEquip: '유리 절단기',
    labelingMachine: '부착기',
    copy: '복사',
    paste: '붙여넣기',
    undo: '취소',
    move: '이동',
    PTP: 'PTP',
    dock56FDrill: '대여섯 면 드릴',
    sideHoleDrill: '측공기',
    combination: '콤보 장치',
    integration: '올인원',
    standardPlank: '표준 보드',
    standardMaterial: '표준 판재',
    standardMaterialTip: '참고: 대판 정보 조정을 완료한 후, 캐비닛 조판 생산의 사용자는 캐비닛 클라이언트를 다시 시작하여 최신 변경을 적용해야 합니다!',
    specialMaterial: '특수 판재',
    specialPlank: '특수 대판',
    singlePlank: '단일 패널',
    previous: '이전',
    plankInfo: '보드 상세 정보',
    moreResult: '더 많은 레이아웃 시나리오',
    moreResultTip: '판자에 가장자리를 붙여 가공한 슬롯이 있어, 판자는 재조판에 참여하지 않을 것이다',
    ok: '확정',
    dispersePaibanTip: '일부 대판이 분산 조판을 할 수 없다는 것을 감지했습니다. 당신은 수동으로 조판 방안을 조정하거나 전환할 수 있습니다. 달리기 판을 만들지 않도록 할 수 있습니다!',
    next: '다음',
    rate: '활용도',
    paibanBatch: '조판 차수',
    return: '돌아가다',
    FGNo: '계약 번호',
    refresh: '새로 고침',
    inde: '번호',
    productionLine: '생산 라인',
    operation: '조작',
    colorPlaceHolder: 'Enter를 눌러 색상 카드 자동 생성',
    saveAndContinue: '저장 및 계속',
    reset: '초기화',
    check: '조회',
    inputPlaceholder: '입력하십시오.',
    filter: '선별',
    all: '전부',
    exportPDF: 'PDF 내보내기',
    exportPic: '그림 내보내기',
    add: '추가',
    edit: '편집',
    delete: '삭제',
    restore: '복구',
    save: '저장',
    saveSetting: '설정 저장',
    isHeightGloss: '하이라이트인지 여부를 선택하십시오.',
    noSync: '동기화 중단',
    sync: '동기화',
    formatSuccess: '{type} 성공',
    dataLoading: '데이터가 로드되고 있습니다......',
    warmTip: '친절한 안내',
    importantTip: '중요한 알림',
    wellcome: '클라우드 레이아웃 시작',
    timeOut: '조판 시간 초과, 재조판 여부',
    notSawKnifeTip: '참고: 톱질 조각기에서 "가로 자르기 톱날" 을 설정하지 않아 조판을 할 수 없습니다. 추가하러 가십시오!',
    doorFrameKnifeRadiusErr: '"톱질 조각기-문틀 절단" 기능을 활성화했습니다. 하料 칼 반경이 톱날 두께보다 커서 조판할 수 없습니다!',
    doorFrameIrregularPlankErr: '"톱질 조각기-문틀 절단" 기능을 활성화했습니다. 이 기능은 현재 특형 판재 조판을 지원하지 않습니다!',
    warning: '경고',
    export: '내보내기',
    mark: '표시',
    noMark: '표시 안 함',
    sawArrange: '조판을 톱질하다',
    directArrange: '직절 조판',
    area: '면적',
    plankNum: '보드 바코드',
    loc: '캐비닛',
    cutHeight: '원단 길이',
    cutWidth: '원본 너비',
    defaultProduction: '기본 라인',
    surplusNum: '여분 바코드',
    tip: '힌트',
    history: '기록',
    hinge: '힌지 구멍',
    hingeScrew: '경첩 문판 인공',
    CCPXHole: '삼합일 편심공',
    stretchHinge: '지퍼 슬롯 및 힌지 컵 구멍',
    stretch: '매직기',
    stretcher: '스트레이트 슬롯',
    eccHole: '편심공',
    preHole: '사전 매몰구멍',
    clothole: '의통공',
    backPlank: '후면판 슬롯',
    ALS: '암암리에 팔짱을 끼다.',
    doorSlot: '문판 금속홈',
    drawerSlot: '서랍 금속홈',
    lkSlot: '음악 단추통',
    KC: '바지에 구멍이 나다',
    stealth: '스텔스 부품',
    lightSlot: '램프 슬롯',
    ConventionalHole: '일반 구멍',
    Keyhole: '열쇠 구멍',
    allHole: '이형판의 모든 구멍',
    allSlot: '이형판의 모든 슬롯',
    freedomAllHoleSlot: '이형판의 모든 구멍과 슬롯',
    freedomAllHoleSlotTip: '이형판: 직각이 아닌 모서리가 있는 이형판',
    millInfo: '소뿔이 손을 잡다.',
    haiTang: '해당각',
    FSDrill: '5 / 6 면 드릴',
    engraving2: '원료 공급기',
    xyReverse: 'XY 축 교환',
    autoXYReverse: '구멍 처리 장비 자동 적응 교환',
    autoXYReverseTip: '5/6 면 드릴의 가공 데이터와 캐비닛 드릴의 가공 데이터가 자동으로 캐비닛 드릴의 XY 축 교환에 적합하게 조정됩니다',
    autoXYReverseTip2: '주의: PTP는 지원되지 않습니다',
    xyReverseTip: 'XY 축 교환 기능은 아직 호환되지 않은 L형 여분 재료 부족이 정확하게 배치되었으니 신중하게 사용하십시오',
    rect: '직사각형',
    Ltype: 'L형',
    archive: 'Archive',
    tellPlaceholder: '핸드폰 번호를 입력하세요.',
    knivesStore: '칼 창고',
    roll: '판자 뒤집기',
    pause: '일시 정지',
    editTrans: '편집 번역',
    translateManager: '번역 관리',
    grating: '격자',
    addressEditErr: '프로젝트 주소 수정은 다중 주문에서 일시적으로 지원되지 않습니다.',
    customerEditErr: '다중 주문은 고객 프로필 수정을 지원하지 않음',
    factoryEditErr: '다중 주문은 공장 번호의 수정을 지원하지 않습니다.',
    roomNameEditErr: '다중 주문은 공간 이름 수정을 지원하지 않습니다.',
    remarkEditErr: '다중 주문은 당분간 주문 노트 수정을 지원하지 않습니다.',
    toMaterialList: 'BOM으로 이동',
    deleteFail: '삭제에 실패했습니다. 나중에 다시 시도하십시오!',
    batchRestore: '일괄 복원',
    batchDelete: '대량 삭제',
    workShop: '작업장 생산',
    FGAdrress: '프로젝트 주소 / 계약 번호',
    cuttingSize: '가공 치수',
    finishedSize: '최종 품목 크기',
    labelImg: '스티커 사진',
    layoutImg: '조판도',
    file: '파일',
    folder: '폴더',
    reName: '이름 바꾸기',
    to: '에',
    plankUnit: '장',
    tagTemp: '태그 템플릿',
    roomRemark: '룸 메모',
    noModificationPermission: '수정 권한 없음',
    modificationRecord: '레코드 수정',
    page: '페이지',
    strip: '조',
    jump: '점프',
    freeAgreement: '소프트웨어 책임 면제 계약',
    preStep: '이전 단계',
    nextStep: '다음 단계',
    upload: '업로드',
    uploading: '업로드 중',
    iAgree: '동의합니다',
    pleaseSelectPlank: '하나 이상의 보드를 선택하십시오.',
    saveToStoreTip: '트림되지 않은 보드를 하나 이상 선택하십시오.',
    fileIsNotExist: '파일이 없습니다.',
    selectAll: '모두 선택',
    pdfTag: 'PDF 레이블',
    tagImage: '태그 그림',
    guigui: 'Guigui',
    gratingSlot: '그리드 슬롯',
    deleteTip: '데이터를 삭제한 후 복구할 수 없습니다. 삭제하시겠습니까?',
    deleteError: '알 수 없는 오류가 발생하여 삭제에 실패했습니다.',
    cancelDelete: '삭제 취소됨',
    confirmDeleteTip: '뒷면 보드를 삭제하면 페이지 오른쪽 하단 모서리에 있는 "보드 준비 라이브러리 - 입고되지 않음" 으로 이동합니다. 이 데이터를 삭제하시겠습니까?',
    confirmDeleteBujianTip: '삭제 후 부품이 페이지 오른쪽 하단의 "부품 라이브러리"에 추가됩니다. 데이터를 삭제하시겠습니까?',
    confirmSureDeleteTip: '현재 대기중인 라이브러리에 동일한 재료의 보드가 감지되었습니다. 삭제 후 대기중인 라이브러리의 해당 보드는 표시되지 않습니다. 이 보드를 계속 삭제하시겠습니까?',
    deleteEmptyTip: '이 대시보드 삭제 여부',
    notCanDelete: '재단된 여분의 재료는 입고가 지원되지 않습니다.',
    new: 'New',
    innerBluneFailure: '내장 클라우드 레이아웃은 이 기능에 적용되지 않습니다.',
    deleteBigPlankTip: '마지막 큰 판에 작은 판이 존재하여 삭제할 수 없습니다!',
    continueExport: '무시, 파일 내보내기 재개',
    toCheck: '검사하러 가다',
    pleaseCheck: '현재 조판 결과에 슬롯 충돌 / 슬롯 밖으로 날아가기 / 깊이 이상이 있습니다. 확인하십시오!',
    clampHandCheck: '일부 플레이트의 구멍 슬롯에서 클립의 위치를 피할 수 없음이 감지되었습니다. 수동으로 조정하십시오.',
    conflictPartDetail: '충돌하는 보드 상세 정보',
    colorNotUndefined: '색상은 비워둘 수 없습니다.',
    materialNotUndefined: '재료는 비워둘 수 없습니다.',
    newSetting: '새로운 기능',
    downImageErrTip: '스티커 이미지를 열면 보드에 따라 다른 폴더로 나눌 수 있으므로 보드 레이블을 선택하여 함께 내보내려면 그림 내보내기에 실패했습니다.',
    downNcErrTip: 'NC를 다운로드하지 못했습니다. 맵 이미지를 열면 보드에 따라 폴더가 다르기 때문에 보드 레이블을 선택하여 내보내야 합니다',
    downNcErrTipForSurFolder: 'NC 다운로드에 실패했습니다. 스티커 이미지는 보드에 따라 다른 폴더와 여분 보드 파일 설정으로 나뉘어 동시에 열 수 없습니다.',
    yes: '예',
    no: '아니',
    checkColorPrint: '현재 컬러 레이블이 켜져 있습니다. 컬러 프린터를 사용하여 인쇄하십시오.',
    colorRules: '컬러 라벨 생성을 켜면 주문/방/캐비닛/문짝이 색상에 따라 구분됩니다. 현재 컬러 라벨은 같은 유형의 데이터에 대한 지원 상한선이 12개입니다. 구체적인 규칙은 다음과 같습니다.',
    greyPart: '오른쪽 탭의 회색 부분은',
    region: '지역',
    notSame: '{regionName} 지역 색상이 다릅니다',
    doorTip: '회색은 문짝, 흰색은 비문짝이다',
    exist: '존재',
    limitNotEffect: '데이터 12개 이상, 컬러 레이블 적용 안 함',
    hoverTip: '현재 bmp 접미사 그림, 인코딩 형식 흑백, 컬러 라벨 그림을 출력할 수 없습니다',
    lock: '잠금',
    unlock: '잠금 해제',
    batchLock: '대량 잠금 / 잠금 해제',
    surplusLock: '남은 재료 잠금',
    surplusUnlock: '남은 재료 잠금 해제',
    is: '예',
    not: '아니',
    savingHistory: '히스토리 파일 저장 중',
    saveHistorySuccess: '히스토리 파일을 저장했습니다.',
    saveHistoryFail: '히스토리 파일을 저장하지 못했습니다.',
    bw: '흑백 태그 내보내기',
    modular: '유닛 캐비닛',
    autoAdjust: '자동 조정',
    cutOrderTip: '{errorCutOrdersString} 대 판의 가공 순서에 오류가 발생했습니다! NC 파일을 다운로드하기 전에 조정하세요',
    lockedCutOrderTip: '【{errorCutOrdersString} 대 판】이 잠겨 있습니다. 수동으로 수정하려면 이동하세요',
    paibanImgCutOrderTip1: '사용자가 감지됨',
    paibanImgCutOrderTip: '가공 순서에 오류가 있습니다!레이아웃 페이지 조정 후 레이아웃 파일 내보내기',
    goAdjust: '조정하다',
    autoAdjustWarning: '현재 조판 결과는 자동 조정을 지원하지 않습니다',
    checkNetwork: '네트워크를 확인하십시오.',
    moreInfo: '추가 정보 보기',
    continueLayout: '조판을 계속하다',
    adjustPosition: '설정 조정',
    specialAndFiveSix: '5 / 6면 드릴링 가공 플레이트가 이형일 경우 이형 네스트를 열면 플레이트가 잘릴 수 있습니다. 레이아웃을 계속하시겠습니까?',
    plankPathErr: '내부 플레이트 이형 데이터 오류, 도구 사양에 맞는지 확인하세요! 보드 번호 [{plankidlist}]',
    edgeCheck: '시스템이 대판이 존재하는 수정된 모서리를 감지하였으니, 다시 조판하여 생산이 정확한지 확인하십시오',
    iKnow: '알았어',
    versionErrTip: '캐비닛을 최신 버전으로 업데이트하십시오!',
    annualFeeExpired: '당신의 연회비가 이미 만기가 되었으니, 갱신하십시오!',
    holeEquipment: '드릴 장비 {num}',
    customizedService: '맞춤형 서비스를 지원하여 고객의 고유한 프로덕션 솔루션 구축',
    exampleCombination1: '조각기 + 5/6면 드릴 + 측공기 조합',
    exampleCombination2: '전자톱 + 5/6면 드릴 + 측공기 조합',
    exampleCombination3: '전자동 일체형 생산라인 + 5/6면 드릴 조합',
    feedback: '귀하의 캐비닛 소프트웨어 판매 또는 판매 후 직원에게 귀하의 요구를 직접 피드백할 수 있습니다.',
    markModifiedBoards: '수정된 보드를 식별합니다.',
    showMoveStep: '키보드 이동 단계 설정',
    moveStep: '키보드 이동 단계',
    existChangeBoards: '변경된 보드가 있습니다.',
    crossMaterialBoard: '다른 재질·색상 보드',
    skipCrossMaterialTip: '이번 배치에서 다시 표시하지 않기',
    crossMaterialConfirmTip: '다른 재질이나 색상으로 소형 보드를 이동하고 있습니다. {highlight} 계속하시겠습니까?',
    crossMaterialConfirmTipHighlight: '생산된 보드가 분할 주문의 재질/색상과 일치하지 않을 수 있습니다',
    exportHoleSlotPDF: '구멍 슬롯 그림 내보내기',
    pdfFormat: 'PDF 형식',
    dxfFormat: 'DXF 형식',
    specialShapeKnivesInfo: '이형 선택 팁',
    specialShapeKnivesInfoTips: '보드 {stockNum}:',
    specialShapeKnivesInfoTips2: '이형 자동 선택 공구가 켜져 있고 레이아웃 데이터가 이상하므로 BOM에서 재레이아웃하거나 이형 자동 선택 기능을 해제하십시오.',
    default: '기본',
    exportLanguage: '언어 내보내기',
    exportLanguageTip: '참고: 일부 텍스트 정보 내보내기 pdf를 번역할 수 없습니다.',
    highGlossNameTip: '캐비닛에서 동기화된 하이라이트 패널은 하이라이트 속성에 영향을 주지 않고 다른 문서로 설명될 수 있습니다.',
    mixPaibanPlanSetting: '혼합 배열 시나리오 설정',
    mixPaibanPlanSettingTip: '시스템 검사 혼합 배열 방안 설정이 변경되었습니다. 이번 혼합 배열 방안을 다시 선택하십시오!',
    mixPaibanPlanSettingOk: '혼합 배열 설정',
    mixPaibanPlanSettingCancel: '아뇨, 그냥 조판해요',
    noMixPaibanPlan: '사용 가능한 혼합 배열 스키마 없음',
    mixColors: '혼합 색상',
    mixPai: '혼합',
    plan: '방안',
    mixPaibanTitle: '서로 다른 색깔의 작은 판자를 한데 배열하다.',
    mixColorsTip: '판재의 원래 색상 정보를 변경하지 않고 동일한 색상으로 큰 판에 배치할 수 있는 색상의 판재를 정의할 수 있습니다.',
    mixColorsTip2: '프로젝트를 추가한 후에는 BOM을 열어야 적용됩니다.',
    mixColorsTip3: '이색 봉인 기능에 충돌이 있어 일시적으로 이 기능을 동시에 적용할 수 없습니다',
    mixErrTip: '혼합 배열에 필수 항목이 없습니다. 확인하십시오.',
    addPlan: '스키마 추가',
    chooseMatcode: '재료 선택',
    chooseColor: '색상 선택',
    defineColor: '선택한 색상을',
    confirmDeletePlan: '이 스키마를 삭제하시겠습니까?',
    trimmingMethod: '모서리 손질 방식',
    followStandardTrim: '원판 중의 표준 판재의 수선값을 따르다',
    trimToast: '참고: 남은 재료의 사용자 정의 모서리 수정 기능을 사용하였으며, 옵션으로 조판을 톱질할 수 있습니다.',
    individualTrimValue: '모서리 수정 값을 개별적으로 설정하려면 다음과 같이 하십시오.',
    topTrimEmptyToast: '가장자리를 비워서는 안 된다!',
    bottomTrimEmptyToast: '아래쪽 가장자리는 비워둘 수 없습니다!',
    leftTrimEmptyToast: '왼쪽 가장자리는 비워둘 수 없습니다!',
    rightTrimEmptyToast: '오른쪽 가장자리는 비워둘 수 없습니다!',
    topTrimBlurToast: '업스트림 모서리 값을 입력하십시오.',
    bottomTrimBlurToast: '모서리 수정 값을 입력하십시오.',
    leftTrimBlurToast: '왼쪽 트림 모서리 값을 입력하십시오.',
    rightTrimBlurToast: '오른쪽 수정 모서리 값을 입력하십시오.',
    effectToast: '1. 사용자 정의 모서리 수정 기능은 용접판에만 적용됩니다.',
    defaultTrimSetting: '남은 재료 기본 모서리 설정',
    enterHere: '여기 입력',
    permissionTipExportDxf: 'DXF 홀 슬롯 다이어그램 내보내기',
    permissionTipSurplusRecycleBin: '잔여 재료 재활용함',
    permissionTipAdvancedNesting: '고급 불규칙 중첩',
    permissionTipPanelGrainAlign: '판재 결 정렬',
    permissionSeparator: ', ',
    missingPermissionTip: '다음 권한이 없습니다: {permissions}'
    },
  home: {
    head: {
      production: '제품 소개',
      resolve: '솔루션',
      about: '회사 소개',
      equipment: '기계 설비',
      tell: '신고 전화',
      enter: '클라우드 레이아웃에 들어가기'
      },
    swiper: {
      case1: {
        tag: '새로운 업그레이드',
        subTitle: '기계의 지능적인 두뇌',
        description: '업계의 클라우드 온라인 레이아웃 최적화 소프트웨어 개혁'
        },
      case2: {
        title: '캐비닛 생산',
        subTitle: '기술 혁신',
        description: '다양한 부착기, 원료 공급기, 측면 구멍 기계, 5면 PTP, 5면 / 6면 드릴 도킹 지원'
        },
      case3: {
        title: '산업 두뇌',
        subTitle: '솔루션',
        description: '지능형 레이아웃 알고리즘으로 판재 활용도 향상'
        }
      },
    statistics: {
      today: '오늘 배차량',
      toMounth: '당월 조판량',
      outturn: '출재율',
      cumulative: '누적 사용자'
      },
    intro: {
      title: '엔터프라이즈급 빅 데이터 클라우드 온라인 레이아웃 소프트웨어',
      subTitle: '업계 태세를 통찰하고 고객의 수요에 초점을 맞추며 기업의 디지털 전환 업그레이드를 부여하고 인터넷 가구 생산 자동화 산업 변혁을 추진하여 기존 판식 가구 업계 생산 장면에 맞추어 AI 보조 알고리즘을 출시하여 기업의 새로운 성장을 지속적으로 공헌한다',
      menue: {
        case1: {
          title: '온라인 조판',
          subTitle: '언제든지 조판할 수 있다',
          description: '소프트웨어를 다운로드할 필요 없이, 언제든지 조판할 수 있으며, 원격 조종은 컴퓨터에 의존할 필요가 없다'
          },
        case2: {
          title: '다선 생산',
          subTitle: '빠른 생산 라인 전환',
          description: '여러 생산 라인이 동시에 신속하게 가공되도록 지원하여 생산 라인 간에 신속한 전환이 가능합니다.'
          },
        case3: {
          title: '정밀 생산',
          subTitle: '세밀한 레이아웃, 세밀한 매개변수 설정',
          description: '정밀 조판, 정밀 파라미터 설정으로 판재 생산을 더욱 정밀하게 하다'
          },
        case4: {
          title: '맞춤형 프로덕션',
          subTitle: '사용자 정의 레이블, 5, 6면 드릴, 여분 형태',
          description: '사용자 정의 라벨, 사용자 정의 5, 6면 드릴, 사용자 정의 여분 모양, 조합 설비 가공'
          }
        }
      },
    fangan: {
      title: '업계 전문 솔루션',
      subTitle: '낮은 비용, 높은 생산성, 지능형 알고리즘으로 보드 활용도를 높이고 다양한 디자인 소프트웨어와 호환되며 사용자에게 최적의 생산 방안을 제공합니다.',
      menue: {
        case1: {
          title: '온라인 주문 생산 일체화',
          description: '원격 온라인 조작, 공간 장애를 뛰어넘고, 수시로 주문 동시 공장을 수출하고, 설계 생산 동시 완성'
          },
        case2: {
          title: '원클릭으로 생산 라인을 전환하다.',
          description: '맞춤형 라인, 다중 라인 지원, 다중 유형 장치 도킹'
          },
        case3: {
          title: '지능 알고리즘으로 판재 이용률 향상',
          description: '전통적인 알고리즘 판재 이용률이 낮고, 스마트 알고리즘 정밀 파라미터 설정, 맞춤형 생산 방안'
          },
        case4: {
          title: '전문 절단 시나리오',
          description: '패스가 짧고 안정적으로 가공되도록 가공 순서, 언더컷 점 최적화'
          }
        }
      },
    aboutUs: {
      title1: '뉴 겔 주거 기술',
      subTitle: '가구 산업 변혁의 창시자',
      description: '신겔 기업, 전통 가구 산업 의 인터넷 변혁 에 집중 하다',
      culture: {
        case1: {
          title: '기업의 목적',
          subTitle: '3배 증가한 공장 지원'
          },
        case2: {
          title: '문화적 가치관',
          subTitle: '고객을 중심으로, 분투자의 근본으로, 간고분투하여 인민을 행복하게 하다'
          },
        case3: {
          title: '지도 사상',
          subTitle: '대중 노선, 판매력, 제품력, 조직력을 갖춘 엘리트 팀 구축'
          }
        },
      feature: {
        case1: '전문 팀 유지 관리',
        case2: '지속적인 업데이트 반복',
        case3: '일대일 애프터서비스',
        case4: '기능 사용자 정의 서비스'
        }
      },
    cooperation: {
      title: '성심성의껏 협력하여 미래를 함께 창조하다.',
      subTitle: '도킹 설비 브랜드는 90% 의 국내 공산 상용 설비를 커버하고, 107554명의 상인이 우리와 동행한다'
      },
    footer: {
      contact: {
        title: '연락처',
        adrres: '주소: 강소성 무석시 빈호구 수계50호',
        subAdrres: 'K-Park 서비스센터 1호동 16층',
        tell: '전화'
        },
      business: {
        title: '뉴 그릴 핵심 사업',
        department1: '도어 윈도우 소프트웨어 사업부',
        department2: '가구 소프트웨어 사업부',
        department3: '조립건축사업부',
        department4: '뉴 그릴 본사 홈페이지'
        },
      brand: {
        title: '뉴 겔 산하 브랜드',
        brand1: '재신금복',
        brand2: '문도망',
        brand3: '정흠투자',
        brand4: '3장 도과학기술',
        brand5: '상해 분묵 과학기술'
        },
      organization: {
        title: '뉴 겔 글로벌 지사',
        organization1: '신겔-화남국 (불산지사)',
        organization2: '신겔-북방국 (림기지사)',
        organization3: '신겔-서남국 (성도지사)',
        organization4: '뉴 그릴 - 캐비닛 서부 서비스 센터',
        organization5: '뉴 그릴 - 캐비닛 동부 서비스 센터',
        organization6: '뉴 겔 - 대리점 클러스터',
        organization7: '뉴 겔 - 국제 마케팅 부서'
        },
      follow: {
        title: '"관심 캐비닛" 청소'
        },
      friendLink: {
        link1: '새로운 겔 소프트웨어',
        link2: 'K 쇼 구매 안내 소프트웨어',
        link3: '문도망',
        link4: '전체 알루미늄 캐비닛 소프트웨어',
        link5: 'ZOL 소프트웨어 다운로드',
        link6: '화군소프트웨어원',
        link7: '다운로드 홈',
        link8: 'ZOL 소프트웨어 다운로드',
        link9: '녹색자원망',
        link10: '옷장 가맹',
        link11: '가정 가맹',
        link12: '미표 목욕탕 가맹'
        }
      }
    },
  login: {
    title: '로그인',
    tell: '휴대폰 번호',
    password: '비밀번호',
    passwordPlaceholder: '비밀번호를 입력하세요',
    forget: '암호를 잊었습니다.',
    registerAccount: '계정 등록',
    backLog: '로그인으로 돌아가기',
    verifyCode: '인증 코드',
    getVerifyCode: '인증 코드 가져오기',
    verifyCodeErr: '인증 코드 오류',
    confimPassword: '암호 확인',
    confimPasswordPlaceholder: '비밀번호 확인',
    editPassword: '암호 수정',
    register: '등록',
    reSend: '나중에 다시 가져오기',
    loginLoadText: '로그인 중입니다. 잠시만 기다려 주십시오...',
    loadingPageTextL: '로그인했습니다. 페이지 구조를 로드하는 중입니다...',
    loginSuccess: '로그인 성공',
    tellErr: '핸드폰 번호의 형식이 정확하지 않다.',
    passwordErr: '비밀번호를 입력하세요'
    },
  main: {
    head: {
      title: 'Bluen',
      subTitle: 'Save time, materials, and effort',
      task: '임무를 맡다',
      arrange: '편집',
      surplus: '여분',
      setting: '설정',
      find: '발견',
      upgrade: '지금 업그레이드',
      editNickName: '닉네임 수정',
      editPassword: '암호 수정',
      logout: '로그인 종료',
      notice: '공지',
      enterOfficial: '공식 홈페이지로 이동',
      equipment: '기계 설비',
      help: '도움',
      importFunc: '고유 기능 보기',
      enterThinkerOfficial: '뉴 겔 공식 홈페이지 입장',
      history: '기록 저장',
      plankManager: '원본 관리',
      tagManager: '태그 관리',
      suplumentManager: '패치 및 예약된 라이브러리',
      fileManager: '파일 관리',
      productionLine: '장치 버트',
      workeShop: '클라우드 프로덕션',
      useLesson: '자습서 사용',
      videoLesson: '비디오 자습서',
      prolineManager: '생산라인 관리',
      materialManager: '보드 관리',
      productManual: '제품 브로셔',
      medialRelated: '그라데이션 게시'
      },
    sideBar: {
      title: '생산 최적화',
      materialList: '커팅 리스트',
      paibanTask: '조판 작업',
      paibanResult: '조판 방안',
      printTag: '레이블 인쇄',
      history: '기록 저장',
      limitDate: 'Limited Free',
      surplusManager: '여분 관리',
      translateManager: '번역 관리',
      moreSettings: '추가 설정',
      deepSeekTitle: '컨설턴트',
      paibanCommune: '조판 교류군'
      },
    allRead: '모두 읽음',
    learnMore: '자세히 보기',
    noticeEmpty: '잠시 공고가 없다....',
    noticeErr: '자세한 공지 내용 가져오기 오류',
    feedBack: {
      tab1: '피드백 제출',
      tab2: '피드백 레코드',
      type: '의견 유형',
      typePlaceholder: '기능 선택',
      description: '묘사',
      descriptionPlaceholder: 'hi~15자 이상의 상세한 사용 장면 설명을 기입하여 우리가 당신에게 더 잘 도움을 제공할 수 있도록 해 주십시오. 협조해 주셔서 감사합니다!',
      uploadPic: '그림 추가, 최대 6장, 단일 사진 크기 10M 미만)',
      tell: '연락처',
      submit: '제출',
      admin: '클라우드 레이아웃 관리자:',
      picTip: '사진: (사진 상세 정보를 보려면 확장 클릭)',
      empty: '피드백 데이터 없음',
      picErr: '한 장의 그림 크기는 10M을 넘지 않는다',
      contentErr: '글자 수는 15에서 300 사이여야 한다',
      necessary: '이 옵션은 필수입니다.'
      }
    },
  taskPage: {
    tab1: '생산 임무',
    tab2: '대량 생산 대기열',
    filter: {
      title: '선별',
      unArrange: '미조판',
      arranged: '조판됨',
      allArranged: '모두 조판됨',
      preLayout: '사전 조판'
      },
    search: {
      placeholder: '검색 내용을 입력하십시오.',
      orderName: '주문 이름',
      sender: '보낸 사람'
      },
    importTask: '작업 가져오기',
    refuseTask: '작업 거부',
    refreshList: '목록 새로 고침',
    refuseRecord: '레코드 거부',
    taskCard: {
      sender: '가져온 커팅 리스트',
      delivery: '납기',
      delete: '삭제',
      addToBatch: '대량 추가',
      save: '아카이빙',
      arrange: '직접 조판',
      deleteTitle: '작업 삭제',
      checkDetail: '자세한 내용을 보려면 클릭하십시오.',
      refuse: '거절',
      refuseTime: '거부 시간',
      refuseReason: '거부 이유',
      refuseTask: '거부 임무',
      refuseTaskPlaceholder: '거부 이유를 입력하십시오.',
      addErr: '추가에 실패했습니다. 나중에 다시 시도하십시오!'
      },
    batchNo: '로트 번호',
    batchArrange: '대량 조판',
    clearBatch: '대기열 비우기',
    taskCount: '현재 작업 수:',
    checkAllTask: '모든 커팅 리스트 보기',
    clearSuccess: '지우기 성공',
    record: {
      batchNo: '배치',
      saveDate: '저장 시간',
      materialList: '재료 명세서',
      arrangedRecord: '조판 방안',
      searchPlaceholder: '배치 번호를 입력하십시오.',
      tipText: '이 아카이브를 삭제하시겠습니까?'
      },
    errTip: '가공할 수 있는 작업 데이터가 없습니다. 작업 목록으로 가서 추가하십시오!',
    emptyErr: '이 작업 주문은 보드 데이터가 없어서 조판 생산을 진행할 수 없습니다!',
    operationSuccess: '작업 성공',
    operationFail: '작업이 실패했습니다. 나중에 다시 시도하십시오.',
    saveSuccess: '아카이브 성공',
    plankMaxLimit: '널빤지 수량이 최대 조판 상한선을 초과하다',
    batchWorning: '차수로 나누어 생산해 주십시오',
    batchEmptyErr: '주문 목록에 보드 데이터가 없어 대량 생산이 불가능합니다!',
    noRoomTip: '방이 존재하지 않아 대량 생산을 진행할 수 없습니다!',
    refuseHistory: '거부 기록'
    },
  materialPage: {
    specialProcess: '특수 공예',
    distanceFromTop: '거리 위',
    distanceFromRight: '오른쪽',
    hingeData: '힌지 데이터',
    labelBackProcTip: '이번 업데이트는 이미 대판 뒷면 부착 방식을 최적화하였습니다. 현재 라벨의 정보에 따라 직접 테두리를 봉하고 구멍을 뚫어 슬롯을 당기면 됩니다. 당신이 알기를 바랍니다!',
    openDir: '문 여는 방향',
    edgeEmptyTip: '모서리 수정 값은 비워둘 수 없습니다.',
    edgeNumberLimit: '모서리 수정 값은 숫자만 입력할 수 있습니다.',
    chooseSurplusQuantity: '사용 가능한 잔여 자재 {total} 종류, {quantity} 종류 선택',
    noCanSaveInfo: '저장할 정보가 없습니다.',
    chooseBujianStoreQuantity: '총 {total} 개의 보수 판, {quantity} 개의 보수 판을 포함할 수 있으며, {chooseQuantity} 개의 판이 선택되었습니다.',
    isConfirmPushToAwaitStore: '선택한 보드를 보류 중인 라이브러리에 추가하시겠습니까?',
    enterAutoCreateMatCode: '롤백을 누르면 재료가 자동으로 생성됩니다.',
    chooseAwaitStoreQuantity: '총 {total} 개의 보류 중인 라이브러리 소판, {quantity} 개의 판을 포함할 수 있으며, {chooseQuantity} 개의 판이 선택되었습니다.',
    defaultFold: '보드 데이터 기본 축소',
    startArrange: '조판을 시작하다',
    importMaterial: '커팅 리스트 가져오기',
    saveToHistory: '역사에 저장',
    addPlank: '보드 추가',
    addBujian: '패치 추가',
    deletePlank: '보드 삭제',
    batchEdit: '대량 수정',
    moreSetting: '추가 설정',
    plankSize: '보드 크기',
    plankSize2: '크기 (길이 * 폭 * 두께)',
    searchPlaceholder: '검색 보드 이름 / 보드 번호',
    checkArranged: '조판 보기',
    checkErr: '조판이 진행되지 않아 볼 수 없습니다!',
    downloadSheet: '샘플 테이블 다운로드',
    downloadSheetShowScientific: '샘플 테이블 다운로드 (과학 계수법 보여주기)',
    exportHoleSlotPDF: '보드 부품 구멍 슬롯 다이어그램 내보내기',
    style1: '스타일 1',
    style2: '스타일 2',
    style2PDF: '스타일 2 (PDF)',
    style2DXF: '스타일 2 (DXF)',
    style3: '스타일 3',
    importNoCover: '원단 가져오기는 덮어쓰지 않음',
    openBujianPlankRecommend: '패치 보드 오픈 추천',
    openAwaitStorePlankRecommend: '보류 중인 라이브러리 보드 추천 열기',
    openSurplusPlankRecommend: '여분 대판 오픈 추천',
    pushToAwaitStore: '예약된 라이브러리에 저장',
    setTableHead: '커팅 리스트 헤더 설정',
    syncConfirm: '캐비닛과 클라우드 레이아웃 원본 데이터가 일치하지 않습니다!캐비닛 원본 데이터로 동기화합니까?',
    handleSync: '참고: 원본 관리에서 수동 동기화 가능',
    noMoreTip: '더 이상 프롬프트 없음',
    checkMore: '자세히 보기',
    noHistory: '보존 내역 없음...',
    sameOrder: '내보낸 프로덕션 파일에 대한 주문이 있습니다. 반복 프로덕션 문제에 주의하십시오.',
    markOrder: '주문 페이지에 생산됨을 표시하시겠습니까?',
    editErrTip: '다중 주문은 정보 수정을 지원하지 않습니다.',
    autoSaveSuccess: '자동으로 역사에 저장되었습니다!',
    goAdd: '추가로 이동',
    noProductionLine: '기록된 생산 라인이 삭제되었으므로 커팅 리스트 재배열로 이동하십시오.',
    fileErr: '파일 내용을 처리하지 못했습니다. 파일 내용을 확인하십시오!',
    noCheckData: '데이터가 검색되지 않았습니다!',
    noArrangeTip: '조판 방안을 직접 볼 수 없습니다. 조판 시작을 클릭하세요!',
    tooOld: '5, 6면 드릴이 너무 오래 설치되었습니다.',
    contactUs: '판매 후 담당자에게 연락하여 다시 도킹하십시오.',
    pathErr: '보드 내부에 비정상 데이터가 있습니다 (보드 번호: {errorPathPlankID}). 확인하세요!',
    sizeErr: '너무 큰 보드가 있습니다! 작은 보드 크기: {width}-{height}',
    noKnife: '원단 공구 지름이 설정되지 않았습니다. 조각기로 가서 공구를 설정하십시오!',
    noKnifeDiameter: '생산 라인 재료 공구 ({name}) 지름이 비어 있습니다. 해당 재료 공구 지름을 추가하세요',
    openDifferentMaterialCuttingKnives: '다른 재료의 재료 공구가 열렸습니다',
    sendFactorySuccess: '작업장으로 전송 성공',
    sendFactoryErr: '작업장을 보내는 데 실패했습니다. 영업 담당자에게 문의하여 도움을 요청하십시오.',
    createTaskCard: '해당 작업 카드를 만드시겠습니까?',
    surplusStatistics: '사용 가능한 여분',
    surplusStatistics2: '선택됨',
    suplementStatistic: '블록 보수, 보수 판과 함께 사용할 수 있습니다',
    expand: '펼치다',
    packUp: '집어치우다',
    importErr: '올바른 파일을 선택하십시오!',
    sendLoadingText: 'NC 파일을 처리하고 보내는 중......',
    arrangeLoading: '총계',
    arrangeLoading2: '장소판은 조판을 최적화하는 중이다......',
    dealing: '처리 중입니다...',
    deleteConfirm: '삭제 후 남은 자재는 휴지통으로 이동됩니다. 이 자재를 정말 삭제하시겠습니까?',
    copyTip: '선택한 나머지 항목에 대한 복제 작업 진행 중',
    copyTip2: '복제할 수량을 확인하십시오.',
    surplusHead: {
      shape: '모양',
      type: '유형',
      remark: '비고',
      area: '면적(m²)',
      area1: '면적'
      },
    surplusTip: '잠시 쓸만한 여분이 없으니, 당신은 먼저 가셔도 됩니다.',
    creatSurplus: '새 잉여 재료',
    orderInfo: '주문 정보',
    suplement: {
      statistic: '총 {total} 개의 보수 판, {useable} 개의 보수 판을 포함할 수 있으며, {selected} 개의 판이 선택되었습니다.',
      exportSuplement: '패치 목록 내보내기',
      suplementLoading: '패치 데이터 로드 중',
      exportSuplementIng: '패치 목록 내보내기 중',
      noMatchSup: '사용 가능한 패치 데이터와 일치하지 않음',
      exportTip: '하나 이상의 패치를 선택한 다음 내보내기'
      },
    empty: '보드 데이터 없음',
    paibanSetting: {
      title: '조판 설정',
      createTask: '조판 작업 생성',
      selectProduction: '생산라인 선택',
      arrangeWay: '레이아웃 옵션',
      suitText: '적용 가능한：',
      surplusTrimTip: '참고: 남은 재료의 사용자 정의 모서리 수정 기능을 사용하여 조판 톱질만 선택할 수 있습니다.',
      suitEquipmentNormal: '일반 조각기',
      suitEquipmentSpecial: '유리 절단기, 톱날 절단기',
      lessRoll: '적게 복제하다',
      computedSpecial: '이형을 계산하다',
      specialTip: '조판 속도에 영향을 주다',
      irregularNesting: '이형 중첩',
      primaryNesting: '일반 중첩',
      specialShapedPanel: '이형감 일반판',
      limitedTimeTrial: 'Limited Free',
      seniorShape: '고급 중첩',
      heteromorphicInlay: '이형감이형',
      autoCutSurplus: '남은 재료는 자동으로 재단한다.',
      cutWay: '재단 방식',
      maxRect: '최대 사각형으로 자르기',
      fixedRect: '고정 치수로 자르기',
      minRectSetting: '최소 크기 자르기',
      firstCutL: '자르기 우선 L형 여분 생성',
      firstCutLTip: '오픈 후 우선 조건을 만족하는 직사각형 판의 조합을 L자형 여분으로 재단합니다',
      shortLine: '짧은 모서리가 보다 큽니다.',
      longLine: '긴 모서리가 보다 큽니다.',
      setDifferentThickness: '다른 두께의 판재 최소 트림 크기 설정하기',
      defaultRuleTip: '보드 두께에 명중 규칙이 없는 경우 기본 규칙에 따라 자르기',
      panelThickness: '판자 두께',
      duplicateMinCutSize: '현재 두께에 최소 트림 치수가 동일합니다.',
      templateEmpty: '"다른 두께의 보드 최소 트림 크기 설정" 템플릿 데이터는 비워둘 수 없습니다.',
      duplicateThicknessData: '"다양한 두께의 보드 최소 트림 크기 설정" 템플릿 데이터에 중복된 두께 데이터가 있습니다.',
      atLeastOne: '하나 이상 유지!',
      maxAddFive: '최대 5개 추가!',
      surplusTemplate: '여분 재료 상용 템플릿',
      add: '추가',
      templateErr: '자르기를 일반 크기로 선택하려면 데이터 템플릿을 하나 이상 선택해야 합니다.',
      cutLong: '길이 자르기',
      cutWidth: '트림 폭',
      baseInfo: '기본 정보',
      continue: '확인 및 계속',
      standardSelect: '표준 보드 선택',
      customPlankOrder: '대판 조판 순서 사용자 정의',
      customPlankOrderDetail: '소판 목록 없음',
      customPlankOrderTip: '내장 클라우드 레이아웃은 이 기능에 적용되지 않습니다.',
      customPlankOrderBrandTip: '조판 대기 주문에 브랜드 색상 카드 보드가 있어 이 기능이 기본으로 사용됩니다',
      surplusPlank: '남은 슬레이트 목록',
      overSizePlank: '하이퍼스케일 인벤토리',
      plankOrder: '조판 순서',
      plankType: '판재 유형',
      plankSize: '판재 크기',
      plankEdgeOff: '모서리 값 수정하기',
      amount: '공급 수량',
      amountMax: '공급 수량이 가장 크다.',
      numAndOverSizeTip: '소판 초척이 존재하고 대판 사용량이 부족하여 조판할 수 없다',
      numErrorTip: '널빤지 용량이 부족하여 조판할 수 없다',
      overSizeTip: '소판 초자가 존재하여 조판할 수 없습니다',
      restPartList: '소판 목록 없음',
      layoutOrder: '조판 순서',
      arrangeAmount: '공급 수량',
      specialShapeTip: '이형 여분 재료는 톱으로 조판을 잘라서는 안 된다.',
      surplusConflictTip: '나머지 재료 자르기가 보드 아웃라인과 충돌합니다. 다시 자르십시오.',
      stackingMethod: {
        title: '레이아웃 쌓기 방법',
        long: '긴 변을 따라 레이아웃',
        short: '짧은 변을 따라 레이아웃'
        },
      seniorShapeTip: '【고급 중첩】무료 평가판 기간이 만료되었습니다. 레이아웃 결과를 미리 확인할 수 있습니다. (일반 중첩으로 전환하여 정상 생산을 진행할 수 있습니다.) 고급 중첩 생산 파일을 내보내려면 판매 담당자에게 문의하세요.~'
      },
    filter: {
      title: '보드 필터링',
      search: '검색',
      all: '모두 선택',
      diskSize: '레이아웃 기록 데이터 공간이 이미 사용되었습니다.',
      resetFilter: '필터링 해제'
      },
    edit: {
      title: '대량 수정',
      target: '객체 수정',
      onlineSelectRow: '행만 선택',
      allRow: '모든 행',
      editKey: '컨텐트 수정 필요',
      editValue: '다음으로 수정',
      warningTip: '참고: 수정하면 구멍 슬롯 및 이형이 자동으로 지워집니다.',
      allEdge: '모서리 모두 닫기'
      },
    add: {
      title: '보드 추가',
      continue: '확인 및 계속',
      matCodeErr: '재료는 비워둘 수 없습니다.',
      thickErr: '두께는 비워둘 수 없습니다.',
      colorErr: '색상은 비워둘 수 없습니다.',
      longErr: '최종 품목 길이는 비워둘 수 없습니다.',
      widthErr: '최종 품목 너비는 비워둘 수 없습니다.',
      countErr: '최소 1 개'
      },
    delete: {
      tip: '데이터를 삭제한 후 복구할 수 없습니다. 삭제하시겠습니까?',
      errTip: '이 작업을 수행하려면 먼저 하나 이상의 보드를 선택하십시오.',
      errTip1: '하나 이상의 보드를 선택한 다음 레이아웃하십시오.',
      confirm: '삭제 확인'
      },
    restore: {
      confirm: '복원 확인'
      },
    restoreConfirm: '복원 후 남은 자재는 남은 자재 목록이나 창고로 이동됩니다. 이 자재를 정말 복원하시겠습니까?',
    restoreBatchConfirm: '선택한 남은 자재를 복원하시겠습니까?',
    save: {
      errTip: '저장할 정보가 없습니다!',
      title: '스키마 저장',
      subTitle: '(참고: 기록은 1년만 저장됨)',
      name: '스키마 이름',
      historyName: '히스토리 시나리오',
      successTip: '저장 성공!',
      fieldTip: '저장 실패!'
      },
    exportErr: '판넬 없음, 내보낼 수 없음',
    exportPicErr: '보드 구멍 슬롯 다이어그램을 내보내는 중 알 수 없는 오류가 발생했습니다. 해결 방법을 문의하십시오.',
    plankNotFound: '관련 보드가 검색되지 않았습니다!판넬을 그릴지 확인하세요!',
    noPlankName: '보드 이름을 찾을 수 없습니다.',
    plankDataErr: '판넬 데이터 오류, 생산 손실을 방지하기 위해 자세히 확인하십시오.',
    exportThreeViewErr: '구멍 슬롯 3개 뷰를 내보내지 못했습니다. 사후 처리에 문의하십시오.',
    heighGlossWarning: '참고: 재료가 고광판인 경우 재료를 수정한 후 판재를 고광판으로 복원할 수 없습니다!',
    reset: '기본 복원',
    settingHead: {
      title: '커팅 리스트 헤더 설정',
      head: '표두',
      customHeadName: '사용자 지정 머리글 이름',
      example: '예제',
      tip: '작업 팁: 머리글 데이터 레이블 위치를 좌우로 드래그할 수 있습니다.',
      headerNameEmpty: '머리글은 비워둘 수 없습니다',
      duplicateHeader: '중복된 머리글입니다'
      },
    copyLine: '현재 줄을 복사하려면 누르십시오',
    copySuccess: '{name} 데이터 복사 성공',
    arranging: '{count} 장의 작은 보드가 조판을 최적화하는 중입니다...',
    overSize: {
      title: '판재 초척',
      subTitle: '하이퍼스케일 인벤토리',
      overSizeTip: '보드 하이퍼바이트 힌트',
      nonWorkInfo: '가공할 수 없는 플레이트 상세 정보',
      mergeFrameDoorWholeTip: '주의: 이 부품은 프레임 도어 병합 처리의 전체입니다',
      conflictWorkInfo: '충돌하는 보드 상세 정보',
      warning: '판자 크기가 너무 긴 것이 감지되어 조판이 불가능합니다!보드 크기를 조정하거나 해당 크기 원본을 추가하십시오.',
      checkInfo: '보드 상세 정보 보기',
      tipContent: '시스템은 조판 소판에 초척 판재가 존재하는 것을 검사했다. 아래는 특수 판재 첨가 건의이다. 판재 길이와 폭을 수동으로 수정한 후 표 아래의 <span class="bold color-0">"원클릭 추가"</span> 버튼을 클릭하여 빠르게 추가한 후 계속 조판하거나 <span class="bold color-0"> 원판 설정-특수 판재 <span> 수동으로',
      add: '클릭 한 번으로 추가',
      addPlank: '원본 추가',
      error: '판자 초과, 조판 실패',
      successTip: '보드 추가 성공!재레이아웃 중',
      warningTip: '판본의 너비를 기입해 주십시오!'
      },
    arrangeErr: '판넬 내부 데이터에 이상이 있어 조판 생산을 진행할 수 없습니다',
    nonDelete: '삭제 불가능',
    addOverSizeTip: '하이퍼바이트가 있습니다. 다시 추가하십시오.',
    addPlankSuccess: '특수 대판 추가 성공',
    addPlankFail: '특수 대시보드 추가 실패',
    paibanFeedback: '조판 피드백',
    cuttingAndPaoban: '주판을 절단하다',
    lowUtilizationRate: '활용도가 낮음',
    unreasonableLayout: '조판이 불합리하다.',
    feedbackSuccessTip: '피드백 성공!',
    feedbackFailTip: '피드백 실패!',
    mixedLayoutScheme: '이번 혼합 배열 방안'
    },
  arrangedPage: {
    subtleDownloadCheckTip: '보드 데이터가 변경되었지만 스키마를 저장하지 않았습니다. 스키마 확인 을 클릭한 다음 다음 작업을 수행하십시오.',
    paibanRequestFailed: '배치 요청이 실패했습니다. 다시 시도해 주세요',
    accordingPlankCountOrder: '높은 보드에서 낮은 보드로 정렬',
    editOrder: '일련번호 편집',
    dragOrder: '드래그 정렬',
    inputOrder: '입력 순서',
    editOrderTip: '순서 조정',
    range: '범위',
    unsupportRotateTip: '대판 일부가 회전되어 재레이아웃이 지원되지 않습니다. 대판 일련 번호가 회전되었습니다.',
    slotErrTip: '현재 플레이트에는 가장자리를 붙여 가공한 슬롯이 있으며 재배열은 지원되지 않습니다!',
    lockedPaibanTip: '대판이 잠겨서 다시 조판할 수 없습니다',
    batchBujianErrTip: '현재 플레이트 부품은 원본 원본 원본 데이터에 존재하지 않으므로 패치 / 릴리스 대기 라이브러리에서 재레이아웃을 선택할 수 있습니다.',
    useFolderIsNot: '파일 다운로드 저장 위치 "{type}"가 존재하지 않습니다! 파일이 삭제되었는지 확인하세요. USB 드라이브를 사용하는 경우 USB 드라이브가 제대로 연결되어 있는지 확인하세요',
    useFolderIsNot1: '파일 다운로드 위치를 설정하지 않은 것을 감지했습니다. 먼저 디렉터리를 선택하십시오.',
    downloadNC: 'NC 다운로드',
    downloadNC1: 'NC 파일 다운로드',
    reArrange: '재조판',
    reArrangeSpecifiedMaterialGroup: '지정된 패널 그룹 재조판',
    specifiedMaterialRelayoutMoreResultTip: '지정된 패널 그룹을 다시 배치한 후에는 더 이상 추가 배치 결과가 제공되지 않습니다',
    searchMaterialGroup: '패널 그룹 검색',
    saveToHistory: '역사에 저장',
    moreSetting: '더',
    cutIndexRe: 'ctrl+z 키를 사용하여 이전 작업을 취소하십시오',
    followExportTag: 'NC 스트립 내보내기 레이블 파일 다운로드',
    followExportPaibanImg: 'NC 스트립 내보내기 레이아웃 파일 다운로드',
    followExportWorkerShop: 'NC 온보드 내보내기 요청서 다운로드',
    tagTemplateSelect: '태그 템플릿 선택',
    showCuttingSequence: '가공 순서 표시하기',
    showPlankSize: '보드 크기 표시',
    sendToFactory: {
      title: '작업장으로 보내다',
      fileType: '태그 파일 유형'
      },
    checkData: '데이터 무결성을 확인하는 중입니다...',
    dataLoading: '로드하려고 노력 중입니다......',
    addToBujianStore: '진일보물 창고를 추가하는 중입니다...',
    updateTaskStatus: '작업 상태를 업데이트하는 중입니다...',
    sending: '작업장으로 보내는 중',
    waitLoadding: '기다림',
    loadding: '진행 중',
    finish: '완료',
    loadSetting: '로드 설정',
    loadPreference: '로드 환경 설정',
    dealTemplate: '템플릿 작업',
    initTagData: '레이블 데이터 초기화',
    prepareDrawData: '레이블 드로잉 데이터 준비',
    drawDataText: '레이블 드로잉 데이터',
    genPdfTagFile: 'PDF 태그 파일 생성하기',
    genPicTagFile: '태그 그림 파일 생성',
    uploadFile: '파일 업로드',
    dealNCFile: 'NC 파일 작업',
    zipFile: '로컬 압축 파일 생성',
    plankCount: '대판 수량',
    rollCount: '리메이크 횟수',
    totalRate: '전체 최적화율',
    rate: '최적화율',
    useArea: '최적화된 영역',
    materialList: '재료 명세서',
    saveSurplus: '남은 재료를 입고하다.',
    workeShop: '구매서',
    batchTagging: '대량 태그 보정',
    batchTaggingTip: '아래에서 레이블을 추가할 보드를 선택하십시오.',
    holeSlotErr: '플레이트 부품에 구멍 슬롯 깊이 예외가 발견되었습니다!',
    knivesErr: '판넬에서 가공 공구를 찾을 수 없음이 감지되었습니다!',
    checkDetail: '자세히 보기',
    deepErr: {
      title: '판자 구멍 슬롯 깊이 예외',
      errStatistic: '{count} 개의 보수 판에 예외가 발생했습니다',
      errText: '예외 부분',
      markErrPart: '예외 부분 상자'
      },
    warningTip: '양면 가공된 고광판: <span class="font-style"> 고광면 </span>을 먼저 가공하고 <span class="font-style"> 무광면 </span>을 가공한다.단면 가공의 고광판: 직접 가공 <span class="font-style"> 무광면 </span>',
    showDetail: {
      tip1: '클릭하여 개별 보드 선택',
      tip2: '보드 레이블 보기'
      },
    arrangeTip: '(이형 네스트된 레이아웃은 지원됨)',
    plankOpration: '보드 작업',
    rotate: '90도 회전',
    notCare: '판넬 텍스쳐 없음',
    editRemark: '편집 메모',
    clearRemark: '메모 비우기',
    recalcIndex: '다음 가공점 및 가공 순서 다시 계산하기',
    recalcIndexSuccess: '다음 공구 점 및 가공 순서 계산 성공',
    storageArea: {
      title: '보드 부품 임시 저장 영역',
      empty: '보드 없음 임시 저장',
      storageTip: '슬레이트 보관을 위해 슬레이트를 여기로 끌 수 있습니다.'
      },
    subtleArrange: '세밀한 조판',
    addPlank: '대시보드 추가',
    deletePlank: '보드 삭제',
    deletePlankErr: '현재 대판에 소판이 존재하므로 대판을 삭제할 수 없습니다!',
    useSurplus: {
      title: '남은 재료를 사용하다'
      },
    dragWarning: '대시보드로 드래그하십시오.',
    areaWarning: '플레이트를 배치할 수 없습니다. 여유 공간 크기에 유의하십시오.',
    subtlePage: {
      cut: '여분 재단',
      lineTip: '수동 절단이 잘못된 경우 ctrl+z를 사용하여 이전 절단 지점으로 돌아갈 수 있습니다',
      cancelCut: '자르기 종료',
      cutPoint: '남은 재료 재단 흡착점',
      storageArea: '플레이트 부품 대기열 플레이트 영역',
      cutErr: '큰 판자에서만 절단할 수 있고 작은 판을 건드려서는 안 된다!',
      saveErr: '먼저 재단할 여분의 재료를 선택하십시오.',
      cutErr2: '널빤지에서만 절단할 수 있고, 널빤지를 초과해서는 안 된다!',
      selectTip: '자른 나머지 원단을 선택하십시오.',
      noCutPath: '이형 부분은 직사각형을 자를 수 없다',
      cutOperate: '여분 재료 재단 작업',
      line: '수동으로 모서리 그리기',
      cutErrtip: '자르기 지점의 교차 문제가 있습니다. 다시 자르십시오.',
      cutErrtip2: '자르기 위치 제한 초과: 9, 다시 자르십시오.'
      },
    shortCut: '단축키',
    updownRoll: '위아래로 미끄러지다',
    leftRightRoll: '좌우 슬라이딩',
    zoomScale: '확대 축소',
    dragCanvas: '페이지 드래그',
    mouseRoll: '마우스 휠',
    mouseRight: '마우스 오른쪽 버튼',
    mouseMultiSelect: '보드 파트를 여러 개 선택',
    mouseLeft: '마우스 왼쪽 버튼',
    doublePlank: '보드를 두 번 클릭합니다.',
    keyboard: '키보드',
    picSymble: '범례',
    funished: '최종 품목',
    holeSlotConflict1: '구멍 슬롯 충돌',
    plankErr: '보드 충돌',
    frontSlot: '정면 슬롯',
    backSlot: '후면 당김 슬롯',
    frontHole: '전면 구멍 비트',
    backHole: '후면 구멍 비트',
    resetScale: '줌 재설정',
    maxLong: '최장',
    tempErr: '추가에 실패했습니다. 템플릿 위치가 잘못되었거나 너무 큽니다!',
    sendErr: '작업장을 보내는 데 실패했습니다. 레이블 템플릿과 보드 데이터가 올바른지 확인한 후 다시 보내십시오.',
    someTips: '클라우드 레이아웃 이형 여분 / 이형 중첩 기능을 한시적으로 시험해 보고 있습니다. 생산 문제를 피하십시오.',
    nestingTips: '[고급 이형 중첩 레이아웃] 기능의 한시 무료 체험이 만료되었습니다. 계속 사용하려면 영업 담당자에게 문의하여 구매해 주세요!',
    frameDoorTip: '이 레이아웃에는 병합된 프레임 문이 있음을 감지했습니다. 프레임 문은 재처리 전에 폐쇄되어야 합니다!',
    cutOrderErr: '절단 순서가 정확하지 않습니다. 클릭하여 칼점과 절단 순서를 다시 계산하세요!',
    holeSlotConflict: '보드 부품에 구멍 슬롯 충돌 / 플라이아웃 감지',
    exportSetting: '내보내기 설정',
    currentTagTemp: '현재 태그 템플릿',
    specialPaibanErr: '특수 프로세스 또는 테두리 가공 슬롯이 있는 보드 부품은 재레이아웃이 일시적으로 지원되지 않습니다!',
    moreResult: '더 많은 결과',
    moreResultTip: '판자에 가장자리를 붙여 가공한 슬롯이 있어, 판자는 재조판에 참여하지 않을 것이다',
    batchBujian: '대량 패치',
    batchOperation: '대량 작업',
    batchEditPlankSize: '대시보드 크기 대량 수정',
    editPlankSize: '치수 수정',
    editWay: '수정 방법',
    editByType: '유형별 수정',
    editByPlankNumber: '대판 번호로 수정',
    editContent: '컨텐트 수정',
    editContentTip: '수정할 보드 유형을 선택하십시오.',
    editContentTip1: '수정할 보드 번호를 선택하십시오.',
    editStart: '시작',
    editEnd: '결말',
    bigPlank: '판자',
    editSize: '치수 수정',
    bigPlankWidth: '널빤지 너비',
    bigPlankHeight: '판자 길이',
    bigPlankLengthMarking: '대판 길이 표식',
    markedAs: '으로 식별',
    maxAddTen: '최대 10개 추가',
    minValue: '최소값',
    differentKnifeErr: '다른 언더레이가 있는 보드가 선택되어 치수를 수정할 수 없습니다.',
    noEditablePlank: '수정할 수 있는 조건에 맞는 대형 보드가 없습니다',
    skipBrandPlankTip: '선택한 범위에 크기 수정을 지원하지 않는 브랜드 대형 보드가 {count}개 있어 건너뛰었습니다',
    nonBrandToBrandTip: '이 작은 보드는 브랜드 색상 카드 대형 보드로 드래그할 수 없습니다!',
    brandToNonBrandTip: '이 작은 보드는 비브랜드 색상 카드 대형 보드로 드래그할 수 없습니다!',
    brandToOtherBrandTip: '이 작은 보드는 다른 브랜드 색상 카드 대형 보드로 드래그할 수 없습니다!',
    editNo: '호',
    editAllPlank: '모든 보드',
    editBigPartSize: '대시보드 크기 수정',
    disPlaySetting: '디스플레이 설정',
    stored: '입고 완료',
    onlySurplus: '남은 재료만 보다.',
    UnuseSurplus: '남은 재료는 이용률 계산에 참여하지 않는다',
    usePlankAdsorption: '판재 흡착 기능',
    dataDefaultCollapsed: '데이터 기본 축소',
    unit: '덩어리',
    cutSurplus: '남은 재료를 썰다',
    frontWarningTip: '양면 가공된 고광판: <span class="font-style"> 무광면 </span>을 먼저 가공한 다음 <span class="font-style"> 고광면 </span> <span>을 가공한다. &nbsp;단면 가공을 위한 고광판: 직접 가공 </span <span class="font-style"> 고광면 </span>',
    selectTip: '아래에서 패치가 필요한 보드를 선택하십시오!',
    plankKeyWordPlaceholder: '보드 이름 또는 보드 번호를 입력하십시오.',
    surplusStoreSuccess: '입고 성공',
    editCutOrder: '가공 순서 수정하기',
    setCutPoint: '다음 공구 점 설정하기',
    specialPaibanChangeErr: '특수 공정 또는 모서리를 붙여 가공한 슬롯이 있는 판재는 조판 스키마 전환이 일시적으로 지원되지 않습니다!',
    storedSuccess: '패치 성공!선택된 위젯은 이미 위젯 관리에 넣었습니다!',
    noSurplus: '사용 가능한 여분의 재료가 질의되지 않았습니다.',
    selectErrTip: '남은 원판 부품은 보충할 수 없습니다. 먼저 일반 소판을 선택하십시오.',
    noRoomIDTip: '이 보드에는 공간 ID가 없으므로 패치 입고 작업을 수행할 수 없습니다. 먼저 다른 보드를 선택하십시오.',
    noPlank: '보드를 찾을 수 없음',
    noPaibanData: '조판 데이터 없음, 진행 불가',
    historyNameErr: '스키마 이름을 입력하십시오.',
    tempErrTip: '5면 / 6면 드릴을 추가하지 않은 템플릿이 발견되어 5면 / 6면 드릴링 가공 파일을 내보낼 수 없습니다. 참고: 추가가 완료되면 다시 조판해야 합니다.',
    changeDataTip: '참고: 데이터가 변경되었음을 감지하여 새 히스토리 파일을 만들어 변경 내용을 저장하시겠습니까?',
    upgrade: '업그레이드',
    upgradeTip: ', 당신은 아래 단추를 클릭하여 버전을 업그레이드할 수 있습니다',
    plankOverEdge: 'NC 다운로드 실패!판재가 중첩되거나 판재가 큰 판 밖에 있는지 확인하십시오',
    useSurplusTip: '여분 감액 여부',
    noDataExport: '내보낼 수 있는 조판 데이터가 없습니다.',
    noPlankExport: '내보낼 수 있는 보드가 없습니다.',
    lockTip1: '클릭하여 잠금 해제, 잠금 해제 후 가능',
    lockTip2: '보드 위치 및 속성 편집',
    unlockTip1: '클릭하여 잠금 진행, 잠금 후 진행불가',
    unlockTip2: '보드 위치 및 속성 편집',
    plankLockErr: '대판이 잠겨 배치할 수 없습니다.',
    lockPartEditTip: '보드가 잠겨 편집할 수 없습니다.',
    glassEquipmentTip: '생산 라인이 유리 절단기일 때 판재를 이동할 수 없다',
    expandedTip: '슬롯을 당기는 특수 프로세스가 있는 보드 부품은 편집 작업을 지원하지 않습니다!',
    sameWidthPlankTip: '앤티앨리어싱이 켜져 있어 보드를 이동할 수 없음',
    expandedArrangeTip: '판재에는 슬롯을 당기는 특수 공예가 존재하므로 다시 조판해야 한다!',
    dragErrTip: '배치할 수 없습니다. 보드 재료, 색상 및 두께 속성을 확인하십시오!',
    subtleSaveTip: '현재 대시보드에 대해 작업했지만 저장되지 않았습니다. 종료하시겠습니까?',
    rollTip: '널빤지에 구멍 / 슬롯이 있어 리메이크를 권장하지 않습니다!',
    glossRollErr: '고광판 뒤집기 금지.',
    lockDeleteErr: '보드가 잠겨서 삭제할 수 없습니다.',
    deleteConfirmTip: '삭제 작업을 복구할 수 없습니다.',
    deleteContinueTip: '계속 할 거야?',
    deleteConfirm: '삭제 여부를 확인하십시오.',
    selectPlankTip: '이 작업을 수행하려면 먼저 위젯을 선택하십시오.',
    storeFailTip: '남은 재료 입고 실패!판재가 중첩되거나 판재가 큰 판 밖에 있는지 확인하십시오',
    repeatStoreErr: '현재 트림된 나머지 원단은 이미 입고되었다',
    surplusStoreFail: '입고 실패. 보드가 직사각형 또는 L 보드인지 확인하십시오!',
    plankConfilictErr: '여기에 점을 배치하는 것은 지원되지 않으며 다른 보드와 충돌할 수 있습니다.',
    surplusErrTip: '여기에 지점을 배치하는 것은 지원되지 않으며 오류가 발생할 수 있습니다.',
    changeArrageSuccess: '레이아웃 스키마를 성공적으로 전환했습니다.',
    trialProduction: {
      trialProductionSample: '시제품 견본함',
      trialProduced: '나는 이미 시험 생산을 했다',
      trialWarning: '{fontStyleStart}만약{fontStyleEnd} 견본 캐비닛의 생산 검증을 하지 않았기 때문에 자신, 타인 및 클라우드 조판 소프트웨어에 대한 모든 손실과 불리한 결과는 귀하 개인이 모든 책임을 집니다.',
      trialSlotTip: '프로덕션 시 정반대면 슬롯의 크기, 깊이, 면 및 위치가 올바른지 확인합니다',
      trialSlotTip1: '캐비닛 미러링 방지',
      trialSlotTip2: '의 문제',
      pleaseUploadTrial: '조립된 시제품 견본함 사진 올려주세요.',
      uploadTrial: '샘플 캐비닛 업로드'
      },
    awaitPlankStore: {
      store: '판재 대기열 판고',
      notTip: '입고되지 않았다는 메시지가 표시되지 않음',
      justLookCurrent: '현재 주문 보드만 보기',
      notInPushStorage: '입고되지 않음',
      beInStorage: '입고 완료',
      searchPlaceholder: '주문을 입력하여 예약된 라이브러리 보드를 검색합니다.',
      plankUploading: '보드 저장 중',
      oneClickStorage: '클릭 한 번으로 대기판 라이브러리에 저장',
      notUsePlank: '사용 가능한 슬레이트 없음',
      notPlank: '보드 없음 임시 저장',
      dragPlankInHere: '슬레이트 보관을 위해 슬레이트를 여기로 끌 수 있습니다.',
      surplusCannotBeStorage: '남은 재료는 입고할 수 없다.',
      plankHasBeenDeduction: '보드가 분리되었거나 원본 데이터가 존재하지 않아 입고할 수 없음',
      plankLoadErr: '보드 정보 로드 실패',
      taskTitle: '보류 중인 라이브러리 내 보드 업로드',
      dataGenErr: '데이터 생성 오류',
      pushSuccess: '입고 성공',
      pushErr: '알 수 없는 오류가 발생하여 입고 실패',
      awaitBoxExistPlank: '조판 재고가 아직 입고되지 않은 보드에 있으니, 입고된 후에 다시 조작하는 것이 좋습니다.',
      mergeFrameDoorWholeTip: '이 부품은 프레임 도어 병합 처리의 전체입니다, 저장 후 시스템은 자동으로 분해하여 개별 블록으로 관리합니다',
      checkPlankStatus: '보드 상태를 검사하는 중입니다...'
      },
    batchSetCut: '다음 공구 점 대량 설정',
    applyTo: '적용 가능한:',
    ncDownloadLifeText: {
      checkData: '데이터 테스트 중',
      checkDone: '데이터 테스트 완료',
      checkDataText: '데이터 검색',
      loadSetting: '설정 로드 중',
      settingLoadDone: '설정 로드 완료',
      loadSettingText: '로드 설정',
      downloadNc: 'NC 다운로드 중',
      ncDownloadDone: 'NC 다운로드 완료',
      downloadText: 'NC 다운로드',
      loadPreferenceSetting: '환경 설정을 로드하는 중',
      PreferenceSettingLoadDone: '환경 설정 로드 완료',
      loadPreferenceText: '로드 환경 설정',
      dealTemp: '템플릿 작업 중',
      TempDealDone: '템플릿 처리 완료',
      dealTempText: '템플릿 작업',
      beBeingGenTagFile: '{fileType} 파일 생성 중',
      genTagFileDone: '{fileType} 파일 생성 완료',
      genTagFileText: '{fileType} 파일 생성',
      zip: '로컬 압축 파일 생성 중',
      zipDone: '로컬 압축 파일 생성 완료',
      genZipText: '압축 파일 생성',
      fileTypeText: '사진'
      },
    surplusCommonTemp: '여분 재료 상용 템플릿',
    plankErrTip: '현재 재료 사용 방안에 작은 판이 존재하여 큰 판으로 조판할 수 없습니다!',
    brandPlankErrTip: '현재 재료 계획에 사용할 수 있는 브랜드 대판이 없는 브랜드 소판이 있습니다!',
    overSizeTip: '대판 수량이 부족하거나 초과자',
    uselessPart: '현재 보드에 사용 가능한 보드가 없습니다. 다시 배치해 주세요.',
    splitArranged: '널빤지의 수량이 너무 많으니, 다시 조판하거나 차수로 나누어 조판하는 것을 건의합니다.',
    arrangedErrTip: '조판 실패, 대판 수량 부족 또는 소판 초자 존재',
    knivesModalTitle: '구멍 슬롯이 있어 공구를 찾을 수 없습니다.',
    cannotDownloadByKnivesErr: '다음 구멍 슬롯에서 공구를 찾을 수 없음을 감지한 NC를 다운로드할 수 없습니다.',
    viewPart: '문제 보드 보기',
    deductionModalTitle: '공제 객체를 선택하십시오.',
    bujianDeduction: '패치 소판',
    paibanDeduction: '잠금 영역 슬레이트 공제',
    surplusDeduction: '남은 재료의 널빤지를 깎다',
    unlockPaiban: '조판에 참여한 나머지 재료의 잠금을 해제하다',
    maintain: '조판에 참여한 나머지 재료의 잠금을 유지하다',
    lockModalText: '사용 잔재 대판이 다른 주문서에 의해 점용되고 있는데, 재조판 여부',
    lockNewSModalText: '현재 사용된 여분의 대판이 다른 주문에 의해 점용되고 있습니다. NC 다운로드 지속 여부',
    rePaibanWarn: '나머지 대판은 기타 주문서에 점용되어 사용 가능한 대판이 부족하니, 개료 명세서에 가서 다시 조판하십시오.',
    sawRePaiban: '참고: 앤티앨리어싱을 사용하며 NC 파일을 내보내려면 레이아웃을 다시 작성해야 하는 이형 플레이트 레이아웃이 추가되었습니다.',
    togglePlankTip: '판재 부품에 슬롯 당기기 특수 공정이 존재하므로 정면과 후면 전환 작업을 지원하지 않습니다!',
    stepCuttingMsg: '계층형 컷 깊이는 보드 두께보다 작아야 합니다.',
    stepCuttingMsg2: '계층형 컷 깊이는 0보다 큰 숫자만 입력할 수 있습니다.',
    flipPlankTip: '구멍 슬롯 분류 원료 공급기 가공 단일 패널이 열렸습니다. 판을 뒤집는 작업은 허용되지 않습니다!',
    genNoCutTagNotSupportExportPic: '원판 부품 태그 생성이 켜져 있으며 그림 내보내기가 지원되지 않음',
    allSmallPlanksAreNoCutNotInLayout: '현재 소판은 모두 재료를 넣지 않고 조판에 참여하지 않는다',
    canStillExportHoleSlotOrPrintTag: '구멍 슬롯 가공 파일을 내보내거나 레이블을 인쇄할 수 있습니다.',
    desMaterialNoCutNotSupportSwitchLine: '현재 생산라인이 이미 열려 있어 지정된 슬레이트 재료가 원료를 공급하지 않으며, 직접 생산라인 전환은 잠시 지원되지 않습니다.',
    desMaterialNoCutSettingChanged: '지정한 슬래브 재료의 재료가 들어가지 않는 설정이 수정된 것을 감지했습니다. 정확한 생산을 위해 재조판하십시오.',
    continueDownload: '다운로드 계속',
    desMaterialNoCutErrorTip: '조각기 머시닝에 할당된 슬롯 / 이형이 슬롯 재료에 재료가 들어가지 않는 슬롯 / 이형에 있음을 지정합니다. 이번 다운로드 슬롯 / 이형은 모두 5, 6면 드릴링에 할당됩니다. 파일 다운로드 지속 여부',
    clearReuseRelation: '재사용 관계를 해제하려면 클릭하세요',
    layoutReuseTip: '대판 레이아웃을 빠르게 복제하며, 판재 변경 시 재사용 관계가 자동 해제됩니다',
    hasBeenReused: '재사용됨',
    layoutReuse: '레이아웃 재사용',
    specialProcessNotSupported: '판재에 특수 공정이 있어 이 작업을 지원하지 않습니다',
    conflictNotSupported: '판재 충돌이 있어 이 작업을 지원하지 않습니다',
    noAvailablePlankForReuse: '재사용할 수 있는 판재가 없습니다',
    noMatchingPlankFound: '일치하는 판재를 찾을 수 없습니다',
    reuseBoard: '{number}번째 판재 재사용',
    influenceTip: {
      title: '최적화율에 영향을 주는 기능',
      empty: '없음',
      groupParams: '레이아웃 매개변수',
      surplusNoRoll: '잔재 미뒤집기',
      surplusCustomTrim: '개별 마감 값 설정',
      otherPlateCustomTrim: '특수 대판 개별 마감 값',
      knifeDiameter: '커터 지름',
      surplusNoFlip: '잔재 미뒤집기',
      surplusNotLayout: '잔재 대판은 지정된 판재를 배치하지 않습니다',
      plankEdgeOff: '마감',
      surplusCustomTrim2: '나머지 사용자 정의 가공',
      other: '영향을 받을 수 있는 기타 기능',
      enabled: '활성화됨',
      plankThicknessStacking: '두께 높이 배치',
      edgePreMilling: '끝면 예제 가공',
      multiMaterialCuttingBlade: '다중 재료 절단 도구',
      sawSpecialShapePart: '톱 절단 및 조각기의 특수 형상 노치 판재',
      longPlankCutting: '긴 판재 이차 가공'
      }
    },
  paibanImg: {
    title: '조판도 관리',
    exportCustomPaibanImg: '사용자 지정 배열도 내보내기',
    customPaibanImg: '사용자 지정 조판도',
    isCustomName: '사용자 지정 조판도 이름',
    template: '조판 템플릿',
    addTem: '템플릿 추가',
    canvasIndexSearch: '보드 번호 검색',
    symbol: '조판도 표식',
    frontSlot: '전면 슬롯',
    backSlot: '후면 슬롯',
    frontHole: '전면 구멍',
    backHole: '반면',
    printNum: '용지 한 장 인쇄 최대 전시',
    printUnit: '조판도 한 장',
    edit: '조판 템플릿 편집',
    temName: '템플릿 이름',
    rotate: '조판도 회전',
    showOverflow: '텍스트가 위젯을 넘을 때 식별선은 위젯 데이터를 보여줍니다.',
    showHoleSlot: '구멍 슬롯 정보 표시하기',
    bigPartCss: '대판 조판도 스타일 조정',
    partCss: '소판 조판도 스타일 조정',
    addTemTip: '최대 10개의 레이아웃 템플릿만 추가할 수 있습니다!',
    exportTip: '적어도 하나의 레이아웃 템플릿 내보내기를 선택하십시오.',
    editSaveTip: '필수 항목을 모두 기입한 후 저장하시기 바랍니다!',
    exportDXF: 'DXF 내보내기',
    exportDxfGeneral: '2D 일반 DXF',
    exportDxf3d: '3D 전용 DXF',
    exportDxfGeneralTip: '수동 가공, 도면을 보며 절단하거나 배치 결과를 확인하는 데 적합합니다',
    exportDxf3dTip: '타사 시스템으로 가져와 생산하는 데 적합하며 Huiya 레이저 절단 일체형 기계를 지원합니다'
    },
  historyPage: {
    matchErrBySpecialTip1: '다음 특수 보드에서 일치하는 항목을 찾을 수 없습니다. 조판 페이지를 다시 조판하는 데 문제가 있을 것입니다. 만약 이 역사가 혼합 배열을 사용했다면 이 힌트를 무시하십시오',
    specialPlankInfoErrTip2: '특수 대판 정보 획득 오류, 조판 페이지 재조판 기능에 영향',
    download: '로컬 다운로드',
    allType: '모두 저장',
    handleSave: '수동 저장',
    specialPlank: '특별한',
    surplusPlank: '여분',
    autoSave: '자동 저장',
    allArrange: '전체 조판',
    searchPlaceholder: '주문명 / 조판 배치 / 주문번호 검색',
    saveHistoryName: '저장 이력 이름',
    trailProduction: {
      title: '시제품 견본함',
      lastTime: '마지막 파일럿 날짜',
      recordList: '시험 생산 기록',
      start: '시험 생산을 시작하다',
      date: '시간',
      outputFrom: '출력 위치',
      empty: '데이터 없음',
      record: '업로드된 시제품 견본함 사진 기록',
      tip1: '참고: 현재 파일럿 주문은 기본 프로덕션 데이터를 사용합니다.',
      tip2: '참고: 현재 파일럿 주문은 최신 공정 설정 매개변수를 사용하는 것이 아니므로 파일럿 룸에서 다시 저장할 수 있습니다.',
      download: '가공 파일 다운로드'
      },
    deleteTip: '다음 히스토리를 삭제하시겠습니까?',
    startDate: '시작 날짜',
    endDate: '종료일',
    lastWeek: '최근 일주일',
    lastMonth: '최근 1월',
    lastSeason: '최근 3월',
    toArrangePage: '조판 페이지로 이동 중',
    notArrangedTip: '이 기록은 조판을 한 적이 없으니, 먼저 BOM으로 가십시오!',
    toMaterialPage: '커팅 리스트 페이지로 이동 중',
    lessSelectTip: '이 작업을 수행하려면 레코드를 하나 이상 선택하십시오.',
    downloadNc: '가공 파일 다운로드'
    },
  workShopPage: {
    warningTip: '이 기능은 한시적으로 시험적으로 사용할 수 있습니다. 주문 생산을 합리적으로 안배해 주십시오!',
    fileManager: '프로덕션 파일 관리',
    selected: '선택됨',
    suplement: '패치',
    size: '치수',
    saveToStore: '엔트리 웨어하우스 추가',
    enterArrange: '조판에 들어가고 있습니다...',
    deleteTip: '데이터를 삭제한 후 복구할 수 없습니다. 삭제하시겠습니까?',
    arrangeTip: '패치 데이터를 처리하는 중입니다. 잠시만 기다려 주십시오...',
    store: '보충 창고',
    downloadFile: '프로덕션 파일 다운로드',
    notBujianFile: '패치 파일을 찾을 수 없습니다.',
    productLineDelete: '생산 라인이 삭제되어 NC 파일을 다운로드할 수 없습니다!'
    },
  basePlankManager: {
    saveTip: '참고: 캐리지 리턴별로 저장',
    offsetSize: '모서리 치수 고치기',
    overSizeTip: '사이즈가 너무 크면, 자동으로 더 큰 사이즈 규격의 대판을 선택하여 조판한다.',
    addTip: '조판 시 판재가 초자를 초과하면, 튀어나와 자동으로 특수 대판 탄창을 추가합니다',
    defaultOversizePlankValue: '대판 특수 대판의 기본 추가 크기 설정',
    onlyLayoutTooBig: '초척 대판은 초척 소판만 배열한다',
    settingRemark: '참고: 원래 이 기능은 오른쪽 설정으로 조정됨',
    searchPlaceholder: '판재 재료 / 색상 검색',
    syncData: '캐비닛 데이터 동기화',
    syncDataM: '캐비닛 문 데이터 동기화',
    deletePlank: '특수 대시보드 삭제',
    addPlank: '특수 판재를 새로 짓다.',
    matCodePlaceholder: '판재를 선택하세요',
    thickPlaceHolder: '두께를 선택하십시오.',
    widthErr: '판재 너비는 비워둘 수 없습니다.',
    heightErr: '판재 길이는 비워둘 수 없습니다.',
    matCodeErr: '판재 재질은 비워둘 수 없습니다.',
    colorErr: '판재 색상은 비워둘 수 없습니다.',
    editPlank: '판재 편집',
    deleteTip: '데이터를 삭제한 후 복구할 수 없습니다. 삭제하시겠습니까?',
    plankKnifeSelect: '원판 재료 칼 선택',
    plankKnifeSelectTip: '판재가 여러 규칙에 명중할 때, 판재의 두께 우선순위는 판재 재질보다 크다',
    knifeSelectTip: '참고: 인라인 레이아웃은 이 기능을 지원하지 않습니다.',
    knife: '원단 공구',
    matcodeInput: '판재 재료를 입력하세요',
    thickInput: '판재 두께를 입력하세요',
    default: '시스템 기본',
    unessential: '이 열은 필수가 아닙니다.',
    emptyTip: '참고: 이 항목을 입력하지 않을 때 원본과 일치할 때 이 데이터를 구분하지 않습니다!',
    defaultUse: '기본 선택',
    editMatcode: '재료 편집',
    syncTip: '{fromMc}에서 데이터를 가져와 기존 클라우드 레이아웃의 원본 관리 데이터를 덮어쓰고 동기화할까요?',
    sameErr: '동일한 데이터가 이미 있음',
    cancelDelete: '삭제 취소됨',
    syncErr: '동기화 실패',
    syncSuccess: '동기화 성공',
    syncDataTip: '{fromMc} 데이터 동기화',
    editErrTip: '기입하지 않은 정보가 존재하니 확인하세요!',
    numberCheck: '{type}는 숫자만 입력할 수 있습니다!',
    deleteStandardPlate: '표준 판재 삭제',
    createStandardPlate: '새 표준 판재',
    editStandardPlate: '표준 판재 편집',
    trimmingDimension: '모서리 치수 고치기',
    front: '상',
    back: '아래',
    left: '왼쪽',
    right: '오른쪽',
    frontTrim: '가장자리를 고치다',
    backTrim: '테두리를 깎다',
    leftTrim: '왼쪽 모서리',
    rightTrim: '오른쪽 가장자리',
    customTrim: '모서리 수정 값 사용자 정의',
    trimValue: '모서리 값 수정하기',
    notEmpty: '{type}는 비어 있을 수 없습니다!',
    edgeDir: '모서리 수정 ({type})',
    brandPlank: '브랜드 대판',
    brandPlankTip: '참고: 브랜드 대판의 삭제 및 수정은 Cabinet 클라이언트 보드 리소스 라이브러리에서 진행됩니다',
    brand: '브랜드',
    supplier: '공급업체',
    brandPlaceholder: '브랜드를 선택하세요',
    supplierPlaceholder: '공급업체를 선택하세요',
    brandInput: '브랜드를 입력하세요',
    supplierInput: '공급업체를 입력하세요',
    addBrandPlank: '브랜드 대판 추가',
    deleteBrandPlank: '브랜드 대판 삭제',
    editBrandPlank: '브랜드 대판 편집',
    searchBrandPlaceholder: '브랜드/공급업체/재질/색상 검색'
    },
  bujianAndStore: {
    bujianStore: '보충 창고',
    awaitStore: '릴리즈 준비 라이브러리',
    depositAwaitStore: '예약된 라이브러리에 저장',
    pushToAwaitStore: '예약된 라이브러리에 넣기',
    useTwoTableArrange: '양식 레이아웃 2개 사용',
    confirmUseTwoTableTip: '현재 선택한 보드에 트위닝 라이브러리와 예약된 라이브러리가 포함되어 있습니다. 계속 정렬하시겠습니까?',
    confirmAddPlankToAwaitStore: '선택한 보드를 보류 중인 라이브러리에 추가하시겠습니까?',
    pushStoreSuccess: '입고 성공',
    dataGenErr: '데이터 생성 오류',
    unknownErr: '알 수 없는 오류가 발생하여 입고 실패'
    },
  surplusPage: {
    surplusMaterial: '남은 커팅 리스트',
    surplusStore: '잉여 재료 창고',
    recycleBin: '잉여 재료 창고',
    recycleBinTip: '여분 자재 데이터는 휴지통에 90일 이상 있으면 자동으로 삭제됩니다',
    "deleteReason-0": '수동 삭제',
    "deleteReason-1": '조판 공제',
    "deleteReason-2": 'Guigui 모바일 작업 출고',
    surplusShape: '여분 형태',
    batchTransfer: '대량 전송',
    createNewSurplusStore: '새 잉여 재료 창고',
    pushStoreSetting: '남은 재료 입고 설정',
    surplusStoreName: '남은 재료 창고 이름',
    surplusStoreName2: '남은 라이브러리 이름',
    addSurplusStore: '남은 재료 라이브러리 추가',
    inventoryCeiling: '재고 상한',
    autoTransferTip: '삭제 후 남은 저장소의 남은 재료는 자동으로 남은 재료로 이동됩니다.',
    asIndexPushStore: '창고 보관 상황 순서에 따라 입고하다.',
    pushToSurplusMaterial: '남은 커팅 리스트 저장',
    surplusStoreTable: {
      number: '번호',
      name: '남은 라이브러리 이름',
      quantity: '남은 재료 수량 (개)',
      capacity: '잔재 재고 상한선 (개)',
      rules: '잉여 재료 입고 규칙',
      remark: '비고',
      operation: '조작'
      },
    editSurplusStore: '남은 라이브러리 편집',
    addSurplus: '여분 을 첨가 하다',
    importSurplus: '남은 재료 가져오기',
    downloadSurplusTemplate: '남은 자료 가져오기 템플릿 다운로드',
    batchExportSurplus: '현재 남은 커팅 리스트 내보내기',
    surplusBatchImportExport: '남은 재료 대량 가져오기 내보내기',
    surplusMaterialStorageCode: '잔재 입고 코드',
    generateQRCodeSuccess: 'QR코드 생성 성공',
    generateQRCodeFailed: 'QR코드 생성 실패',
    refreshQRCode: 'QR코드 새로 고침',
    refreshQRCodeFailed: 'QR코드 새로 고침 실패',
    cancelRefresh: '새로 고침 취소됨',
    refreshQRCodeTip: 'QR코드를 새로 고칠지 여부, 새로 고침 후 현재 QR코드가 무효화됩니다.',
    refreshQRCodeConfirm: '확정',
    refreshQRCodeCancel: '취소',
    wechatScanTip: '위챗을 열고 코드를 스캔하면 수동으로 여분의 재료를 추가하여 입고하여 사용할 수 있다',
    deletSurplus: '남은 재료를 삭제하다.',
    editSurplus: '남은 재료 수정',
    surplusNoRoll: '남은 재료는 복제하지 않고 가공한다.',
    type: {
      all: '모든 모양'
      },
    allMatcode: '모든 재료',
    allThick: '전체 두께',
    surplusName: '나머지 재료 이름',
    rectSurplus: '직사각형 여분',
    LTypeSurplus: 'L형 여분',
    noMatchSup: '관련 데이터가 질의되지 않았습니다.',
    jumpTo: '다음으로 건너뛰기',
    page: '페이지',
    newMatcode: '새 재료',
    newColor: '새 색상',
    autoCreateColor: 'Enter 키를 누르면 색상 카드가 자동으로 생성됩니다.',
    nameLimit: '나머지 재료 이름 최대 10자 입력',
    nameLimitNameErr: '나머지 재료 이름은 비워둘 수 없습니다.',
    tempLongTip: '판재 길이는 숫자만 입력할 수 있습니다.',
    minLongLimit: '짧은 모서리 길이는 숫자만 입력할 수 있습니다.',
    minLongEmptyTip: '짧은 모서리 길이는 비워둘 수 없습니다.',
    minLongLimitMax: '짧은 모서리 길이는 판재 길이를 초과할 수 없다',
    widthLimit: '판재 너비는 숫자만 입력할 수 있다',
    minWidthLimit: '짧은 모서리 너비는 숫자만 입력할 수 있습니다.',
    minWidthEmptyLimit: '짧은 모서리 너비는 비워둘 수 없습니다.',
    minWidthLimitMax: '짧은 모서리 너비는 판재 너비를 초과할 수 없다',
    thickLimit: '판재 두께는 숫자만 입력할 수 있습니다.',
    thickEmptyLimit: '판재 두께는 비워둘 수 없다',
    countInputLimit: '수량은 양의 정수만 가능합니다.',
    countEmptyLimit: '수량은 비워둘 수 없습니다.',
    remarkMaxlimit: '메모 최대 50자 입력',
    orderAddressMaxlimit: '소스 주문 주소 최대 100자 입력',
    orderIdMaxlimit: '소스 주문 번호 최대 100자 입력',
    createTime: '시간 추가',
    deleteTime: '삭제 시간',
    deleteReason: '삭제 이유',
    branchName: '소재 여분 재료 창고',
    orderAddress: '소스 주문 주소',
    orderId: '소스 주문 번호',
    lockStatus: '잠금 상태',
    lockOrder: '주문 잠금',
    enableSurplusLock: '여분 잠금 사용',
    isCloseSurplusLock: '기능이 꺼지면 나머지 모든 재료의 잠금이 해제됩니다. 계속 진행하시겠습니까?',
    confirm: '종료 확인',
    surplusTransfer: '남은 재료 이동',
    targetSurplusStore: '목표 잉여 재료 창고',
    enableSurLockTip: '오픈 후, 매번 조판할 때마다 남은 재료를 잠그고, 기타 주문의 점용을 방지한다',
    addMainRule: '주 규칙 추가',
    surplusRules: '잉여 재료 입고 규칙',
    mainRulesTip: '주규칙 간의 예 또는 관계, 즉 하나의 주규칙을 만족시키면 나머지 재료가 입고된다',
    mainRulesTip1: '규칙을 추가한 후, 명중 규칙의 남은 재료는 우선적으로 이 창고에 보관되며, 이 창고가 가득 차면 기타 빈 남은 재료 창고에 보관된다',
    rule: '규칙',
    addSubRule: '하위 규칙 추가',
    subRuleTip: '하위 규칙 간에는 및 의 관계가 있습니다. 즉, 주 규칙 아래의 모든 하위 규칙을 동시에 충족해야 라이브러리에 들어갈 수 있습니다.',
    bigPlankMatCode: '판재',
    bigPlankThick: '판자 두께',
    bigPlankColor: '널빤지 색',
    greaterEqual: '보다 큼',
    lessEqual: '보다 작음',
    capNumberCheck: '재고 상한선은 정수만 입력할 수 있습니다!',
    capEmptyCheck: '재고 상한선은 비워둘 수 없습니다!',
    surNameEmptyCheck: '남은 재료 창고 이름은 비워둘 수 없습니다!',
    mainRuleLimit: '주 규칙이 이미 상한에 도달하였습니다',
    delMainRuleTip: '기본 규칙 삭제 여부',
    matCodeEmptyCheck: '널빤지 소재는 비워둘 수 없습니다!',
    thickEmptyCheck: '널빤지 두께는 비워둘 수 없습니다!',
    textureEmptyCheck: '널빤지 색상은 비워둘 수 없습니다!',
    enableWarehouseSecondCon: '남은 재료 입고 2차 확인 사용',
    surplusWarehouseConfirm: '남은 재료 입고 확인',
    surplusWarehouseConfirm1: '입고 확인',
    closeSurplusConfirm: '입고 확인 닫기 (여분 관리 페이지 설정에서 다시 열 수 있음)',
    position: '보관 위치',
    nameRepeatTip: '현재 남은 재료 이름이 이미 존재합니다. 수정한 후 다시 입고해 주십시오',
    surLimitTip: '현재 남은 재료 창고가 이미 상한선에 도달하였거나 입고 규칙을 만족시키지 않음',
    surFailTip: '입고 실패, 잉여 재료 이름 중복 또는 잉여 재료 창고 보관이 상한선에 도달하거나 입고 규칙을 만족시키지 못함',
    surplusExistTip: '일부 남은 원판 부품이 이미 라이브러리에 있으므로 이번 작업은 실패했습니다.',
    surplusExistTip2: '현재 남은 원판 부품이 이미 라이브러리에 있으므로 입고할 수 없습니다.',
    currentPage: '현재 페이지',
    totalPage: '모두 선택'
    },
  printPage: {
    goto: '즉시 이동',
    surplusSizeTittle: '남은 재료 치수 팁',
    surplusSizeErrTip: '남은 재료의 사이즈가 너무 작으니, 해당 생산 라인에 가서 남은 재료의 최소 사이즈를 설정하세요!',
    opacityTip: '지능형 컬러 레이블에 의한 기술 지원',
    opacityTip2: '현재 계정은 지화채표를 구매하지 않았습니다.구매한 경우 컬러 레이블 소프트웨어에 캐비닛 계정 바인딩',
    loadFontTip: '필요한 글꼴 에셋 파일을 로드하는 중입니다. 잠시만 기다려 주십시오.',
    leftAlign: '왼쪽 정렬',
    rightAlign: '오른쪽 정렬',
    topAlign: '위쪽 정렬',
    bottomAlign: '아래 정렬',
    horizontalAlign: '가로로 가운데 맞춤',
    verticalAlign: '세로 중심 정렬',
    horizontalSplit: '가로 균분',
    verticalSplit: '세로 균분',
    norTag: '일반 원본 레이블',
    surTag: '여분 대판 라벨',
    genTag: '태그 생성',
    all: '모두 선택',
    deleteWarning: '친절한 안내',
    print: '인쇄',
    defaultTemplate: '기본 템플릿(60 x 40)',
    editTemplate: '템플릿 편집',
    deleteTip: '템플릿을 삭제한 후 복구할 수 없습니다. 삭제하시겠습니까?',
    tagSetting: '레이블 설정',
    rememberSetting: '수정 후 설정에 유의하기',
    genCutingTag: '트림된 원단 탭 생성하기',
    genSurplusTag: '남은 원판 부품 레이블 생성하기',
    genPlankTag: '대시보드 레이블 생성',
    genPartTag: '보드 레이블 생성하기',
    genNoCutTag: '원판 부품 레이블을 생성할 수 없음',
    tagPosition: '부착 위치',
    tagPositionTip: '(아래 X/Y 좌표는 어댑터에 입력해야 함)',
    Xposition: 'X 좌표',
    Yposition: 'Y 좌표',
    genPlankSuffix: '보드 레이블은 원본 파일 이름 접미어를 생성합니다.',
    arrangeMirror: '탭 이미지 미러링',
    drillPlankBase: '5, 6면 드릴 방판 기준',
    drillPlankBaseTip: '플레이트 기준 데이터 가져오기 오류, 나중에 다시 시도하십시오!',
    suitAuto: '라벨 정렬은 자동 상하 재료에 적합합니다.',
    colorLabel: '색상 레이블 생성',
    colorRevert: '슬레이트 색상 반전 레이블 생성하기',
    displayEnAndZh: '방/캐비닛/판본명 전시 중영문',
    displayEnAndZhTip: '기본 공간 / 캐비닛 이름 / 보드 이름만 지원되며 사용자 정의 이름으로 수정하면 이 기능은 적용되지 않습니다.',
    up: '위로',
    down: '아래로',
    default: '기본',
    printSetting: '인쇄 설정',
    oneToMore: '여러 페이지',
    perPage: '매 장',
    coloumn: '열',
    tagMargin: '레이블 간격',
    coloumnMargin: '열 간격',
    specialMark: '특수 태그',
    opacity: '투명도',
    opacityTip3: 'BMP 형식의 그림은 투명도를 지원하기 위해 실제 색상을 선택해야 합니다.',
    suite: '적응성',
    svgListTip: '스몰 보드 생성 탭을 열지 않았습니다. 왼쪽에서 선택하십시오.',
    size: '크기',
    lightSide: '광변 을 보다',
    locFrontSide: '캐비닛 앞',
    openSide: '문 여는 방향',
    extraTip: '팁: 직접 인쇄를 처음 사용할 경우 프린터 설정에 해당 크기와 길이, 너비가 조정된 용지를 추가한 다음 새 용지를 사용하여 인쇄합니다 (예: 원래 용지 크기 60 × 40, 새 용지 크기 40 × 60).',
    noMore: '더 이상 없어요',
    prepareData: '데이터 준비 중...',
    genTagFile: '탭 생성 중, 페이지 전환, 브라우저 최소화, 탭 위아래로 스크롤 등을 하지 마십시오!',
    waitGen: '라벨 로드가 완료될 때까지 기다린 후 다운로드하십시오.',
    tempLoading: '태그 템플릿 로드 중, 나중에',
    front: '앞',
    open: '열다',
    toEdit: '편집으로 이동',
    simplifyOneCodeTip: '참고: 이 태그 템플릿에 설정된 바코드 속성은 "간단한 바코드" 기능을 지원하지 않습니다. 바코드 속성을 수정하십시오(권장 바코드 속성: CODE128)',
    plankTemp: '보드 레이블 템플릿',
    surplusTemp: '남은 재료 레이블 템플릿',
    enableSubTag: '부 라벨 사용',
    enableSubTagTip: '더보기 설정 > 소판 부 라벨 설정 > 부 라벨 생성에 적용할 데이터 소스 설정에서 구성할 수 있습니다. 활성화 후 설정한 데이터 소스가 부 라벨에 값이 있을 때만 부 라벨이 생성되며, 그렇지 않으면 생성되지 않습니다.',
    goSet: '설정으로 이동',
    mainTag: '소판 메인 라벨',
    subTag: '소판 부 라벨',
    downloadSubTagTip: '내보낸 라벨에 서브 라벨이 포함되어 있습니다. 자동 라벨링 생산 라인은 현재 서브 라벨을 생성할 수 없습니다. 계속 출력하시겠습니까?',
    embeddedSubTagTip: '부 라벨 기능은 지원되지 않습니다. 웹 기반 클라우드 레이아웃을 열어 사용하세요.',
    subTagPerSaveTip: '서브 라벨 권한이 만료되었습니다. 서브 라벨을 닫고 다시 저장하세요.',
    subTagPerexportTip: '내보낸 생산 파일에 지불 서브 라벨 권한이 포함되어 있습니다. 이 기능은 만료되었으며 닫고 다시 출력해야 합니다.',
    tempNamePlaceHolder: '템플릿 이름을 입력하십시오.',
    editTip: '원하는 대로 왼쪽 단추를 오른쪽 탭 용지로 드래그하여 탭 템플릿 편집을 완료할 수 있습니다.',
    oneCode: '바코드',
    image: '이미지',
    arrow: '화살표',
    editPage: {
      digitLimitation: '자릿수 제한',
      title: '태그 템플릿 편집',
      reset: '기본 복원',
      exit: '편집 종료',
      tagInfo: '태그 정보',
      tagName: '라벨 이름',
      tagSize: '레이블 크기',
      tagData: '태그 데이터',
      dragTip: '마우스 왼쪽 버튼을 누른 채 데이터 레이블 드래그',
      dataTip: '오른쪽 속성 표시줄에서 데이터 정보를 선택하십시오.',
      text: '텍스트',
      dataSource: '데이터 정보',
      graph: '그래픽',
      typograpyPic: '조판도',
      barCode: '바코드',
      QRCode: 'QR 코드',
      plankMark: '보드 태그',
      holeSlotPic: '구멍 차트',
      edgeBandPic: '봉인도',
      visibleEdgePic: '광변 을 보다',
      holeSlotPicZoom: '구멍 슬롯 그림 배율 조정',
      rotateDeg: '회전 각도',
      colorDeep: '색상 깊이',
      surplusMark: '남은 재료 표식',
      surplusSizePic: '남은 재료 치수도',
      dataSize: '데이터 크기',
      extraList: '추가 목록',
      QRCodeFormat: 'QR코드 형식',
      formatQR: 'QR 형식',
      formatDM: 'DM 형식',
      locIndex: '캐비닛 번호',
      plankFrontSign: '패널 태그',
      genNCSuffix: 'NC 접미어 생성하기',
      table: '표',
      inputPlaceholder: '입력 텍스트를 두 번 클릭하십시오.',
      attribute: '속성',
      fontFamily: '글꼴 유형',
      fontSize: '글꼴 크기',
      fontWeight: '글자 굵게',
      flipOverProcessing: '뒤집기 가공',
      showSideMachiningSequenceDiagramBorder: '측면 가공 순서 도표 테두리 표시',
      showSideMachiningSequenceNumber: '측면 가공 순서 번호 표시',
      autoRow: '자동 줄 바꿈',
      rowMargin: '행 간격',
      autoFontSize: '오버플로우 자동 글꼴 크기 조정',
      statisticsDimension: '통계 차원',
      noLimit: '무제',
      sameOrderNo: '동일 주문',
      sameRoom: '같은 방',
      sameWardrobe: '같은 캐비닛',
      alignWay: '정렬',
      JustifyLeft: '왼쪽 정렬',
      JustifyRight: '오른쪽 정렬',
      JustifyCenter: '가운데 맞춤',
      otherOpration: '추가 작업',
      attributeReset: '매개변수 재설정',
      barCodeSize: '바코드 크기',
      installPic: '설치 다이어그램',
      plankCode2: '보드 바코드(noMark)',
      frontCode: '전면 바코드',
      backCode: '후면 바코드',
      orderRemark: '주문 노트',
      NCFileName: '원본 파일 이름',
      NCFileNameTip: '원본 파일 이름은 중국어를 포함하지 마십시오. 길이는 10자리를 초과할 수 없습니다.',
      showOpenSide: '문 여는 방향 표시',
      limitFixed: '소수점 자릿수 제한',
      showFrontHS: '전면 구멍 슬롯 표시',
      showBackHS: '후면 구멍 슬롯 표시',
      showPartEdge: '보드 막대 모서리 표시하기',
      showPlankSize: '보드 크기 표시하기',
      tempNamePlaceholder: '태그 이름을 입력하십시오.',
      deleteAreaTip: '삭제할 청크를 선택하십시오.',
      suitShunt: '맞춤 구멍 슬롯 분기 설정',
      suitShuntTip: '선택 후, 후속 공정이 없는 구멍 슬롯 부품은 바코드를 생성하지 않습니다.',
      noHoleSlot: '구멍 없는 슬롯에도 바코드 표시',
      rotate: '회전 바코드',
      barcodeAtrribute: '바코드 속성',
      imgSize: '이미지 크기',
      graphStyle: '그래픽 스타일',
      noEdgeDisplay: '봉인 모서리가 0이면 표시되지 않습니다.',
      allEdgeNoDisplay: '봉인 모서리가 표시되지 않음',
      isShowDiffEdgeColor: '각 봉인 모서리 색상 표시',
      hideSameEdgeColorAsPlank: '판자 색상과 같을 때 봉인 모서리 색상 숨기기',
      hideSameEdgeColorAsPlankTip: '내장 클라우드 조판은 당분간 지원하지 않습니다',
      imgRotate: '그림 회전',
      circleD: '원형 상자 지름',
      roomNo: '방 번호',
      roomOrder: '캐비닛 번호 (방별 정렬)',
      alphabetically: '알파벳순',
      numberOrder: '숫자별 정렬',
      specialMarkup: '특수 태그 기호',
      smallPlateMarking: '마커',
      arrow: '화살표',
      triangle: '삼각 각표',
      sixSideDrillPlankBase: '5, 6면 드릴 방판 기준',
      boldSettingTip: 'PDF 블랙은 지원되지 않습니다.',
      frontEdge: '캐비닛 앞 보이기',
      visibleEdge: '광선 모서리 표시',
      lineCount: '행당 단어 수'
      },
    autoSaveToHistory: '자동으로 역사에 저장되었습니다!',
    firstPrintTip: '직접 인쇄를 처음 사용할 때는 프린터 설정에 해당 크기와 길이, 너비가 조정된 용지를 추가한 다음 새 용지를 사용하여 인쇄합니다.',
    tagDownloading: '태그는 다운로드 중입니다...',
    cutLaveEnd: '남은 재료 라벨은 각 큰 판 뒤에서 생성된다',
    deleteTemplate: '템플릿 삭제',
    copyTemplateRenderUrl: '템플릿 링크 복사',
    noPermission: '템플릿 링크 복사 권한이 없습니다, 템플릿을 삭제하시겠습니까?',
    moreOperation: '더 많은 작업',
    importTemplate: '템플릿 가져오기',
    importTemplateLink: '템플릿 링크 주소를 입력 상자에 붙여넣으면 템플릿을 가져올 수 있습니다',
    importTemplateLinkPlaceholder: '템플릿 링크 주소를 입력 상자에 붙여넣으면 템플릿을 가져올 수 있습니다',
    noDeleteTemplate: '기본 템플릿을 삭제할 수 없습니다',
    tip1: '현재 템플릿에 복사 링크가 없습니다',
    tip2: '현재 템플릿 데이터 링크가 복사되었습니다',
    tip3: '템플릿 링크 복사 실패, 나중에 다시 시도하십시오',
    tip4: '가져온 템플릿 링크를 인식할 수 없습니다. 다시 다운로드한 후 가져와 주세요.'
    },
  fileManagerPage: {
    folderClassifyByTextureColorThickSize: '색상, 재료, 두께, 대시보드 크기에 따라 다른 폴더로 분류 (레이블 파일 포함)',
    notOpeFolderPermission: '이 디렉토리에 대한 권한이 부여되지 않았습니다.',
    notFindFolder: '현재 클라이언트에서 이 디렉토리를 감지할 수 없습니다.',
    productLineUniversal: '모든 생산 라인 공통',
    effectCondition: '이 설정은 변경된 후 다시 조판해야 적용됩니다.',
    addPath: '경로 추가',
    downloadPositionChangeByType: '생성된 파일의 다운로드 위치가 {type}로 변경되었습니다',
    isDeleteFolder: '사용한 파일의 저장 위치를 삭제하시겠습니까?',
    netWorkIsNotSafe: '네트워크 환경이 안전하지 않은 것 같습니다. 이 기능을 사용할 수 없습니다. 피드백해 주십시오.',
    NotSupportBrowse: '브라우저에서 이 기능을 지원하지 않습니다. 최신 버전인 <a href="https://www.microsoft.com/zh-cn/edge/download"target="_blank">Edge</a> 브라우저 사용',
    notSupportDisk: '[데스크톱] [C디스크] 와 같은 시스템 수준 디렉토리는 선택할 수 없습니다.',
    useFolderDownload: '프로덕션 파일은 압축 해제 후 다운로드됨',
    downloadPosition: '다운로드 파일 위치',
    changeUseFolder: '변경',
    folderNameSetting: '폴더 설정',
    mainFolder: '레벨 1 폴더',
    exportNameSetting: '주문 번호에 따라 가공 파일 이름 내보내기',
    fileMax: '파일 이름은 최대',
    char: '문자',
    overTip: '섹션 이상이 표시되지 않음 (맵 압축 팩과 json 파일은 레벨 1 폴더 이름을 따름)',
    example: '예제',
    engravingFolder: '조각기 폴더',
    electronicSawFolder: '전자 톱 폴더',
    labellingFolder: '어댑터 폴더',
    sideHoleDrillFolder: '측면 구멍 머신 폴더',
    fiveDrillFolder: '5면 드릴 폴더',
    sixDrillFolder: '육면 드릴 폴더',
    PTPFolder: 'PTP 폴더',
    labellingTagFolder: '맵 이미지 폴더',
    surplusFolder: '남은 재료 파일 대시보드 설정',
    surplusBigPlankSetting: '남은 대판 원단 파일 / 태그 이미지 / 태그 파일 별도 배치',
    surplusBigPlankSettingTip: '여분의 NC 파일을 열면 태그 이미지와 태그 파일이 하나의 폴더에 별도로 배치됩니다.',
    folderMergeSetting: '폴더 병합 설정',
    folderMerge: '폴더 병합',
    mergeName: '병합 이름',
    subMergeFolder: '재료 색상 두께에 따라 하위 폴더로 결합',
    subFolderName: '하위 폴더 이름',
    splitChar: '분할자',
    splitTip: '(/:? < >. "* 등의 문자는 지원되지 않음)',
    folderAutoAdd: '폴더 수 증가 시작 값',
    resetTip: '(매일 0점을 시작 값으로 재설정)',
    emptyErrTip: '정보는 비워둘 수 없습니다.',
    repeatErrTip: '파일 이름 중복',
    mergeDataTip: '판재 재료 색상 두께 가로세로 또는 파일 수 증가 또는 판재 재료 색상 두께가 있어야 합니다.',
    engravingFileSetting: '조각기 파일 설정',
    engravingSplitZF: '조각기 양면 / 후면 파일을 다른 폴더로 배치',
    engravingSplitZFTip: '1, 2, 3 자동 부착기에 적용,',
    engravingSplitWorkstation: '조각기 위치별 폴더',
    engravingSplitWorkstationTip: '조각기와 절단 조각기만 지원',
    holeFileSetting: '펀치 파일 설정',
    holeFileSingle: '펀치 파일은 주문에 따라 폴더별로 개별적으로 배치됩니다.'
    },
  moreSettings: {
    generalSetting: '일반 설정',
    outSyncTip: '클라우드 레이아웃 원본 데이터가 캐비닛과 동기화되지 않을 때 알림 탄창 생성',
    secondarySwitchShow: '조각기 설정 중 스위치 제어의 2단계 내용 스위치 해제 후 여전히 전시',
    isFrameDoorTip: '프레임 문 가공 시 프롬프트 탄창 생성',
    exPaibanTip: '이형 여분 / 이형 중첩 레이아웃 사용 시 힌트 탄창 생성',
    isDesMaterialNoCutTip: '조각기에 할당된 구멍 슬롯 / 이형이 있는 경우 프롬프트 탄창을 생성하는 슬래브 재료가 재료에 들어가지 않는 판재를 지정합니다.',
    surpTagThresholdTextHalf1: '남은 재료 (비재단 남은 재료) 면적이',
    surpTagThresholdTextHalf2: '남은 재료 라벨 생성 안 함',
    innerShapeToolMatch: '조각기 가공 내부 이형 자동 선택 적합한 공구',
    innerShapeToolMatchTip: '(조각기 가공은 원단보다 지름이 작은 내부 이형으로 치수 오류로 가공할 수 없는 경우 활성화할 수 있습니다.)',
    innerShapeToolMatchTip2: '참고: 사용으로 설정하면 최소 밀링 슬롯 공구가 사용됩니다. 최소 밀링 슬롯 공구의 공구 길이와 단일 최대 가공 깊이를 적절하게 설정하여 클라우드 레이아웃에만 적용합니다.',
    surNotLayout: '남은 재료를 정의하는 대판은 지정된 판재를 배열하지 않는다',
    surNotLayoutTip: '오픈 후 1.여분 대판은 소판 이름을 배열할 수 없습니다.아래 이름의 소판을 포함합니다.2.조판 시 이번 조판에 이 기능이 적용되는지 여부를 선택할 수 있습니다',
    addPlank: '보드 이름 추가',
    addPlankTip: '보드 이름 하나 이상 추가',
    thisInput: '여기 입력',
    surNotLayoutMat: '남은 재료는 지정된 판자를 배열하지 않는다.',
    subTagSetting: '소판 부 라벨 설정',
    subTagDataSource: '부 라벨 생성에 적용할 데이터 소스 설정',
    subTagDataSourceTip: '활성화하면 부 라벨 생성을 제어하는 데이터 소스를 추가할 수 있습니다. 부 라벨에 해당 데이터 소스가 있고 값이 있으면 부 라벨이 생성됩니다.',
    addSubTagDataSource: '데이터 소스 추가',
    addSubTagDataSourceTip: '중복 데이터 소스는 추가할 수 없습니다',
    addSubTagDataSourceTip1: '데이터 소스를 하나 이상 추가하세요',
    addSubTagDataSourceTip2: '데이터 소스는 비워둘 수 없습니다. 선택하세요',
    reuseMatchingPlankName: '보드 이름으로 재사용 매칭',
    reuseMatchingPlankNameTip1: '이 기능이 비활성화되면, 레이아웃 재사용은 재질, 색상, 두께, 크기, 질감 및 고광택 속성이 같은 패널을 매칭합니다',
    reuseMatchingPlankNameTip2: '이 기능을 활성화하면, 위의 매칭 조건 외에 보드 이름 매칭도 추가됩니다'
    },
  lineManager: {
    add: '생산라인 추가',
    engraving: '원료 공급 설비',
    holeSlotEquip: '구멍 슬롯 가공 장치',
    workSetting: '가공 설정',
    noUse: '활성화되지 않음',
    warningTip: '* 참고: 다음 기능을 설정한 후에는 캐비닛 클라이언트 장치 도킹 페이지에 저장하지 마십시오. 매개 변수 재설정을 피하십시오!',
    engravingSetting: '원료 공급기 설치',
    workWay: '가공 방식',
    cutedSpecial: '가공을 위한 특수 구멍 슬롯:',
    noWork: '이 옵션은 5 / 6 드릴 기본 템플릿에 적용되지 않습니다.',
    onlyCut: '재료만',
    onlyFrontHoleSlot: '플레이트 전면 구멍 슬롯만 가공',
    onlyHoleSlot: '가공 플레이트만 페이스 슬롯 양수 반대',
    sideHoleSetting: '측면 구멍 기계 설정',
    cutHoleSlot: '가공된 슬롯',
    minSize: '짧은 모서리 치수',
    maxSize: '긴 모서리 치수',
    minSize2: 'mm의 보드에 있는 모든',
    minSize3: '및 이형 부분',
    onlyFrontHoleSlotTip: '의 레이아웃 페이지 전면에 구멍 슬롯이 있는 보드만',
    onlyFrontHoleSlotTip2: '측면 구멍 측면 슬롯 없음',
    holeAndSlot: '구멍 및 슬롯',
    empty: '빈',
    singleHole: '단일 구멍',
    singleSlot: '단일 슬롯',
    diameterRange: '구멍 지름 범위',
    hDeepRange: '구멍 깊이 범위',
    widthRange: '슬롯 너비 범위',
    sDeepRange: '슬롯 깊이 범위',
    to: '에',
    specialHS: '특수 구멍 슬롯 및 이형',
    allowRoll: '원료 공급 기계가 특수 슬롯을 복사하여 가공하는 것을 허용한다',
    engravingPath: '원료 공급기에서 판재 이형 부분을 가공하다.',
    curve_range: '이형 부분은 길이가 더 큽니다.',
    curve_range2: '의 모든 판넬 이형 부분',
    curveArea: '이형면적',
    drillSetting: '5, 6면 드릴 설정',
    engravingCuted: '원료 공급기에서 이미 가공된 구멍 슬롯은 5 / 6면 드릴에 있다',
    engravingCutedSpecial: '원료 공급기에서 이미 가공된 이형 부분은 5 / 6면 드릴에 있다',
    genCuttingPath: '절단 데이터 생성',
    otherCuted: '기타 장비의 가공된 구멍 슬롯은 5 / 6면 드릴에 있습니다.',
    noGen: '생성되지 않음',
    genCut: '생성 및 가공',
    genNoCut: '생성되지만 가공되지 않음',
    cutTip: '참고: 이 옵션은 사용자 정의 5, 6면 드릴링 파일에만 적용됩니다.',
    maxShortSize: '최대 짧은 모서리 크기',
    maxLongSize: '최대 긴 모서리 크기',
    normalSlot: '일반 슬롯',
    specialSlot: '특수 슬롯',
    combinSetting: '콤보 장치 설정',
    allowShortSize: '짧은 모서리 치수 허용',
    equipment1: '장치 1',
    equipment2: '장치 2',
    noSameTip: '참고: 두 장치는 동일하게 선택할 수 없습니다.',
    workRange: '장치 1 가공 가능한 구멍 슬롯 범위',
    rangeWarning: '참고: 설비 1가공 범위만 설정할 수 있으며, 비설비 1가공 범위는 전부 설비 2에서 가공할 것이니, 신중하게 조작하세요!',
    deleteWarning: '이 생산라인을 삭제한 후 복구할 수 없습니다. 이 생산라인의 모든 설정은 삭제됩니다. 이 생산라인을 삭제하시겠습니까?',
    top: '상단',
    inputCheck: '{msg} 최소값은 최대값보다 커서는 안됩니다',
    lockTip: '생산 라인이 잠겼습니다. 작동 금지!',
    reNameTip: '기본 라인은 이름을 수정할 수 없습니다.',
    permissonTip: '신원 정보가 만료되었습니다. 이 페이지를 캐비닛에서 다시 열어 주십시오!',
    permissonErr: '이 권한이 없습니다. 계정 버전을 업그레이드하세요!',
    permissionOneMacErr: '통합 기기에 대한 접근 권한이 {idx}개 있습니다. 더 추가하려면 판매 담당자에게 문의하세요!',
    permissionSawErr: '톱질 조각기 사용 권한 없음, 판매에 연락하여 알루미늄 톱질 보충팩 구매 후 사용',
    getAuthError: '장치 권한을 가져오지 못했습니다!',
    sawAddNumber: '당신이 현재 사용할 수 있는 전자톱 생산 라인 수가 이미 다 떨어졌습니다. 추가하려면 판매에 연락하세요!',
    newLine: '새로운 생산 라인 {idx}',
    deleteCheck: '모두 삭제할 수 없음',
    deving: '개발 중',
    combinTip: '아래 콤보 장치 설정을 클릭하여 설정하세요',
    noUseEquip: '머시닝 장치 사용 안 함',
    equipmentSelectTip: '조립 설비가 원료 공급기를 선택했을 때, 원료 공급 설비는 전자톱을 선택할 수 없다',
    lineLoading: '데이터 로드 중',
    strenchType: '스트레이트 슬롯 유형',
    aioProcessTip: '올인원 장치를 활성화했습니다. 기본값은 가공 플레이트 부품의 양수 얼굴 슬롯입니다.',
    aioProcessTip2: '올인원 사용 후 조각기 부분에서 가공된 특수 슬롯',
    aioProcessTip3: '참고: 이 기능은 XY 축 교환이 활성화된 조각기와 호환되지 않으므로 주의해서 사용하십시오.',
    specialHoleTip: '참고: 위의 가공된 특수 구멍 슬롯 기능을 사용할 때는 구멍 뚫기 및 구멍 뚫기 를 한 번에 뚫기 로 설정합니다.',
    specialHoleTip2: '참고: 위의 가공된 특수 구멍 슬롯 기능을 사용할 때는 조각기 구멍 뚫기 및 구멍 뚫기 를 한 번에 뚫기 로 설정하십시오.',
    fiveSixNotTake: '이 옵션은 5 / 6 드릴 기본 템플릿에 적용되지 않습니다.',
    onlyFrontSide: '전면만 가공',
    onlyBackSide: '후면만 가공',
    less: '미만',
    equal: '같음',
    greater: '보다 크다',
    or: '또는',
    and: '그리고',
    bothFrontBack: '전면 및 후면 가공하기',
    shareDataErrTip: '이 데이터는 {operatorPhone}에서 적용되었으며, IP: {actionIp}',
    restoreParams: '복원 매개변수',
    loadMore: '추가 로드',
    currentCombinationEquipment: '현재 조합 장치를 선택하여 재료 공급 장치를 유리 절단기로 전환할 수 없습니다.',
    selectEquipmentType: '장치 유형을 선택하십시오.',
    ruleRemark: '규칙 설명',
    remarkPlaceholder: '이것은 이 규칙이 어떤 공예를 가공하는지 비고하여 잊어버리지 않도록 하고, 기입한 후 생산 라인을 보존하여 효력을 발생시킬 수 있는 비고 정보이다',
    onlyNoSideHoleSlotSmallPlank: '측면 구멍/슬롯이 없는 소판만'
    },
  cuttingDock: {
    title: '재료 도킹',
    autoStockCode: '자동 위아래 소스 코드',
    stationStart: '작업 위치 시작',
    stationStartCode1: '작업 위치 1 시작 코드',
    stationStartCode1Placeholder: '작업 위치 1 시작 코드 입력',
    stationStartCode2: '작업 위치 2 시작 코드',
    stationStartCode2Placeholder: '작업 위치 2 시작 코드 입력',
    stationEnd: '작업 위치 종료',
    stationEndCode1: '작업 위치 1 종료 코드',
    stationEndCode1Placeholder: '작업 위치 1 종료 코드 입력',
    stationEndCode2: '작업 공간 2 종료 코드',
    stationEndCode2Placeholder: '작업 공간 2 종료 코드 입력',
    frontBackStart: '앞뒷면 시작',
    frontBackEnd: '앞뒷면 끝',
    frontStartCode: '전면 시작 코드',
    frontStartCodePlaceholder: '전면 시작 코드 입력',
    frontEndCode: '전면 종료 코드',
    frontEndCodePlaceholder: '전면 종료 코드 입력',
    backStartCode: '후면 시작 코드',
    backStartCodePlaceholder: '후면 시작 코드 입력',
    backEndCode: '후면 끝 코드',
    backEndCodePlaceholder: '후면 끝 코드 입력',
    plankStart: '보드 뒤집기 시작',
    plankEnd: '보드 뒤집기 끝',
    plankRollCode1: '작업 위치 1 뒤집기 코드',
    plankRollCode1Placeholder: '작업 위치 1 뒤집기 코드 입력',
    plankRollCode2: '작업 위치 2 뒤집기 코드',
    plankRollCode2Placeholder: '작업 위치 2 뒤집기 코드 입력',
    autoBaitingCode: '자동 공급 코드',
    autoBaitingCode1: '작업 위치 1 원료 코드',
    autoBaitingCode1Placeholder: '작업 위치 1 공급 코드 입력',
    autoBaitingCode2: '작업 위치 2 원료 코드',
    autoBaitingCode2Placeholder: '작업 위치 2 공급 코드 입력',
    thickMarkPermission: '현재 대판 두께 표시 권한이 없습니다. 판매팀에 문의하여 구매 후 사용하세요',
    thickMark: '대판 두께 표시',
    preStartEquipment: '사전 부팅 장치',
    firstKnifePreCode: '첫 번째 사전 부팅 코드 이전',
    secondKnifePreCode: '보조 및 후속 칼 사전 부팅 코드',
    rowInsert: '행 삽입',
    pumpPause: '진공 펌프 정지',
    pumpPauseTip: '참고: 단일 작업 비트 장치는 작업 비트 1과 작업 비트 2를 동일한 자동 재료 공급 코드와 양면 가공 전면 주석 코드로 채워야 합니다.',
    pumpPause2Tip: '참고: 단일 작업 공간 장치는 작업 공간 1과 작업 공간 2를 모두 동일한"진공 펌프 일시 중지 코드"로 채워야 합니다.',
    pumpPauseCode1: '작업 공간 1 진공 펌프 일시 정지 코드',
    pumpPauseCode1Placeholder: '작업 공간 1의 진공 펌프 일시 정지 코드를 기입해 주십시오',
    pumpPauseCode2: '작업 공간 2 진공 펌프 일시 정지 코드',
    pumpPauseCode2Placeholder: '작업 공간 2의 진공 펌프 일시 중지 코드를 입력하십시오.',
    annotationCode1: '가공 비트 1 양면 머시닝 전면 주석 코드',
    annotationCode1Tip: '정면의 다른 명령을 자동으로 전달하는 장치',
    annotationCode1Placeholder: '가공 위치 1 양면 머시닝 전면 주석 코드 입력',
    annotationCode2: '가공 위치 2 양면 머시닝 전면 주석 코드',
    annotationCode2Placeholder: '가공 위치 2 양면 머시닝 전면 주석 코드 입력',
    upSpeedTip: '공통 가속도를 입력하십시오.',
    cutThickTip: '공통 모서리 컷 두께를 입력하십시오.',
    sizeErrTip: '레이블을 내보낼 올바른 크기를 레이블에 설정하십시오.',
    offEdgeKnifeDiameter: '모서리 공구 지름을 입력하십시오.',
    slowDownSpeedTip: '컷 모서리 감속 입력 매개변수 오류',
    permissionErr: '현재 무료 버전으로 저장할 수 없습니다.',
    labellingTempErr: '부착기 템플릿을 선택하십시오.',
    autoRollInputTip: '탭 자동 회전을 켜려면 유효한 값을 입력해야 합니다',
    offlineTempFormat: '현재 부착기 파일 형식이 오프라인 상태입니다. 확인하십시오.',
    autoStockCode1: '작업 위치 1 자동 공급 코드',
    autoStockCode1PlaceHolder: '작업 위치 1 자동 공급 코드 입력',
    autoStockCode2PlaceHolder: '작업 위치 2 자동 공급 코드 입력',
    autoStockCode2: '작업 위치 2 자동 공급 코드',
    pauseCode: '코드 일시 중지',
    pauseCodePlaceHolder: '일시 중지 코드 입력',
    cuttingToolMaxDepthTip: '{errKey} 칼 라이브러리에서 한 번의 최대 가공 깊이는 칼 길이보다 커서는 안됩니다',
    cuttingParams: {
      title: '가공 매개변수',
      stationWidth: '작업 면적 너비',
      stationWidthTip: '자투리 대판을 사용할 때 폭 방향으로는 설정된 치수 범위 내에서만 소판을 배치할 수 있습니다',
      holeSlotMainSide: '구멍 슬롯 집중면',
      holeMainSide: '구멍 집중면',
      slotMainSide: '슬롯 집중면',
      workPriority: '(기능 우선 순위: 특수 구멍 슬롯 가공면 사용자 지정 > 구멍 뚫기 슬롯 소재 면은 이 보드에 구멍이 뚫리지 않은 슬롯을 따릅니다. > 구멍 슬롯 분류에 설정된 특수 구멍 슬롯은 대판 정면 > 슬롯 집중면 > 구멍 집중면에 우선적으로 배치됩니다.)',
      holeSlotSet: '구멍 뚫기 슬롯 가공 설정',
      hingeRollWork: '지퍼 및 경첩 컵 구멍을 대형 플레이트 후면에 배치하여 가공',
      followWork: '구멍 뚫기 슬롯의 소재면은 이 판자의 구멍 뚫지 않은 슬롯을 따른다',
      autoMatchSide: '양수 얼굴 반전 슬롯 비례 지정',
      backHSRate: '후면 구멍 슬롯 비율',
      matchTip: '이 설정은 하이라이터, 컴퓨팅 이형 레이아웃 또는 패턴 매칭을 켜도 적용되지 않습니다.',
      specIalHoleAndSlotSurface: '특수 구멍 슬롯 가공면 사용자화',
      specialRuleTip: '특수 슬롯을 선택하십시오.',
      specialSlotsHoles: '구멍 슬롯 유형',
      holeType: '구멍 유형',
      specialRules: '규칙',
      normalHole: '일반 구멍',
      normalSlot: '일반 슬롯',
      holeDiam: '구멍 지름',
      slotLongSide: '슬롯 길이 모서리',
      slotShortSide: '슬롯 짧은 모서리',
      FixedmachSurface: '가공면 고정',
      deleteRuleTip: '규칙 삭제 여부',
      blankFront: '판자 정면',
      blankBack: '널빤지 뒷면',
      addRules: '규칙 추가',
      addRulesTip: '동일한 보드가 여러 규칙을 명중시킬 때 가장 앞에 있는 일련 번호가 적용되므로 임의의 행을 드래그하여 규칙 순서를 변경할 수 있습니다.',
      highGlossSetting: '고광택 패널 설정',
      heighGlossFront: '조판할 때 소판의 고광면이 큰 판에 배열되어 있다',
      highGlossPlankNoRotate: '고광면 패널 회전 안 함',
      highGlossAutoRoll: '후면 구멍 슬롯만 있는 대판 자동 뒤집기',
      highGlossAutoRollTip: "<span class='color-o-4'>(활성화 후 반면 구멍 슬롯이 있는 대판 조판 시 자동으로 뒤집히며, 단면 보드로 변환됩니다. 사용자 정의 파일 이름 \"고광면 뒤집기 널빤지\" 데이터와 함께 사용하세요）</span>",
      customHighGlossReverse: '고광면 뒤집기 널빤지',
      sideSlotPut: '측면 슬롯 배치',
      optimize: '기능 최적화 중',
      sysDefault: '시스템 기본',
      plankInSide: '널빤지 안쪽',
      plankOutSide: '대판 바깥쪽',
      specialNotWork: '이 기능은 이형 플레이트에 적용되지 않습니다.',
      commonSide: '공통 모서리 컷',
      commonSetting: '공통 모서리 설정',
      plankThickRange: '판재 두께가 같음 이하',
      useCommonSide: '공통 모서리 컷 사용',
      zeroTip: '조판 간격은 수동으로 0으로 변경해야 합니다. 절단된 모서리로 가공할 때 바이트가 모서리를 건너뜁니다. 이 기능이 켜지면 사선 가공이 지원되지 않습니다. 주의하세요!',
      useTip: '이 기능을 켜면 사선 가공이 지원되지 않습니다. 주의하세요!',
      commonSpeed: '공통 모서리 가속',
      highSpeed: '고속 밀링 속도',
      min: '분',
      notWorkTip: '판재 가공이 공변 절단을 만족시킬 때, 공변 가속은 효력이 발생하지 않는다',
      changeStartPoint: '이중 작업 시작점 전환',
      changeStartPointTip: '듀얼 비트 시작점 전환이 활성화되면 XY 축 교환 기능과 호환되지 않으므로 주의해서 사용하십시오.',
      flatOffset: '테이블 평면 오프셋',
      xRowChange: 'X축 좌표 데이텀 쌍',
      bigplankPointChange: '대시보드 후면 좌표 데이텀 쌍',
      reverseXRowChange: 'X 좌표 조정',
      changebigplankPointTips: '이 기능이 활성화되면 XY 축 교환, 이중 작업 시작점 전환 기능과 호환되지 않으므로 주의해서 사용하십시오.',
      reverseYRowChange: 'Y 좌표 대조',
      plankMirrorTip: '이 기능은 원료 공급기에서 가공된 판재 대칭복사에 사용됩니다.',
      notSameSize: '더블 비트 테이블 다른 크기',
      maxSize1: '작업 공간 1 최대 크기',
      notSameSizeTip: '듀얼 비트 테이블의 다른 크기가 활성화되면 듀얼 비트 파일 병합 기능과 호환되지 않으므로 주의해서 사용하십시오.',
      maxSize2: '작업 공간 2 최대 크기',
      autoSelectTip: '더블 비트 장치 두 테이블 크기가 동시에 사용되지 않음 이 기능은 자동으로 해당 비트 가공 대판을 선택합니다',
      bigFlatLimit: '큰 작업공간은 작은 작업공간에서 가공할 수 없는 큰 판만 가공합니다.',
      surplusSetting: '여분 설치',
      surplusPosition: '여분의 재료 배치 위치',
      cutHoleWay: '가공 펀치 방식',
      knifeFlat: '대시 데이텀 면',
      flat: '테이블',
      plankFlat: '판자 표면',
      freeHeightZ: '유휴 시 Z 높이',
      relativeHeight: '대판 표면 높이 대비',
      cutDeepZ: '절투량 Z 깊이',
      cutDeepH: '펀치 방식',
      setDisableDoubleSidedThroughHole: '설정이 유효하지 않음 뒤집기 두 번 천공',
      addHolesToRulesDisableDoubleSided: '해당 관통공(뚫린 구멍)을 아래 규칙에 추가한 후, 뒤집어 두 번 꿰뚫기가 적용되지 않습니다',
      onceThrough: '한 번에 꿰뚫다',
      rollThrough: '뒤집어 두 번 꿰뚫다.',
      cutDeepS: '통홈 뚫기 방식',
      plankCutDirection: '소판 절단 방향',
      clockDirSwitch: '밀링 구멍 밀링 슬롯 / 내부 이형 컷 방향 사용자화',
      millHoleSlotDir: '밀링 구멍 밀링 슬롯 방향',
      millInternalCurveDir: '내부 이형 컷 방향',
      sDirection: '시계 바늘',
      nDirection: '반시계 방향',
      curveReplenish: '호 보간 명령 절단 호형판',
      curveReplenishTip: '원형 판넬 가공에 톱니가 나타나는 경우 이 기능을 사용할 수 있습니다.',
      noGen: 'G17/G18/G19 면 명령이 생성되지 않음',
      arcInstruction: '호 보간 명령 접두사',
      example: '예시',
      arcExample: 'G17G03 X100 Y100',
      curveCutTip: '호 가공은 I, J로 표현됩니다.',
      coverRate: '슬롯 밀링 시 컷 중첩률은 다음과 같습니다.',
      roughTip: '이 기능은 공구가 슬롯을 밀링할 때 슬롯 내부에 가시가 남아 있을 때 사용됩니다.',
      clearCurve: '슬롯을 밀링할 때 잡아당기지 않은 슬롯은 자동으로 필렛을 정리합니다.',
      curveUseTip: '슬롯을 밀링할 때 필렛을 정리해야 합니다. 이 기능은 연결 부품에 적용되지 않습니다.',
      slotCutWay: '밀링 슬롯 패스 방법',
      outToIn: '바깥쪽에서 안쪽으로 밀링 슬롯',
      inToOut: '내부 밀링 슬롯',
      zShapProcess: '슬롯 상하 Z자형 밀링 슬롯',
      zShapProcessTip: '공구 경로 중첩률은 전면 및 후면 밀어내기 슬롯 밀링 슬롯에만 적용되며 기본적으로 공구 반지름입니다.',
      zSlotCuttingOverlapRate: 'Z자형 밀링 슬롯 컷의 중첩률은 다음과 같습니다.',
      zSlotCuttingOverlapRateTip: '현재 중첩률로 인해 가공 속도가 느려질 수 있습니다. 시험 삼아 가공하십시오.',
      slotWorkLimit: '(밀링 슬롯 패스 레벨 수가 1 이상인 경우에만 적용)',
      minKnifeChange: '가공 감소 교체 도구',
      preventBreakage: '가장자리 슬롯 격판 파손 방지',
      preventBreakageTip: '이 설정은 네스팅 시 전면에 위치한 슬롯에만 적용되며, "특수 구멍 슬롯 가공면 사용자화" 기능과 함께 사용할 수 있습니다',
      preventBreakageTip1: '슬롯이 판재 가장자리에 너무 가까운 경우, 절삭 시 해당 위치의 분리대(남은 연결 부분)가 응력 집중으로 인해 쉽게 끊어지는 문제를 해결할 수 있습니다',
      preventBreakageDistance: '판재 가장자리까지의 거리',
      preventBreakageLength: '가장자리 구간 길이',
      preventBreakageSlot: '슬롯',
      preventBreakageCutDeep: '최초 절삭 깊이',
      workSpeedOp: '가공 속도 최적화',
      obliqueCut: '가공 시 바이트 각도',
      obliqueCutTip: '판재 두께가 지정되지 않은 경우, 모든 판재 두께가 작은 판재에 적용됩니다',
      obliqueThickLabel: '사용자 지정 사선 하향 커팅 유효 판재 두께',
      obliqueThick: '베벨 커스텀 머시닝 속도',
      backObliqueThick: '베벨 커스텀 머시닝 속도',
      effectiveThickness: '효과적인 두께',
      effectiveThicknessTip: '효과적인 두께는 비어있을 수 없습니다, 입력해주세요!',
      effectiveThicknessDuplicateTip: '효과적인 두께는 중복될 수 없습니다. 수정해 주세요',
      obliqueCutData: '사선 하강 거리',
      backOblique: '뒷면 트림 각도 각도',
      obliqueSpeed: '사선 속도',
      obliqueSpeedTip: '사선 속도',
      arcSpeed: '커브 머시닝 속도',
      cuttingPreDistance: '칼을 내려 거리를 앞당기다',
      backKnife: '절단 커터 감속',
      openKnifeSpeed: '칼을 거두는 속도',
      retractionCompensation: '가공 마무리 거리 보정',
      retractionCompensationTip: '최대 20',
      cutCornerSlow: '절단 모서리 감속',
      addRow: '추가',
      bettwenDistance: '모퉁이 전후 거리',
      cuttingSpeed: '절단 속도',
      stepCutting: '계층형 컷',
      splitSlot: '슬롯 두 번 절단',
      splitPlank: '의 보드를 두 번 절단합니다.',
      splitPlank2: '판자를 두 번 절단하다.',
      minSafeThick: '두께 초과',
      splitPlankTip: '(이형 보드에는 적용되지 않음)',
      splitPlankTip2: '(호환되지 않음: 커팅 커팅 보상)',
      cutPlankMethod: '판자 자르기 방법',
      cutPlankMethodTip: '네 면을 두 번 자르다',
      cutPlankMethodTip2: '마지막 변만 한 번 자르고 두 번 자르다',
      specialShapCut: '이형판 부품을 두 번 자르다',
      specialShapCutTip: '(활성화되면 모든 이형판 부품이 두 번 잘립니다.)',
      bridgeRetention: '브릿지 유지점 방식',
      bridgeRetentionTip: '(주의: 1. 이 기능은 현재 외부 이형판을 지원하지 않습니다. 2. 사선 하향 절단을 지원하지 않습니다. 3. 연결 브릿지 생성 판재의 최소 크기는 30mm입니다.)',
      bridgeRetentionDesc: '판재 내부에 많은 중공 영역이 있어 절단 경로의 지지가 부족할 때 발생하는 떨림이나 밀림 문제를 해결할 수 있습니다.',
      bridgePunchArea: '관통 부분이 전체 면적을 초과',
      bridgeSize: '연결 브릿지 크기',
      bridgeGenMethod: '생성 방식',
      bridgeAddTip: '최대 10개의 데이터 추가',
      bridgeCount: '연결 브릿지 수',
      bridgePlankLength: '판재 길이(L)',
      maxWH: '길이 또는 너비 이하',
      areaLimit: '면적이 작음',
      secondDeep: '두 번째 컷 깊이',
      splitPlankThickSetting: '가공소재 계층형 가공 설정',
      saveCustomSpeedTip: '가공 속도는 비워둘 수 없습니다.',
      saveLayeredCuttingTip: '가공소재 계층 가공 3차 계층 가공의 합계는 판재 두께와 같아야 합니다.',
      saveLayeredRepeatTip: '원단 계층 컷은 동일한 재료의 하이라이트 속성 두께에 대해 다른 계층 데이터를 설정하는 것이 권장되지 않습니다. 중복 데이터를 제거하십시오!',
      splitPlankThick: '서로 다른 두께 계층형 절단',
      movePlankSetting: '달리기 방지판 설정',
      newCutSequence: '새 절단 알고리즘',
      newCutSequenceText: '기본 대판 중심 진공 흡입력이 가장 강하며, 이 영역 소판은 마지막에 잘라냅니다.',
      positionTip: '해당 영역을 클릭하여 선택 가능',
      suctionPosition: '진공 강흡력 위치',
      strongArea: '강한 흡입력 영역',
      minSuctionPlank: '최소 흡착 가능 플레이트',
      safeWidth: '너비',
      safeHeight: '길이',
      safeTip: '빨아들이지 않으면 판재를 먼저 잘라요.',
      scattered_layout: '소판 분산 조판',
      lastCutPointEnable: '대판에서 마지막 절단 소판 하강점 사용자 정의',
      lastCutPointEnableTip: '활성화 시, 각 대판의 마지막 절단 소판 하강점이 설정된 점 위치에 따라 생성됩니다',
      lastCutPoint: '하강점 위치',
      lastCutPointTip: '활성화 시, 각 대판의 마지막 절단 소판이 이 하강점을 사용합니다',
      leftTop: '왼쪽 상단',
      rightTop: '오른쪽 상단',
      leftBottom: '왼쪽 하단',
      rightBottom: '오른쪽 하단',
      specifyTheMaterial: '재료 지정',
      shapeSecondCutenable: '이형판 2차 절단',
      addMaterial: '재료 추가',
      plankMaterial: '판재 재료',
      specifyTheMaterialTip: '사용으로 설정하면 테이블 재료에 맞는 보드에 2차 가공 기능이 적용됩니다.',
      dispersePaibanTipOne: '활성화되면 각 보드에 최소 흡입 가능 크기를 충족하는 보드가 하나 이상 배치됩니다.',
      dispersePaibanTipTwo: '2、사용 후 대판량이 증가할 수 있으니 주의하세요',
      totalThickLimit: '세 번째 계층 컷의 합계는 보드 두께와 같아야 합니다.',
      offsetFollowStep: '트림된 모서리도 계층형 컷을 따릅니다.',
      longPlankTip1: '1. 이 기능을 켜거나 끈 후, 기록에 저장된 조판 기록은 NC를 다운로드할 때 다시 조판해야 합니다',
      longPlankTip2: '2. 이 기능을 활성화한 후 반드시 [재료 도킹 - 진공 펌프 정지]에서 진공 펌프 일시정지 코드를 설정해야 하며, 그렇지 않으면 장판 절단 시 휨 문제를 해결할 수 없습니다',
      longPlankTip3: '3. 아래에서 활성화된 필터 조건은 계층별로 순서대로 검증되며, 이전 단계의 필터 조건을 충족한 보드만 다음 단계의 필터 조건으로 들어가 판정됩니다.',
      secondCutting: '객체 2차 가공',
      normalPlank: '일반 보드',
      normalPlankTip: '일반판: 캐비닛에 가로세로 칸막이 등 캐비닛 문이 아닌 판재와 개료 명세서에 직접 추가된 판재',
      designatedTarget: '지정 대상',
      filterLevel1Label: '1차 필터',
      filterLevel1Category: '보드 유형',
      filterLevel2Label: '2차 필터',
      filterLevel2Category: '크기 제한',
      filterLevel3Label: '3차 필터',
      filterLevel3Category: '기타',
      specifiedBoardForceEnable: '크기/기타 필터 무시, 강제 활성화',
      curveMaterialFilterTip: '(「이형 보드」 선택 후, 재질 필터 전에 이형 보드 조건을 먼저 만족해야 함)',
      cuttingSettings: '절단 설정',
      plankSizeLimitSuffix: ' 보드',
      specifiedBoard: '보드 이름 가공 지정하기',
      specifiedBoardTip: '열려 있는 경우 아래에 추가된 보드 이름이 보드 이름 내에 포함되면 2차 가공이 적용됩니다.',
      addPlankName: '보드 이름 추가',
      plankNameEmpty: '보드 이름은 비워둘 수 없습니다. 입력하십시오.',
      plankNameRequired: '하나 이상의 보드 이름을 추가하십시오.',
      plankLongLimit: '널빤지 길이가 길면',
      plankShortLimit: '짧은 모서리 초과',
      cuttingSplit: '두 차례로 나누어 절단하다.',
      longExpand: '첫 번째 컷 방량: 긴 모서리 방량',
      firstExpand: '첫 번째 컷 배치',
      longExpandTip: '장변 방량',
      longLimit: '길이 초과',
      cuttingSplitTip: '장판을 두 번에 걸쳐 절단 조건',
      shortExpand: '단변 방량',
      expandTip: '길이/짧은 모서리 크기는 각각 X mm씩 증가하며, 이형 장판의 길이와 짧은 모서리 방량은 모두 긴 모서리 방량값이다',
      pumpOffWay: '진공 폐쇄 방식',
      afterOnePlank: '단일 장판 절단 후',
      afterAllPlank: '전체 대판을 절단한 후',
      numberFixed: '소수점 보존 자릿수',
      bufferCode: '언더 버퍼 명령 설정',
      layoutGap: '조판 클리어런스 설정',
      layoutGapTip: '참고: 레이아웃 간격을 0으로 설정하면 레이아웃이 겹칠 수 있습니다.',
      wasteCutting: '폐기물 자동 절단',
      zkPointCustomize: 'Z-버클 사접 구멍만들기 회전 데이텀 점 사용자화',
      sawSetting: '톱질 설정',
      cuttingLimit: '절단 크기가 보다 큽니다.',
      waste: '의 폐기물',
      wasteSizeLimit: '최소 크기는 100mm 이하여야 합니다.',
      topLeft: '왼쪽, 위',
      topLeftD: '왼쪽 위',
      bottomLeft: '왼쪽, 아래',
      bottomLeftD: '왼쪽 아래',
      topRight: '오른쪽, 위',
      topRightD: '오른쪽 위',
      bottomRight: '오른쪽, 아래',
      bottomRightD: '오른쪽 아래',
      firstTime: '첫 번째',
      secondTime: '두 번째',
      thirdTime: '세 번째',
      startCutting: '가공 시작',
      thickRange: '두께 ≥',
      longCut: '장판 가공',
      edgeSetting: '모서리 설정 고치기',
      cuttingOrder: '가공 순서:',
      cuttingOrderTip: '이 방식은 주판 위험이 있으니, 신중하게 사용하시기 바랍니다.',
      plankFirst: '먼저 판자를 자르다',
      wasteFirst: '폐기물을 먼저 썰다',
      offTip: '닫으면 가공 매개변수에서 모서리 셋업 따르기',
      edgeCutDirection: '모서리 수정 방향',
      lGapTip: 'L형 여분 재료 대판 틈새 배치 위치는 자동으로 위치 실린더 대각 방향으로 조정되며, 고광 여분 재료 대판은 제외되며, 동시에 xy축 교환 기능과 호환되지 않는다',
      cylinderDir: '실린더 방향 지정',
      onlyLong: '길쭉한 테두리만',
      backCutOrder: '뒷면 트림 순서',
      backFirst: '뒷면 모서리 손질 시작',
      backSecond: '후면 구멍 슬롯 가공 후 모서리 고치기',
      frontReCut: '정면 재수선',
      frontReCutTip: '위치 지정 실린더 모서리를 매끄럽게 하여 흔적 방지',
      useNewCut: '새 모서리 수정 규칙 사용',
      newCutTip: '이 기능은 양면 머시닝 보드의 전면에서 모서리 치수를 하나 더 수정할 때 사용됩니다.',
      fixedTip: '참고: 예약된 자릿수가 0 또는 1이면 레이아웃이 겹칠 수 있습니다.',
      cuttingSlow: '하단 패널 부품 표면 버퍼',
      holeSlow: '펀치 플레이트 서피스 버퍼',
      slotSlow: '슬롯 / 밀링 구멍 / 밀링 슬롯 플레이트 서피스 버퍼',
      slowCode: '버퍼 명령 사용',
      code: '명령',
      bufferOffset: '플레이트 서피스 버퍼 높이 오프셋',
      zkRotatePoint: '데이텀 점 회전하기',
      zkRotateDir: '회전 각도 증가 방향',
      restSizeLimit: '남은 치수',
      useSaw: '톱날 사용',
      unGenSawPath: '세로 톱날 가공 경로가 생성되지 않음',
      suitMachine: '전체 알루미늄 용접판 가공용',
      plankBack: '대판 뒷면',
      plankLeft: '널빤지 왼쪽',
      plankRight: '대판 오른쪽',
      plankFront: '널빤지 앞면',
      frontSide: '전면',
      backSide: '후면',
      rightSide: '오른쪽',
      leftSide: '왼쪽',
      singleMachineLimit: '단면 가공판 전면은 모서리 수정 경로를 생성하고 모서리를 먼저 수정합니다.',
      singleMachineLimitTip: '올인원 컴퓨터, 앤티앨리어싱 기능은 적용되지 않음',
      setBatchPositionWaring: '팁: 빠른 언더포인트 수정 모드를 취소하려면 오른쪽 언더포인트 수정 버튼의 선택을 취소합니다.',
      setBatchPosition: '다음 공구 점 대량 수정',
      setBatchPositionAs: '다음 공구 방향을 다음과 같이 수정합니다.',
      activeBatchPosition: '{activePartCount}개의 작은 보드가 선택되었습니다',
      specialFrontSide: '슬롯 분류에 설정된 특수 슬롯은 대판 전면에 우선적으로 배치됩니다.',
      rollCountTip: '구멍 슬롯 분류를 활성화한 후 조각기에서 실제로 가공한 후면 구멍 슬롯에 따라 리플리트 횟수를 계산합니다.',
      specialFrontSideTip: '현재 생산라인은 【구멍 슬롯 분류에 설정된 특수 구멍 슬롯은 대판 전면에 우선적으로 배치】 또는 【구멍 슬롯 분류 사용 후 실제 조각기에서 가공한 뒷면 구멍 슬롯에 따라 리메이크 횟수 계산】기능을 켜기 때문에 생산라인 전환을 지원하지 않습니다.',
      doubleTrim: '이중 패널 트림',
      trim: '테두리를 깎다',
      trimTwoSide: '양쪽을 고치다',
      trimFourSide: '사방을 수리하다',
      rightInmShow: '오른쪽 그림과 같이',
      currentTrimDir: '현재 선택된 모서리 수정 방향',
      cylinderTip: '실린더 위치 지정',
      onlyShort: '짧은 모서리만 다듬기',
      singleTrim: '단일 패널 모서리 수정 경로 생성',
      hierarchyCutTwice: '슬롯 밀링 슬롯 계층 컷',
      knifeDia: '공구 길이가 같음보다 작음',
      slotDeep: '슬롯 깊이가 같음',
      cutTwiceSlot: '경우 계층형 가공 슬롯',
      twiceSlotDeep: '두 번째 레벨 가공 깊이는',
      cutTwiceCondition: '가공 조건',
      zkPointCustomizeTip: 'xy 축 교환을 켜면 가공 방향과 데이텀 점이 반대가 됩니다.',
      zkPointCustomizeTip1: 'xy 축 교환을 켜는 장치에는 이 기능이 적용되지 않습니다.',
      isCustom: '사용자 정의 열기',
      useCutCon: '톱질 조건 사용',
      singleSetPlankSizeSpeed: '개별 보드 크기 범위 가공 속도 설정',
      singleSetPlankSizeSpeedTip: '(1. 아래 설정 치수를 만족하는 보드는 설정된 가공 속도에 따라 가공됩니다. 2. 보드가 여러 규칙을 동시에 만족하는 경우 최소 규칙 적용. 이 기능은 앤티앨리어싱에 적용되지 않습니다.)',
      addSpeedRules: '규칙 추가',
      speedRules: '규칙',
      shortSideSize: '짧은 모서리 치수',
      lessThanEqual: '보다 작음',
      and: '그리고',
      longSideSize: '긴 모서리 치수',
      processingSpeed: '가공 속도',
      trimLenCompensation: '모서리 길이 보정:',
      trimGenerateAPath: '수정 모서리 값이 0이면 경로가 생성되지 않습니다.',
      cuttingMethod: '절단 방식',
      horizontalCutting: '가로 절단',
      verticalCutting: '세로 절단',
      openKnifeDistance: '감속 거리'
      },
    labelingSettings: {
      title: '부착 설정',
      output: '자동 부착 파일 내보내기',
      specification: '맵 파일 형식',
      codeFrontGenerate: '자동 소스 코드가 스티커 코드 앞에 생성됨',
      templateOffline: '사용된 템플릿이 오프라인 상태입니다!',
      rollLabelling: '뒤집기 스티커 설정',
      flipSetting: {
        title: '뒤집기 설정',
        engravingFlipProcess: '조각기 뒤집기 가공 스티커 모드',
        flipTip: '조각기에서 뒤집기 가공이 필요할 때 이 기능을 사용합니다'
        },
      rotateSetting: {
        title: '레이블 회전 설정',
        rotateTip: '필요에 따라 회전 조건을 켜고 동시에 켜면 우선 적용 설정값 선택',
        horizontal: '판재 가로변',
        vertical: '판재 세로변',
        either: '판재 가로 혹은 세로 변'
        },
      countertopSetting: {
        title: '테이블 설정',
        startPoint: '작업 위치 시작점',
        upLeft: '왼쪽 위',
        upRight: '오른쪽 위',
        downLeft: '왼쪽 아래',
        downRight: '오른쪽 아래',
        baseExchange: '좌표 데이텀 조정',
        exchangeX: 'x축 조정',
        exchangeY: 'Y축 조정'
        },
      offset: '부착 좌표 오프셋',
      offsetTip: '일반 부착 좌표는 소판 중심에 있으며 일부 장치는 조정이 필요합니다.',
      label_rotate_offset: '태그 회전 후 좌표 오프셋',
      label_rotate_offset_tip: '레이블 회전의 앞뒤 오프셋 위치 차이가 클 경우 조정 필요',
      label_rotate_offset_err_tip: '레이블 회전 후 좌표 오프셋을 켜면 X 및 Y축 좌표 오프셋이 필요합니다.',
      imgSetting: {
        title: '맵 이미지 설정',
        suffix: '스티커 그림 접미사:',
        code: '그림 인코딩 방법:',
        codeTip: 'png, jpeg는 조판도 인코딩 형식을 동시에 수정하며, 내장 클라우드 조판은 당분간 이 기능을 지원하지 않습니다',
        imgRatio: '맵 이미지 해상도:',
        slowDown: '태그 그림 내보내기 효율성 저하',
        color: '진채',
        bit: '흑백',
        resolution: '맵 이미지 해상도',
        resolutionPlaceholder: '해상도',
        labelPool: '데이터 태그 풀',
        showKey: '디스플레이 필드',
        dragTip: '드래그 가능 태그 풀 내 태그',
        labelImgName: '스티커 이미지 이름',
        labelImgNameErrTip: '태그 그림 이름은 비워둘 수 없습니다.',
        labelTip1: '사용자 정의 시 [보드 바코드] 또는 [태그 번호] 중 하나를 사용해야 합니다. 그렇지 않으면 그림을 덮어쓰는 문제가 발생할 수 있습니다.',
        labelTip3: '【태그 일련번호】 는 재료 공급 순서에 따라 표지를 붙이다 페이지에 추가된 작은 판에는 이 데이터가 없습니다',
        labelTip2: '3. 이 기능은 어댑터 시스템 템플릿에 적용되지 않음',
        delimiter: '구분자',
        inputTip: '입력 /:? 이 (가) 지원되지 않습니다. < > | ."* 등의 문자',
        numStart: '태그 일련번호 시작 값',
        example: '사용자 지정 스티커 이미지 이름 (예)',
        stockNumOffset: '대시보드 번호 보상 자릿수',
        divideFolders: '태그 이미지는 보드에 따라 다른 폴더로 나뉩니다.',
        foldersTip1: '참고: 1. 이 기능은 [원료 공급기 파일 병합] 기능과 함께 사용할 수 없습니다.',
        foldersTip2: '2. 이 기능은 내장 클라우드 레이아웃에 아직 적용되지 않음',
        stickIntoFolders: '태그 파일을 해당 보드의 태그 이미지 폴더에 삽입합니다.',
        stickTip1: '참고: 1. 이 기능은 [NC 스트립 내보내기 태그 다운로드] 기능과 함께 사용해야 합니다.',
        stickTip2: '2. 사용된 스티커 템플릿의 파일 생성 규칙은 단일 파일 생성 기능을 선택해야 적용됩니다.',
        stickTip3: '3. 이 기능은 내장 클라우드 레이아웃에 아직 적용되지 않음'
        },
      pdfSetting: {
        title: '라벨 PDF 설정',
        pdfLabelName: 'PDF 파일 이름',
        example: '사용자 지정 PDF 파일 이름 (예시)',
        address: '프로젝트 주소',
        orderNo: '주문 번호',
        firstFolder: '첫 번째 폴더',
        customerName: '고객 이름'
        },
      paibanImgSetting: {
        title: '조판도 설정',
        tip: '사용자 지정 조판도 내보내기가 켜져 있습니다. 아래 고정 템플릿은 내보낼 수 없습니다. 내보내려면 조판 페이지의 더 많은 설정에서 사용자 지정 조판도 내보내기를 닫으십시오.',
        reparation: '조판 차트 번호 자동 보상',
        figure: '자리',
        inputTip: '1-99의 숫자를 입력하십시오.',
        paibanImg: {
          export: '조판도 내보내기',
          prefix: '조판 도명 접두사',
          size: '조판도 크기',
          format: '조판도 형식',
          directional: '조판도 방향',
          vertical: '세로 방향',
          horizontal: '가로'
          }
        },
      autolabel: '자동 부착 순서 설정',
      customTemp: '사용자 지정 템플릿에만 적용',
      cuttingLabelOder: '재료 공급 순서에 따라 표지를 붙이다.',
      labelToUp: '조판 결과에 따라 아래에서 위로 표지를 붙이다',
      labelToDown: '조판 결과에 따라 위에서 아래로 표지를 붙이다',
      labelDodge: '스티커 자동 회피',
      nolabelForsurplus: '나머지 대시보드는 부착 파일을 생성하지 않습니다.',
      settingValue: '설정 값 선택',
      enabelTip: '열면 보드가 다음 설정 값을 충족하면 레이블이 회전합니다.',
      fixedHori: '탭 가로를 선택하여 보드의 고정 모서리와 평행',
      fixedHoriTip: '텍스쳐 없는 보드에만 적용됩니다. 켜지면 태그가 태그 가로 및 보드 고정 모서리에 평행하게 회전합니다.',
      tagHori: '태그 가로변',
      effectiveTarget: '유효한 객체',
      allPlank: '모든 보드',
      notcarePlank: '텍스쳐 보드만 없음'
      },
    drillSettings: {
      title: '드릴링 설정',
      enable: '드릴링 패키지 활성화',
      toolTable: {
        use: '활성화',
        number2: '작업 위치 2열 드릴 번호',
        number: '드릴링 번호',
        diameter: '드릴 지름',
        xOffset: 'X 오프셋',
        yOffset: 'Y 오프셋',
        moveZF: 'Z축 빠른 이동 속도',
        feedRate: 'Z축 가공 속도',
        moveF: 'XY 축 빠른 이동 속도',
        benchmarkDrill: '데이텀 드릴',
        addKnife: '공구 추가',
        deleteKnife: '공구 삭제'
        },
      prefix: '드릴링 접두사',
      suffix: '드릴 접미어 정렬',
      startCode: '드릴링 부팅 코드',
      endCode: '드릴링 종료 코드',
      combineKnife: '드릴링 조합 언더핸드',
      combineTable: {
        prefix: '드릴링 번호 접두사',
        suffix: '드릴링 번호 접미어',
        mainHole: '주 구멍',
        extraHole: '구멍에서',
        notes: '주석 조합',
        firstUseNotes: '처음으로 주석 사용',
        addExtraHole: '종동체 구멍 추가',
        deleteExtraHole: '종동체 구멍 삭제',
        example: '예제'
        },
      tagPool: {
        drillRowNumber: '드릴링 번호'
        },
      processSetting: {
        title: '가공 설정',
        mode: '드릴링 가공 모드',
        processTip: '이 방식을 선택하면 드릴링 조합 하도 기능이 적용되지 않습니다',
        recentHole: '가까운 곳에서 펀치 (빠른 패스)',
        groupHole: '클래스별 구멍 뚫기 (일류 구멍 재교환 완료)',
        drill_benchmark: '결합된 언더핸드 데이텀',
        drill_benchmark_Tip: '(참고: 이 방법을 선택하면 드릴링 조합 하단 기능이 적용되지 않습니다.)',
        mainHole: '홈 구멍으로',
        secondaryHole: '종속 구멍 (꼬리 구멍)'
        },
      changeBenchDrillTip: '다이아 번호를 입력하고 선택하십시오.'
      },
    NCExportSettings: {
      jumpSkipTip2: '재료는 대시보드 색상, 두께에 따라 다른 폴더로 분류됩니다 (태그 부착 파일과 함께). 동일한 크기의 대시보드 원단 파일은 같은 폴더에 배치됩니다.',
      title: 'NC 내보내기 설정',
      tab1: '원료 공급기 파일 이름 설정',
      tab2: '원료 공급기 파일 이름 병합',
      tab3: '재료 공급 파일의 주석',
      tab4: '재료 공급기 파일의 유형',
      tab5: '원료 공급기 폴더',
      tab6: '가공 명령 설정',
      tab7: '파일 형식 설정',
      fileNameSettings: {
        twoStationAutoSort: '이중 비트 자동 정렬',
        reparation: '대시보드 번호 자릿수 보상',
        figure: '자리',
        labelerBegin: '레이블 시작',
        machineCenter: '머시닝 센터 시작',
        front: '전면:',
        back: '후면:',
        customizeName: '사용자 정의 파일 이름 (형식):',
        example: '사용자 정의 파일 이름 (예):',
        emptyTip: '양면 및 후면 파일 ID는 동시에 비워둘 수 없습니다.',
        labelPool: '데이터 태그 풀',
        dragTip: '탭 풀에서 탭을 드래그하거나 클릭하여 입력란에 탭 복사 가능'
        },
      fileMerge: {
        engravingMerge: '원료 공급기 파일 병합',
        zfMerge: '양면 및 후면 결합',
        singleMerge: '단일 작업 위치 병합',
        doubleMerge: '이중 비트 병합',
        fEndCode: '후면 끝 코드',
        zBeginCode: '전면 시작 코드',
        displayfbInfo: '파일 이름 양의 뒷면 정보 표시',
        fBeginCode: '후면 시작 코드',
        zEndCode: '전면 종료 코드'
        },
      marginalNotes: {
        addPlankInfo: '원본 파일의 시작 부분에 현재 대시보드 정보를 추가합니다.',
        plankInfo: '보드 정보:',
        addStationCodeFirst: '원단 파일의 시작 부분에 작업 위치 코드를 추가합니다.',
        addStationCodeSecond: '가공 코드를 추가하기 전에 재료 파일을 공구로 교체합니다.'
        },
      fileType: {
        zAddtion: 'Z 좌표 보충:',
        addSemicolon: '각 행 NC 끝에 세미콜론:',
        semicolonTip: '이 옵션을 선택하면 소뿔이 손잡이는 가공 파일도 적용됩니다.',
        fileName: '파일 이름',
        defaultName: '기본 파일 이름',
        dedicatedName: '별빛 장치 전용 파일 이름',
        xhNotes: '별빛 E2-9 주석',
        format: '조각기 파일 형식 내보내기',
        example: '파일 예: NC 파일',
        stillGenerate: '후면을 가공하지 않는 경우에도 후면 끝 코드가 있는 후면 NC 파일이 생성됩니다.',
        generateTip: '이 기능은 파일 병합 기능을 지원하지 않습니다.',
        fileNameErrTip: '파일 이름에는 다음 문자를 사용할 수 없습니다: /: *? "'
        },
      categorize: '대시보드 색상, 재료, 두께에 따라 다른 폴더로 분류합니다 (레이블 파일 포함).',
      simplifyG: '가공 G 명령 약어',
      ZToW: 'Z축에서 W축으로 코드 변경',
      knives: '드릴링 공구',
      lineBreakSetting: '줄 바꿈 형식 설정',
      codeFormatSetting: '파일 인코딩 형식 설정',
      utf8bom: 'bom 포함 UTF-8',
      oneCodeSetting: '보드 바코드 설정',
      simplifyOneCode: '간단한 형식 태그 바코드 생성',
      codeLocation: '코드 위치 설정',
      generateLocation: '작업 위치 종료 코드는 후면 종료 코드 앞에서 생성됩니다.',
      emergencySetting: '비상 설치',
      show: '비상 설정 표시',
      emergencyCode: '비상코드',
      params: '매개변수',
      emergencyTip: '판매 후 직원의 협조하에 임시로 일부 소규모 기능을 실현할 수 있다',
      holeSetting: '펀치 파일 설정',
      holeFileCategorize: '펀치 파일은 주문에 따라 폴더별로 개별적으로 배치됩니다.',
      holeTip: '내장 캐비닛 클라이언트에 대한 클라우드 레이아웃은 유효하지 않습니다.',
      specialCodeErr: '특수 문자 입력은 지원되지 않습니다!',
      copySuccess: '복제 성공!',
      copyErr: '복사에 실패했습니다. 탭을 드래그해 보십시오!',
      lengthLimit: '15비트 입력만 지원!',
      plankInfo: '보드 정보',
      otherInfo: '추가 정보',
      uniqueBarCode: '보드 바코드 고유',
      uniqueBarCodeForPack: '보드 바코드 고유 (패키지 전용)',
      machineOrder: '원본 파일 이름 가공 번호 생성',
      folderSetting: '동일한 크기의 대시보드 하단 파일을 같은 폴더에 배치',
      labelImageINCFolder: '맵 이미지는 맵 파일을 따라 NC 폴더에 배치됩니다.',
      custom: '커스터마이징',
      folderSettingTip: '참고: 인라인 레이아웃은 이 기능을 지원하지 않습니다.',
      settingMoveTip: '원래 "{func}" 기능은 "{module}" 페이지로 이동했습니다!',
      fileManagerFunction: '펀치 파일은 주문 파일별로 폴더별로 개별적으로 배치됩니다.',
      gotoSetting: '설정으로 이동',
      singleFileTitle: '개별 파일 만들기 설정',
      slectSingleProcess: '단독 출력 공정 선택',
      slectSingleProcessTip: '유료 2차 가공 공정이 남아 있습니다. 삭제 후 다시 저장하세요',
      setSingleRegularSize: '단독 출력 일반 홀/슬롯 치수 설정',
      holeRange: '홀 적용 범위',
      slotRange: '슬롯 적용 범위',
      holeRangeTip: '홀 적용 범위는 비워 둘 수 없습니다. 입력해 주세요!',
      slotRangeTip: '슬롯 적용 범위는 비워 둘 수 없습니다. 입력해 주세요!',
      yhzc: '원호 절곡부 직선 슬롯',
      xbgy: '경사 해당 코너 및 경사 손잡이',
      nbyx: '내부 이형',
      secondaryProcessingMerge: '2차 가공 파일 병합',
      secondaryProcessingMergeName: '병합 파일명',
      secondaryProcessingMergeTip: '사용 시 내보낸 판재에 2차 가공 공정이 여러 개 있으면 하나의 가공 파일로 병합됩니다',
      singleFileSetting: '개별 파일 머시닝 베고니아 코너 내보내기 및 베고니아 손잡이',
      straightArcSlot: '호 벤드 부분을 가공하는 별도의 파일을 내보내는 직선 슬롯'
      },
    aioMachineSetting: {
      openFunction: '도킹은 다음 기능을 켜야 합니다.',
      openCarving: '조각기를 켜다',
      xyReverseFunction: 'XY 축 교환 기능',
      carvingStartSet: '조각기 작업공간 시작점 설정',
      rightTop: '오른쪽 위',
      carvingEdgeSet: '조각기 전면 재수리 모서리 값은',
      finalEdgeSame: '총 트림된 모서리 값과 동일',
      beginCode: '프로그램 시작 코드',
      endCode: '프로그램 종료 코드',
      drillHole: '펀치',
      pullTrough: '슬롯을 당기다',
      showDataTemp: '데이터 샘플 표시',
      dataTemp: '데이터 샘플',
      title: '올인원 설정',
      outputFile: '올인원 머시닝 파일 내보내기',
      outputFileTips: '일부 브랜드의 올인원 컴퓨터는 XY 교환, 파일 병합, 이형 구멍을 뚫지 않는 것과 호환되지 않으므로 주의해서 사용하십시오',
      fileType: '파일 형식',
      select: '선택해 주세요',
      diameter: '모서리 고치기 공구 지름',
      jidongTip: '극동 복합기를 사용하려면 조각기 공위 시작점을 오른쪽 상단으로 설정하고 A 기능을 켜십시오',
      skill: '기능',
      clampHandLength: '클립 길이 (L)',
      clampHandWidth: '그립 너비 (W)',
      clampHandMargin1: '클립 1피치 모서리(H1)',
      clampHandMargin2: '클립 2피치 모서리(H2)',
      duchClampHand: '구멍 슬롯 피하기 클립 위치',
      clampHandDirection: '클립 방향',
      left: '왼쪽',
      right: '오른쪽',
      top: '위쪽',
      bottom: '아래쪽'
      },
    oneDragTwo: {
      title: '1 끌기 2 조각기',
      outputMachineFile: '1, 2, 조각기 가공 파일 내보내기',
      outputMachineFileTips: '1, 2, 조각기 사용 후 원료 공급기 파일 병합 기능과 호환되지 않으므로 주의해서 사용하십시오',
      fileType: '파일 형식',
      select: '선택해 주세요',
      machineStart: '작업 위치 시작점',
      positionClose: '닫으면 가공 매개변수의 가공 위치 시작점 설정이 따릅니다.',
      engravingPlus: '속조각기'
      },
    sawEngraving: {
      title: '톱질 조각기',
      preLayNav: '톱질 조각기 설치',
      preLayKnifeInput: '톱날 횡단 지름',
      enableSaw: '조각기 톱질 사용',
      sawAioTip: '용접판 일체형(AIO) 출력 권한이 없습니다. 사용을 원하시면 영업팀에 문의해 주세요.',
      cutSet: '용접판 가공 설정',
      weldingPlank: '용접판',
      doorFrame: '문 프레임',
      doorFrameTip1: '톱날 반지름은 톱날 두께보다 작거나 같아야 합니다',
      doorFrameTip2: '2.톱날 반지름은 톱날 두께보다 작거나 같아야 합니다 3.톱날 반지름은 톱날 두께보다 작거나 같아야 합니다',
      sawUsing: '톱날 용도',
      trim: '테두리를 깎다',
      cutBlank: '원단을 절단하다',
      backTrimOblique: '뒷면 테두리 깎기',
      holeSlotOblique: '테두리를 깎다',
      plankThicknessUnit: '판 두께 단위',
      sawUseCond: '톱날 사용 조건',
      exportPartData: '보드 데이터 파일 내보내기 (ban, mpr, xml 등)',
      sawAioTip2: '리플리케이션 없는 올인원',
      hasUsing: '사용 가능한 경로',
      onlyUse: '시재 사용',
      cutMethod: '절단 방식',
      oneKnifePull: '단칼에 널빤지를 꿰뚫다.',
      onlyOneKnifePull: '그때서야 단칼에 꿰뚫었다',
      enableSawThick: '앤티앨리어싱 두께 레이아웃 사용',
      edgedDir: '이미 봉하여 다시 자르지 못하는 큰 판자 모서리',
      sameWidthPart: '각 큰 판 에는 같은 너비 의 작은 판 만 늘어서 있다',
      emptyPath: '가공 시 빈 패스가 생성되지 않음',
      sawUsePlank: '용접판에서만 톱날을 사용하여 가공',
      paibanGap: '용접판 레이아웃 클리어런스',
      minSurplusWidthDiff: '최소 남은 재료 일치 너비 차이',
      minSurplusWidthDiffTip: '판자와 나머지 재료의 너비 차이가 이 값보다 작을 때만 나머지 재료에 배열됩니다.',
      sawReplaceEnable: '직봉 나무 절단 경로를 칼로 대체',
      minSawLength: '최소 거리로 칼로 대체',
      keepDistance: '직봉 나무 절단 경로에서 인접한 넓은 판자 사이의 거리 유지',
      keepDistanceTip: '주의: 인접한 판자에 잘리지 않도록 충분한 거리를 남겨야 합니다',
      sortByLength: '판재 길이에 따라 순서대로 조판하다.',
      sortByLengthTip: '절단 방향은 아래쪽에서 위쪽으로 순서대로 절단하고, 배열판은 먼저 너비에 따라 길이에 따라 배열한다',
      plankAtTop: '널빤지가 위에 있다',
      plankAtBottom: '작은 판자는 아래에 있다',
      useSawTipOne: '사용 가능한 경우 캐비닛의 용접판 속성에 있는 보드만 톱날을 사용하여 가공되고 비용접판은 직선으로 가공됩니다.',
      useSawTipTwo: '사용 후 사용자 정의 보드 레이아웃 순서를 사용할 경우 용접 보드는 표준 보드를 사용하지 않고 특수 보드만 사용됩니다.',
      useSaiTipThree: '이 기능이 활성화되면 배열 체계는 반드시 톱으로 배열을 잘라야 한다',
      surplusStoreAndLabeling: '절단 후 남은 재료는 입고와 라벨을 인쇄할 수 있다',
      surplusMinLength: '남은 재료의 최소 사용 가능한 길이',
      surplusMinSize: '남은 재료의 최소 사용 가능한 크기',
      crossCutOnlyMinSurplusSize: '남은 재료가 최소 사용 가능 크기를 충족해야 횡절 여분 경로가 생성됩니다',
      surplusStoreAndLabelingTip: '1. 대판 상단 또는 하단에는 파란색 여분 공간이 생성되며 이 여분 공간은 정상적으로 입고되고 라벨을 인쇄할 수 있다',
      surplusStoreAndLabelingTip2: '2. 용접판은"여분 재료 자동 재단"기능이 적용되지 않습니다.)',
      surplusStoreAndLabelingTip3: '(활성화 후',
      backCutSurplus: '뒷면에서 남은 재료를 절취하다.',
      cutSurplusTip: '활성화되면 뒷면 모서리 수정 순서를 뒷면 구멍 슬롯 머시닝 후 모서리 수정으로 설정합니다.',
      top: '위쪽',
      bottom: '아래',
      left: '왼쪽',
      right: '오른쪽',
      dockTip: '버트 용접 플레이트 가공을 위해서는 직사각형 플레이트의 네 모서리가 총 수리 모서리와 동일해야 하며, 수동으로 단열 레이아웃으로 조작해야 한다',
      sawToLayoutTip: '이 기능을 활성화한 후 레이아웃할 때 보드에는 톱날 두께와 같은 가공만 예약됩니다.',
      sawToLayoutTip2: '지정된 원단 공구는 조판 톱질에서 일시적으로 지원되지 않습니다.',
      tempPaiabanTip: '앤티앨리어싱을 활성화한 후에는 레이아웃에 직접 이형 플레이트를 추가할 수 없습니다. 추가하려면 커팅 리스트 추가 및 레이아웃으로 이동하십시오.',
      generateCutSurplusPath: '나머지 재료를 먼저 차단하는 횡단 경로 생성하기',
      curSurplusPathTip: '활성화되면 뒷면 모서리 수정 순서를 뒷면 구멍 슬롯 머시닝 후 모서리 수정으로 설정합니다.'
      },
    robotArmDocking: {
      autoLine: '자동 라인 연결',
      autoLineTip: '자동 라인 사용 권한이 없거나 열 수 있는 자동 라인 수가 부족합니다',
      title: '로봇 암 도킹',
      enable: '로봇 암 버트 사용',
      enableTip: '켜면 프로덕션 파일을 내보낼 때 로봇 암 버트 파일이 내보내집니다.'
      },
    laserCuttingMachine: {
      title: '레이저 올인원',
      enable: '레이저 올인원 사용',
      backSafeHeight: '뒷면 유휴 시 Z 높이(H)',
      laserDistance: '양면 / 후면 레이저 커터 가공 시 판재 표면과의 거리',
      coordinateAxis: '좌표축',
      xAxis: 'X',
      yAxis: 'Y',
      zAxis: 'Z',
      cuttingSettings: '가공 설정',
      backKnifeStore: '후면 라이브러리',
      noSupportOriginalMaterialKnife: '원본 원본 공구 선택 기능이 일시적으로 지원되지 않음',
      laserKnifeTip: '원단: 내부 뚫리지 않은 이형 가공에 사용',
      laserKnifeTip2: '레이저 나이프: 뚫린 구멍 슬롯, 내부 이형, 외부 프로파일 하단 가공',
      laserKnifeTip3: '참고: 후면 Z축은 기본적으로 테이블 거리에 해당하는 상대 좌표를 사용합니다.',
      laserKnifeTip4: '공구는 1 개 미만이어야 합니다.',
      laserKnifeTip5: '가공 공구는 삭제할 수 없습니다.',
      laserKnifeTip6: '공구가 없음 체크 오프닝이 감지되었으므로 하나 이상의 공구를 선택합니다.',
      laserKnifeTip7: '레이저 공구는 내부에 비침이 없는 이형을 가공할 수 없으며, 이미 자동으로 "재료 공급" 항목의 선택을 취소했다',
      laserKnifeTip8: '라이브러리에서 재료 공급 옵션의 공구를 선택하십시오. 그렇지 않으면 내부의 비투과 이형을 가공할 수 없습니다.',
      laserKnifeTip9: '원료 공급 칼 라이브러리 레이저 칼날과 레이저 올인원 레이저 칼날이 일치하지 않습니다. 검사하십시오.',
      laserKnifeTip10: '원료 공급 칼 창고의 원료 칼 지름과 레이저 일체형 기계의 원료 칼 지름이 일치하지 않으니, 검사해 주십시오',
      laserKnifeTip11: '장치 버트 매개 변수가 수정되었습니다. 다시 조판하십시오.',
      noLaserPermission: '레이저 올인원 사용 권한이 없습니다. 레이저 올인원 사용 권한을 구입한 후 사용하려면 판매에 문의하십시오.',
      laserOpenCode: '레이저 오픈 코드',
      laserCloseCode: '레이저 클로즈 코드',
      laserToolSettings: '레이저 도구 설정'
      },
    firstSave: '사용자가 클라우드 레이아웃을 처음 사용하는 것을 감지했습니다. 설정을 저장한 후 파일의 테두리 수정 방향이 합리적인지 주의하여 불필요한 손실을 피하십시오.',
    knives: {
      xOffset1: 'X 좌표 오프셋',
      yOffset1: 'Y 좌표 오프셋',
      zOffset1: 'Z 좌표 오프셋',
      insert: '행 삽입',
      delete: '행 삭제',
      tip: '(참고: 라이브러리 정보 수정 또는 설정 조정이 완료되면 캐비닛 레이아웃에서 생산되는 사용자는 캐비닛 클라이언트를 재부팅하여 최신 변경 사항을 적용해야 합니다!)',
      number: '번호',
      name: '이름',
      diameter: '칼 지름 Φ',
      sawDiameter: '톱날 두께 Φ',
      cutting: '절단',
      use: '용도',
      moveZF: 'Z축 빠른 이동 속도',
      axis_offset: '축 오프셋',
      arc_radius: '호 반지름',
      cutZF: 'Z축 가공 속도',
      moveF: 'XY 축 빠른 이동 속도',
      cutF: 'XY 축 가공 속도',
      startCode: '스왑 시작 코드',
      stopCode: '패스 종료 코드',
      startCode2: '작업 위치 2 스위치 시작 코드',
      stopCode2: '작업 위치 2 패스 종료 코드',
      knifeLength: '공구 길이',
      maximum_single_depth: '1회 최대 가공 깊이',
      specialShapeKnifeTip: '내부 이형에만 적용',
      preStartCode: '사전 부팅 코드',
      punchHoles: '펀치',
      pullSlots: '슬롯을 당기다',
      millHoles: '밀링 구멍',
      millSlots: '밀링 슬롯',
      sawBlade: '톱날',
      doubleSaw: '이중 비트 다른 패스 시작 코드 사용',
      singleStation: '단일 작업 공간',
      doubleStation: '이중 작업 비트',
      sawBladeTip: '이 기능은 1, 2, 조각기 및 올인원 장치에 적용되지 않습니다.',
      serialNum: '번호',
      sawWidth: '칼 너비',
      sawType: '톱날 유형',
      cutDirection: '가공 방향',
      moveSpeed: '헛걸음 속도',
      cutSpeed: '가공 속도',
      endCode: '패스 종료 코드',
      sawDownCode: '언더핸드 코드',
      sawUpCode: '수신 코드',
      abscissa: '가로 좌표 접두사',
      ordinate: '누진 접두사',
      sawHor: '횡단 톱날',
      sawVer: '세로 톱날',
      towardsZero: '0점 좌표로 가공하기',
      awayFromZero: '0점 좌표 컷 멀리하기',
      diameterDesc: '칼 지름 Φ',
      xOffset: '가로 좌표 오프셋',
      yOffset: '세로 좌표 오프셋',
      zOffset: '승강 좌표 오프셋',
      offsetX: '오프셋 X',
      offsetY: 'Y 오프셋',
      offsetZ: '오프셋 Z',
      offsetNo: '오프셋 번호',
      knifeWidth: '칼폭',
      drill: '칼을 빼다',
      cut: '가공',
      speed: '회전 속도',
      type: '유형',
      millHoleSlot: '밀링 구멍 / 슬롯',
      rapidFeedSpeed: '빠른 이송 속도',
      typeOption1: '드릴',
      typeOption2: '밀링 커터',
      typeOption3: '조형칼',
      typeTip: '공구 유형을 설정하면 구멍 슬롯이 해당 유형의 공구와 일치하여 가공됩니다.'
      },
    other: {
      title: '기타',
      tip: '(참고: 단일 작업 비트 장치는 작업 비트 1과 작업 비트 2를 동일한 자동 공급 코드로 채워야 합니다.)'
      }
    },
  sideHoleMachine: {
    moreSetting: '추가 설정',
    sideStartCode: '정면 가공 생성 환면 코드',
    useArcCode: '호 보간 명령 절단 호형',
    coordSwitch: '좌표 데이텀 조정',
    updownCoordSwitch: '승강 좌표 데이텀 쌍',
    xCoordSwitch: '가로 좌표 데이텀 조정',
    yCoordSwitch: '수직 좌표 데이텀 조정',
    knifes: {
      number: '번호',
      diameter: '칼폭',
      type: '유형',
      moveSpeed: '빠른 이송 속도',
      doSpeed: '가공 속도',
      startCode: '스왑 시작 코드',
      endCode: '패스 종료 코드'
      },
    ymSetting: '나무 연결 설정',
    flanking: '측면 가공',
    frontProcess: '전면 가공',
    oldSetting: '레거시 설정',
    equipParamsSetting: '장치 매개 변수 설정',
    holeSetting: '펀치 설정',
    raminoSetting: '라미노 연결 설정',
    mortiseTenonSetting: '장부 연결 설정',
    straight: '직불',
    eccentric: '편파적인 돈',
    pbSize: '상하 파판 크기',
    slotOverlapRate: '밀링 슬롯 중첩률',
    breakingBoardDirection: '상하 파판 방향',
    coordinateValue: '좌표값',
    codeFormat: '파일 인코딩 형식',
    suffixSetting: '파일 접미어 설정',
    insertRow: '행 삽입',
    deleteRow: '행 삭제',
    equipmentParams: {
      equipPauseCode: '장치 일시 중지 코드',
      wiggleCode: '스윙 코드',
      equipStartCode: '장치 부트 코드',
      flipPauseCode: '뒤집기 일시정지 코드',
      equipEndCode: '장치 종료 코드',
      equipStartCodePlaceholder: '장치 부트 코드 입력',
      retractingCode: '수신 명령 코드',
      retractingCodePlaceholder: '수신 명령 코드 입력',
      flipPauseCodePlaceholder: '뒤집기 일시정지 코드 입력',
      equipEndCodeTip: '장치 종료 코드 입력',
      sideChangeSetting: '측면 면 변환 설정',
      workTip: '기본값은 왼쪽 ①부터 반시계 방향으로 가공',
      frontTurnCode: '위 시작 코드',
      frontTurnEndCode: '위 끝 코드',
      frontTurnCodePlaceholder: '위 시작 코드 입력',
      frontTurnEndCodePlaceholder: '위 종료 코드 입력',
      leftTurnCode: '왼쪽 시작 코드',
      leftTurnEndCode: '왼쪽 끝 코드',
      leftTurnCodePlaceholder: '왼쪽 시작 코드 입력',
      leftTurnEndCodePlaceholder: '왼쪽 끝 코드 입력',
      downTurnCode: '다음 시작 코드',
      downTurnEndCode: '다음 종료 코드',
      downTurnCodePlaceholder: '다음 시작 코드 입력',
      downTurnEndCodePlaceholder: '다음 종료 코드 입력',
      rightTurnCode: '오른쪽 시작 코드',
      rightTurnEndCode: '오른쪽 끝 코드',
      rightTurnCodePlaceholder: '오른쪽 시작 코드 입력',
      rightTurnEndCodePlaceholder: '오른쪽 끝 코드 입력',
      topFlipCode: '뒤집기 코드. - 위.',
      downFlipCode: '코드 뒤집기 - 아래',
      leftFlipCode: '뒤집기 코드 - 왼쪽',
      rightFlipCode: '뒤집기 코드 - 오른쪽',
      cylinderOutCode: '실린더 출시 코드',
      cylinderbackCode: '실린더 회수 코드',
      cylinderbackDirective: '실린더 회수 명령',
      moveDirective: '이동 명령',
      moveAxisCode: '축 이동',
      pushAxisCode: '실린더 추진축',
      swingAxisCode: '진동축',
      moveCode: '코드 이동',
      punchCode: '가공 코드',
      free: '헛걸음',
      punchPart: '가공 부분',
      cutFaceCode: '가공 평면 코드',
      horVerCutFace: '가로 세로 평면',
      horCutFace: '가로 리프트 평면',
      verCutFace: '수직 승강 평면',
      specifySmallBoardMaterialNoCut: '판넬 재료가 재료가 들어가지 않도록 지정',
      specifySmallBoardMaterialNoCutTip: '판재 재료에 해당하는 키워드가 포함된 판재는 5, 6면 드릴로 가공된 구멍 슬롯 파일만 생성되며 재료를 넣지 않습니다.',
      addMaterialKeyword: '재료 키워드 추가',
      keyword: '키워드'
      },
    tagPool: '데이터 태그 풀',
    dragTip: '드래그 가능 태그 풀 내 태그',
    knives: '가공 공구:',
    directives: '가공 명령:',
    slot: '직선 슬롯 가공',
    cirWork: '호 가공',
    cirInter: '호 보간',
    cirOption1: '시계 방향: G03 반시계 방향: G02',
    cirOption2: '시계 방향: G02 반시계 방향: G03',
    coordinate: {
      xPointSymbol: '가로 좌표:',
      yPointSymbol: '세로 좌표:',
      zPointSymbol: '승강 좌표:',
      upright: '양수 값',
      negative: '음수 값'
      },
    encodeFormat: {
      format: '파일 인코딩 형식:',
      wrap: '줄 바꿈 형식:',
      formatOption1: 'UTF-8 형식',
      formatOption2: 'ANSI 형식'
      },
    suffix: '파일 접미어 설정:',
    enableFP: '전면 머시닝 사용',
    slotSetting: '슬롯 설정',
    slotMillSetting: '슬롯 / 밀링 구멍 밀링 슬롯 설정',
    millSlot: '밀링 구멍 밀링 슬롯 지원',
    millingSlotOverlapRate: '밀링 슬롯 중첩률',
    millingHoleSlotOverlapRate: '밀링 구멍 밀링 슬롯 중첩률',
    takeUpDirective: '칼을 거두는 명령',
    workSeparately: '양면 / 후면 슬롯은 두 세그먼트로 가공됩니다.',
    secondSlotLong: '두 번째 슬롯 길이',
    enableOld: '이전 버전의 측면 구멍 기계 설정 사용',
    default: '기본 설정',
    customizable1: '사용자 정의 1',
    customizable2: '사용자 정의 2',
    customizable3: '사용자 지정 3',
    customizable4: '사용자 지정 4',
    knifeSetting: '공구 설정',
    soltTip: '(밀링 구멍 / 슬롯 포함)',
    specialSetting: '특수 설정',
    ramino: '라미노',
    sun: '장부',
    please: '기대해 주세요',
    designatedKnives: '지정된 칼',
    designated: '지정',
    workOrder: '머시닝 명령',
    other: '기타',
    nameSetting: '접미어 이름 설정',
    repeatErr: '번호가 반복됩니다. 다시 설정하십시오.'
    },
  electronicSaw: {
    importMaterial: '원단 가져오기',
    formSetting: '전자 톱 양식 설정',
    fileFormat: '출력 커팅 리스트 파일 형식:',
    isSmallFile: '보드 그림 파일을 내보내려면 다음과 같이 하십시오.',
    fileGroupRule: '전자톱 파일은 색상, 재료, 두께에 따라 테이블을 다릅니다.',
    roomsByCategory: '전자 톱 파일은 공간에 따라 다른 테이블로 나뉩니다.',
    delimiter: '구분자:',
    fileName: '커팅 리스트 파일 이름:',
    fineNameTip: '커팅 리스트 파일 이름은 비워둘 수 없습니다.',
    fileNamePlaceholder: '사용자 정의 커팅 리스트',
    outputFileEncoding: '출력 인벤토리 인코딩 형식:',
    utf8: 'UTF-8 및 BOM',
    cellTab: '셀 탭을 생성하려면 다음과 같이 하십시오.',
    texture: '텍스쳐 표현:',
    special: '이형 표현:',
    notSpecial: '이형이 아니다',
    genSimpleLabelBarcode: '간단한 형식 태그 바코드 생성',
    uniqueBarCode: '보드 바코드 고유',
    uniqueBarCodeTip: '오픈 후 간이 형식 태그 바코드 생성 기능이 적용되지 않음',
    roboticArmDocking: '로봇 암 도킹',
    customeForm: '사용자 지정 양식',
    tagPool: '데이터 태그 풀',
    tagPoolTips: '태그 풀의 태그를 드래그하거나 클릭하여 복사할 수 있습니다.',
    displayHead: '머리글 표시 안 함',
    addTableHead: '헤더 추가',
    deleteTableHead: '헤더 삭제',
    generateExample: '출력 양식 샘플 생성하기',
    importExample: '양식 샘플 가져오기',
    importExampleTip: '사용자 정의 전자 톱에서만 참조할 수 있는 가져온 양식 예제',
    importExampleErrTip: '아직 원단을 가져오지 않았습니다. 원단을 가져오십시오.',
    outputExample: '샘플 출력 양식',
    outputExampleTip: '사용자 정의 양식의 출력 예제',
    outputExampleErrTip: '출력 양식 샘플이 생성되지 않았습니다. 출력 양식 샘플을 생성하십시오.',
    defaultTableHead: '기본 헤더',
    deleteHeadErrTip: '삭제할 수 있는 헤더가 없습니다!',
    genNonString: '텍스트 형식이 아닌 데이터 형식 생성하기',
    genNonStringTip: '생성된 테이블 데이터 전자톱이 인식되지 않을 경우 사용 가능',
    revertWidth: '가로무늬 판재 너비 조정'
    },
  lockModal: {
    passwordInput: '비밀번호를 입력하세요',
    lockPassword: '잠금 암호',
    lockPasswordInput: '잠금 해제 암호를 입력하십시오.',
    passwordInputPlaceholder: '네 자리 비밀번호를 입력하십시오.',
    editPassword: '암호 수정',
    confirmPassword: '암호 확인',
    setLockPwd: '잠금 해제 암호 설정',
    pwdFormatErr: '암호 형식 오류',
    sendMessageTo: '문자 인증 코드가 다음으로 전송됩니다.',
    captchaPlaceholder: '인증 코드를 입력하십시오.',
    sendCaptcha: '인증 코드 보내기',
    sendSeccess: '문자 발송 성공',
    sendFail: '문자 발송 실패, 나중에 다시 시도하십시오.',
    updateSeccess: '암호 설정 성공',
    editSuccess: '암호 수정 성공',
    lockSeccess: '잠금 해제 성공',
    lock: '잠금 해제',
    lockSeccessTip: '잠금 성공',
    inputErrLimit: '현재 오류 횟수가 제한되었습니다. 잠금 해제 비밀번호를 다시 설정하십시오!'
    },
  dock56Drill: {
    equipType: '장비 유형',
    equipment: '장비',
    fiveDock: '오면드릴',
    sixDock: '육면드릴',
    fileType: '파일 유형 생성',
    templateOffline: '사용된 템플릿이 오프라인 상태입니다!',
    showExample: '데이터 샘플 표시',
    conNoticeTip: '도킹 고려 사항:',
    conNoticeTip1: '1,"XY축 교환"이 활성화된 조각기는 조각기에서 "구멍과 슬롯 가공 장치 자동 적응 교환" 기능을 활성화해야 합니다.',
    conNoticeTip2: '2. 5, 6면 드릴에 판재 이형 부분을 표시하거나 가공하려면 템플릿에 이형 부분을 배치해야 하는 데이터',
    conNoticeTip3: '3. 5, 6면 드릴을 처음 사용하거나 템플릿을 교체한 후 <span style="color:#f00">을 사용하여 캐비닛 시험 생산</span>을 진행하고, 오류가 없음을 확인한 후 일반 생산을 진행하십시오.',
    conNoticeTip4: '4. 시험 생산 시 양면 슬롯의 크기, 깊이, 소재 및 위치가 정확한지 자세히 검사하십시오. <span style="color:#f00">캐비닛 미러링 </span>의 문제가 발생하지 않도록 합니다.',
    example: '데이터 샘플',
    commonSetting: '일반 매개변수 설정',
    throughHoleSetting: '구멍 뚫기 양면으로 나누기',
    throughSlotSetting: '슬롯을 양면으로 나누어 뚫다',
    nonHolesNotFiles: '직사각형 보드에 구멍 슬롯이 없으면 파일을 내보내지 않습니다.',
    frontFileIdentifier: '정면 파일 ID:',
    oppositeFileIdentifier: '뒷면 파일 ID:',
    oppositeFileIdentifierTips: '생성 방식: 원래 13비트 보드 인코딩 + 식별 문자',
    arcDescription: '호 설명 방법',
    linePoints: '세그먼트 형 설명',
    arcCommand: '호 명령 설명',
    slotWidthSplit: '와이드 슬롯을 여러 개의 좁은 슬롯 머시닝으로 분해합니다.',
    slotSplitWidth: '분해 후 단일 슬롯 너비:',
    mm: '참고: 분해 객체는 일반 사각형 슬롯입니다.',
    isNotMergeSlot: '인접한 등폭 등심조 당김 처리:',
    slotPunchTip: '이 기능은 사용자 정의 템플릿을 사용하는 후면판 슬롯 및 서랍 바닥판 슬롯에만 적용됩니다.',
    sizeRange: '인접 치수가 같음보다 작음',
    enableWorningTip: '이 기능은 전면 모서리 배치 방향과 동시에 켜지지 않음',
    longDirection: '판재 장변 배치 방향',
    horizontal: '가로',
    vertical: '세로',
    slotDirection: '5 / 6면 드릴링 또는 이형 배치 방향',
    default: '시스템 기본',
    frontLeft: '전면 및 왼쪽',
    frontRight: '전면 및 오른쪽',
    backLeft: '후면 및 왼쪽',
    backRight: '후면 및 오른쪽',
    frontDirection: '전면 모서리 배치 방향',
    enableTip: '참고: 클라우드 레이아웃에만 적용',
    fixedOn: '고정 위치:',
    front: '앞쪽',
    back: '뒤쪽',
    left: '왼쪽',
    right: '오른쪽',
    coordinateValue: '좌표값 예약된 자릿수:',
    decimalPlaces: '자리',
    slotLengthCompensation: '슬롯 길이 보상',
    curveholesLengthCompensation: '내부 이형 청각',
    slotCompensationEqualZero: '슬롯 모서리에 대한 피치 0의 보정',
    slotCompensationNotEqualZero: '슬롯 모서리에서 0이 아닌 경우 모서리 보정',
    slotCompensationTip: '이 기능은 가공에서 잘리지 않은 작은 필렛이나 길이가 부족한 경우 사용됩니다.',
    curveholesCompensationEqualZero: '오프셋 모서리가 0인 내부 이형 모서리 보정',
    curveholesCompensationTip: '권장 입력: 밀링 내부 이형 공구의 반지름 값',
    curveholesCompensationTip2: '이 기능은 판넬 외곽선 직사각형 모서리에서 가공된 내부 이형에 잘리지 않은 작은 필렛이 나타나는 경우에 사용됩니다.',
    specialParameter: '특수 매개변수 설정',
    output5FDrillSlotKnifeCode: 'XML2 밀링 슬롯 공구 번호',
    output5FDrillShapeKnifeCode: 'XML2 밀링 공구 번호',
    plankTexture: 'XML2 보드 텍스쳐',
    offset: 'XML2 밀링 공구 보정',
    mprConHoleDir: '5 / 6면 드릴링 MPR 파일 측면 구멍 Z 좌표 데이텀 면',
    plankTop: '판재 상단면',
    plankBottom: '플레이트 부품 하단 서피스',
    codeInfo: 'ban 형식 파일에는 Code 정보가 포함되어 있습니다.',
    bomFile: 'bom 형식 파일을 내보내려면 다음과 같이 하십시오.',
    plankHeight: '보드 높이 설명:',
    plankNum: '보드 번호 설명:',
    backZpoint: '리버스 슬롯 Z 좌표:',
    plankThick: '판 두께',
    slotDeep: '슬롯 깊이',
    outputMprFile: '파일 유형',
    oldMPR: '구형 MPR',
    newMPR: '새로운 MPR',
    mprFileZside: '5 / 6면 드릴링 MPR 파일 측면 구멍 Z 좌표 데이텀 면',
    fileTypeOffline: '현재 선택한 5, 6면 드릴 파일 형식이 오프라인 상태입니다. 확인하세요!',
    permissionErr: '신원 정보가 분실되었습니다. 이 페이지를 캐비닛에서 다시 열어 주십시오!',
    banFileSetting: 'ban 형식 파일 설정',
    banFileCodeInfo: 'ban 형식 파일에는 Code 정보가 포함되어 있습니다.',
    huahuaLine: '자작나무 자동선',
    huahuaLineTip: '(라벨 배치 기준과 호환되지 않음)',
    huahuaPartFlag: {
      longSide: '길이가 작음',
      shortSide: '또는 짧은 모서리가',
      partFlag: '의 보드 부품에 대한 작은 보드 ID 생성',
      tip: '(라벨에 표시된 내용은"판재 표식-소판 표식"데이터를 추가해야 하며 자작나무 자동선 파일에는 자동으로 해당 데이터가 추가된다.)'
      },
    plankPutWay: '판재 배치 방식',
    plankPutWayTip: '현재 생산 라인이 활성화되어 있으면 판재 배치 방식 설정이 지원되지 않습니다',
    autoHandle: '자동으로 클립 피하기',
    manualHandle: '수동으로 회피 설정',
    fixedFront: '전면 모서리 고정',
    plankNamePlacement: '판재명 지정 배치',
    plankNamePlacementTip1: '1. 설정 후 판재명에 지정한 필드가 포함되면, 해당 판재의 대응 모서리가 설정에 따라 장비의 지정 측에 고정됩니다',
    plankNamePlacementTip2: '2. 이 설정의 우선순위는 위의 판재 배치 방식 설정보다 높습니다',
    plankNamePlacementTip3: '3. 이 기능은 클라우드 배치에만 적용되며, 현재 생산 라인에서 Huahua 자동라인이 켜져 있으면 판재 배치 방식을 따로 설정할 수 없습니다',
    addRow: '행 추가',
    plankNameTip: '판재 이름을 입력해주세요',
    plankSide: '판재 모서리',
    deviceSide: '장비에 고정',
    weldingPlatePlacementEnable: '웨이딩 보드 원면 고정 클립',
    onlyBluen: '클라우드 레이아웃에만 적용',
    fixedEdge: '전면 모서리 고정',
    fixedEdgeRule: '규칙: 판재의 배치를 결정',
    fixedEdgeRuleItem1: '긴 변이 클립에 가까움',
    fixedEdgeRuleItem2: '클립 옆 모서리 고정',
    fixedEdgeRuleItem3: '클립 옆 모서리 고정',
    fixedEdgeRuleItem4: '우선순위',
    satisfiedCondition: '조건 충족',
    handDirection: '클립이 있는 방향',
    handleMachineTip: '회전 방식을 통해 구멍 슬롯과 이형이 자동으로 클립의 위치를 피하여 판재 가공을 편리하게 한다',
    handleWidth: '클립 너비',
    handleLength: '클립 길이',
    handleMaxWidth: '장비 가공 가능 최대 너비',
    usefulRange: '적용 범위',
    plankLongSide: '보드 부품 긴 모서리',
    usefulRangeTip: '슬롯 및 이형의 배치 위치는 슬롯 및 이형의 배치 위치를 결정하기 위해 슬롯의 긴 모서리를 열어 놓습니다.',
    moveTip: '양면 및 후면 파일 식별 기능이 마이그레이션됨',
    millingOuter: '외이형 밀링',
    millingInner: '밀링 내부 이형',
    drilling: '구멍 가공하기',
    slotting: '가공 슬롯',
    knivesTip1: '1. 밀링 이형 공구 설정 후 가공 경로는 공구 반지름을 보상합니다.',
    knivesTip2: '2. 이형 절단은 xy축 교환을 지원하지 않는 조각기',
    internalCutting: '내부 이형 가공 하부 및 커터 모두 보드 내부에 있음',
    externalCutting: '외부 이형 가공 하단 및 커터 모두 보드 부품 바깥쪽에 있음',
    externalCuttingDirection: '외부 이형 컷에서는 이형이 포함된 전체 모서리가 동시에 컷됩니다.',
    allExternalCutting: '모든 외이형',
    onlyArcExternalCutting: '외부 호 이형만'
    },
  doorWallCabinet: {
    tempErrTip: '문-벽-장 일체형 기계에 사용할 템플릿이 추가되지 않아 가공 파일을 내보낼 수 없습니다. 참고: 추가 완료 후 다시 배치해야 합니다.',
    title: '벽과 장롱을 만드는 기계',
    guifang: '정사각형화',
    processingTechnology: '처리 기술',
    longPlateSecondarySquaring: '긴 판 이차 정사각형화',
    slotOnDoorPlate: '문 판 위의 구멍',
    setting: '벽과 장롱을 만드는 기계 설정'
    },
  PTP: {
    title: 'PTP',
    outputFileFormat: '출력 파일 형식',
    outputDefaultFileFormat: '기본 형식 파일 내보내기',
    outputMPRFormat: 'PR 형식 파일 내보내기',
    fileFormatSettings: '파일 형식 설정',
    wrapSettings: '줄 바꿈 형식:',
    enCodeSettings: '파일 인코딩 형식 설정:',
    utf8bom: 'bom 포함 UTF-8',
    partCoordinate: '소판 좌표',
    xPointSymbol: '가로 좌표:',
    yPointSymbol: '세로 좌표:',
    zPointSymbol: '승강 좌표:',
    upRight: '양수 값',
    negative: '음수 값',
    plankMirroring: '보드 대칭복사',
    plankMirrorSetting: '보드 부품 대칭복사 설정:',
    xAxis: 'X축 대칭복사',
    yAxis: 'Y축 대칭복사',
    mirrorTip: '(보드를 대칭복사할 때 이 기능 사용)',
    knifeTable: {
      type: '유형',
      diameter: '지름 Φ',
      offsetX: '오프셋 X',
      offsetY: 'Y 오프셋',
      offsetZ: '오프셋 Z',
      offsetNo: '오프셋 번호',
      drillVelocity: '내려치기 [F]mm/min',
      cutVelocity: '가공 [F]mm/min',
      rotationSeep: '회전 속도 [S]r/min',
      insertRow: '행 삽입',
      deleteRow: '행 삭제'
      },
    labelPool: '데이터 태그 풀',
    dragTip: '탭 풀에서 탭을 드래그하거나 클릭하여 입력란에 탭 복사 가능',
    procedure: '프로그램',
    beginCode: '프로그램 시작 코드:',
    endCode: '프로그램 종료 코드:',
    zzdKnifeBeginCode: '스핀들 스왑 시작 코드:',
    spindleCutter: '스핀들 나이프',
    zzdKnifeEndCode: '스핀들 스왑 종료 코드:',
    verticalDrill: '수직 드릴',
    czzBeginCode: '수직 드릴 부팅 코드:',
    czzEndCode: '수직 드릴 종료 코드:',
    czzKnifeBeginCode: '수직 드릴 패스 시작 코드:',
    czzKnifeEndCode: '수직 드릴 끝 코드:',
    sidetrack: '사이드 드릴',
    czBeginCode: '사이드 드릴 부트 코드:',
    czEndCode: '사이드 드릴 종료 코드:',
    czKnifeBeginCode: '사이드 드릴 교환기 시작 코드:',
    czKnifeEndCode: '측면 드릴 패스 종료 코드:',
    pauseCode: '코드 일시정지:',
    zSafeHeight: '안전 거리',
    spindleKnife: '스핀들 및 수직 드릴 Z축 안전 높이',
    sideDrillZ: '측면 드릴 Z축 안전 높이',
    sideDrillXY: '측면 드릴X/Y축 안전거리',
    auxiliaryFunction: '보조 기능',
    xhDedicatedInfo: '별빛 장치 전용 정보 생성',
    xhCheckBox: '데이터:',
    outputSettings: '출력 설정:',
    partExegesis: '파일에 작은 보드 치수 주석 생성하기',
    knifeNo: '공구 번호',
    specailKnifeNo: '머시닝 이형 공구 번호:',
    slotKnifeNo: '슬롯 공구 번호:',
    fileNamePlaceholder: '사용자 정의 커팅 리스트',
    slotDrill: '스트레이트 나이프'
    },
  glassEquip: {
    title: '유리 절단기',
    fileType: '가공 파일 유형:',
    sizeReparation: '판재 사이즈 보상:',
    cutPreSpace: '보드 부품 가공 예약 간격:',
    divideIntoFolders: '유리 색상, 재료, 두께에 따라 다른 폴더로 분류:'
    },
  translate: {
    search: '중국어 또는 공식 번역을 입력하여 단어를 찾으십시오.',
    en: '영어',
    es: '스페인어',
    ar: '아랍어',
    kz: '카자흐어',
    vi: '베트남어',
    th: '태국어',
    id: '인도네시아어',
    ug: '위구르어',
    customTranslate: '사용자 정의 번역을 추가하려면 클릭하십시오.',
    customText: '사용자 정의 번역',
    text: '중국어',
    targetLang: '공식 번역',
    zh_hant: '중국어 번체'
    },
  preLayoutSetting: {
    title: '사전 조판 설정',
    titleTip: '먼저 조판 파라미터를 미리 설정하고, 먼저 조판하고, 후에 생산 라인을 선택할 수 있다',
    settingTip: '생산 라인 내에 설정된 매개변수는 다음 사전 조판 매개변수와 일치해야 생산 파일을 출력할 수 있으며 원료 공급기에만 적용됩니다.',
    emptyKnife: '공구가 채워지지 않았습니다.',
    noModify: '설정을 수정하지 않고 저장할 필요 없음',
    reSet: '복원',
    gayPosition: '회색 네모난 블록은 여분의 재료 배치 위치를 전환할 수 있다',
    surplusPosition: '현재 남은 재료의 배치 위치',
    click: '클릭',
    grayStart: '회색 사각형은 가공 위치의 시작점을 전환합니다.',
    currentStart: '현재 작업공간 시작점',
    holeSlotSetting: '구멍 뚫기 슬롯 가공 설정',
    knifeDiameter: '커터 지름',
    currentVersion: '현재 버전',
    on: '오픈',
    off: '닫기',
    firstShort: '첫 번째 컷 - 짧은 모서리 배치',
    firstLong: '첫 번째 컷 - 긴 모서리 배치',
    cuttingSplitLong: '장판을 두 번에 걸쳐 절단합니다. - 긴 모서리 초과.',
    cuttingSplitShort: '장판을 두 번에 걸쳐 절단 - 짧은 모서리 초과',
    plankThick: '일반 보드 두께 ≥',
    singleDoorThick: '문짝 두께 ≥ ',
    normalPlank: '일반 보드',
    confilictTip: '설정 충돌이 있습니다: {confilictTotal}개',
    selectLine: '생산 라인 선택',
    selectLinePlaceholder: '생산 라인을 선택하십시오.',
    lineConfilictTip: '선택한 생산 라인과 {line}이 충돌합니다',
    preWay: '사전 조판 시나리오',
    paibanErrTip: '장판 가공의 [장, 단변 방량]에 변화가 있을 경우, 조판 실패를 초래할 수 있다',
    paibanTip: '이번 조판에는 대판 재질 지정 원료 칼이 존재하므로 다시 조판해야 한다',
    reLayout: '현재 생산 라인으로 재조판',
    fetchErr: '사전 조판 설정 가져오기 실패',
    resetSuccess: '복원 성공',
    resetConfirm: '역사 버전으로 복원하시겠습니까?',
    prolineName: '라인 이름',
    layoutGap: '조판 간격',
    generalThickness: '2차 가공 객체 - 일반 보드 두께',
    cutGeneralPlank: '2차 가공 객체 - 일반 보드',
    cutSingleDoor: '2차 컷 객체 - 도어 패널',
    secondary_cutting_board_list: '보드 이름 가공판 부품 이름 목록 지정',
    changeProline: '생산 라인 전환',
    backTip: '글로벌 조판으로 돌아가 생산라인을 선택하십시오.',
    preLayout: '사전 조판 체계에 따라 조판하다.',
    preWayEmpty: '(비어 있음) 사전 조판 체계',
    specialConfilictTip: '호 밀링 베이스 프로세스는 레이아웃 결과에 영향을 미치므로 다시 레이아웃해야 합니다.'
    },
  lunbo: {
    tips: '조작 팁',
    introduction: '기능 소개',
    qtDownloadText: '따뜻한 힌트: 만약 다운로드 파일이 완전하지 않은 상황이 발생하면, 클라우드 조판 웹 페이지로 가서 다운로드하세요!'
    },
  sendModal: {
    paibanImgType: '조판도 파일 유형'
    },
  authenticationModal: {
    title: '스캔 인증',
    tip: '허가가 성공하기 전에 탄창을 닫지 마십시오!',
    countdownTip: '{countdown} 후 만료',
    refreshTip: 'QR코드 새로 고침',
    qrcodeTip: '위챗으로 코드를 스캔하여 조작을 완성하십시오.',
    qrcodeTip2: '스캔 저장에 실패하면 캐비닛 일반 설정 - 사용자 인증 설정에서 시스템을 수정할 수 있는 권한을 부여해야 합니다.',
    waiting: '스캔 대기 중',
    scanning: '코드 스캔, 확인 대기 중',
    success: '인증 성공',
    error: '검증 실패',
    expired: 'QR코드가 만료되었습니다.',
    tip2: '귀하의 계정 데이터의 안전을 위해 현재 운영자 정보를 검증해야 합니다',
    tip3: '시험 생산을 위한 캐비닛은, {fontStyleStart}비대칭적이어야 하며, 캐비닛 반사 문제를 피하기 위해{fontStyleEnd}'
    },
  printTag: {
    dualLanguageTip: '중영 이중 언어 라벨 생성 권한이 없습니다. 현재는 미리보기만 가능합니다. 정식 사용이 필요하면 영업팀에 문의해 주세요~',
    generateDualLanguageTagTip: '중영 이중 언어 라벨 생성',
    dualLanguageTip2: '해당 기능은 유료 기능입니다. 사용 전 영업팀에 문의해 개통해 주세요~',
    effectiveDataSource: '효과적인 데이터 소스',
    partName: '판재명'
    },
  userAccessToken: {
    createTime: '생성 시간',
    lastUsedTime: '마지막 사용 시간',
    expireTime: '만료 시간',
    status: '상태',
    tokenNamePlaceholder: '토큰 이름을 입력하세요',
    expireTimeSelectPlaceholder: '만료 시간을 선택하세요',
    securityBannerTip: '개인 액세스 토큰을 다른 사람과 공유하거나 브라우저나 다른 클라이언트 코드에 노출하지 마세요. 계정 보호를 위해 공개적으로 유출된 토큰은 자동으로 비활성화될 수 있습니다.',
    expired: '만료됨',
    valid: '유효',
    remove: '제거',
    previewOnceWarning: '이 토큰은 한 번만 표시됩니다. 이 비밀을 안전하고 접근 가능한 곳에 저장하세요. 다른 사람과 공유하거나 브라우저나 다른 클라이언트 코드에 노출하지 마세요.',
    token: '토큰',
    deleteConfirm: '이 토큰을 삭제하시겠습니까?',
    userAccessToken: '사용자 액세스 토큰',
    dayUnit: '일',
    custom: '사용자 지정',
    previewModalTitle: '새 개인 액세스 토큰',
    addModalTitle: '새 개인 액세스 토큰 추가'
    },
  bujianStore: {
    inputPlaceholder: '플랜크 바코드를 입력하여 보완 소판 검색',
    noData: '데이터가 없습니다.',
    loadingErr: '보완 소판 로딩 실패',
    bujianStore: '보완 소판 라이브러리',
    awaitStore: '보완 소판 라이브러리',
    noDrag: '배치할 수 없습니다, 보완 소판 라이브러리에 넣기 위해 버튼을 클릭하세요',
    outOfCanvas: '배치할 수 없습니다, 보드의 재료, 색상 및 두께 속성을 확인하세요'
    },
  alginTexture: {
    tip: '현재 작업은 판재의 텍스처 정렬 정보를 삭제합니다. 계속하시겠습니까?',
    tip2: '현재 작업은 판재 간격을 변경하여 가공 문제를 발생시킵니다. 계속하시겠습니까?',
    group: '텍스처 그룹',
    groupTemp: '텍스처 그룹 첫 번째',
    textureAlignmentPlank: '무늬 정렬 판재를 이동할 수 없습니다'
    },
  customizeFolder: {
    customizeFolder: '폴더 사용자 정의',
    customizeFolderTip: '참고: 폴더 사용자 정의를 활성화한 후 이전에 설정된 폴더 분할 규칙이 더 이상 적용되지 않습니다',
    processingFilesTitle: '파일 데이터 처리',
    dragToFolderTip: '왼쪽 폴더로 드래그하여 하위 폴더 또는 파일로 만들 수 있습니다',
    folderNameEmpty: '폴더 이름은 비워둘 수 없습니다',
    folderNameExists: '동일한 이름의 폴더가 존재합니다',
    fileNotFound: '올바른 파일을 가져오지 못했습니다',
    fileCannotBeClassified: '이 유형의 파일은 어떤 분류 폴더에도 배치할 수 없습니다',
    cannotAddAtThisPosition: '이 위치에 추가할 수 없습니다',
    fileAlreadyExists: '【{name}】이 폴더에 이미 존재합니다',
    confirmDeleteFolder: '이 폴더를 삭제하시겠습니까?',
    confirmDeleteItem: '【{name}】을 삭제하시겠습니까?',
    confirmDeleteFolderWithChildren: '이 폴더 아래에 다른 폴더/파일이 있습니다. 삭제하시겠습니까?',
    deleteFile: '파일 삭제',
    addSubFolder: '하위 폴더 추가',
    editFolder: '폴더 편집',
    deleteFolder: '폴더 삭제',
    rootCannotDelete: '루트 디렉토리는 삭제할 수 없습니다',
    newFolder: '새 폴더',
    fileUsedCanDrag: '사용됨 - 반복해서 드래그할 수 있음',
    fileDraggable: '드래그 가능',
    addFileToFolder: '【{fileName}】을 {folderName}에 추가',
    addFolderTitle: '폴더 추가',
    editFolderTitle: '폴더 편집',
    folderNameLabel: '폴더 이름',
    folderNamePlaceholder: '폴더 이름을 입력하세요',
    sequenceStartLabel: '증분 시퀀스 시작 값',
    classifyMethodLabel: '분류 방법',
    nameLengthLimitLabel: '문자 길이 제한',
    tagInsertTip: '태그를 클릭하여 폴더 이름에 삽입하세요',
    classifyTagInsertTip: '태그를 클릭하여 폴더 이름에 삽입하세요. 파일은 지정된 태그에 따라 분류됩니다',
    engraving_front: '조각기 전면 파일',
    engraving_opposite: '조각기 후면 파일',
    engraving_merge: '조각기 병합 파일',
    engraving_mill: '이차 가공牛角槽 밀링',
    engraving_haitang: '이차 가공 경사진 해당 각 파일',
    engraving_arc_slot: '이차 가공 밀링 바닥 원호 슬롯',
    engraving_line_slot: '이차 가공 사용자 정의 도구 경로',
    engraving_straight_arc_slot: '이차 가공 원호 절곡 부분 직선 슬롯',
    engraving_frame_door: '이차 가공 뼈 문 파일',
    engraving_inner_shape: '이차 가공 내부 형상',
    engraving_hole: '이차 가공 일반 구멍',
    engraving_slot: '이차 가공 일반 슬롯',
    engraving_single_file_merge: '이차 가공 파일 병합',
    electronic_saw: '전자 톱 파일',
    glass: '유리 절단기 파일',
    glass_machine: '유리 절단기',
    side_machine: '사이드 홀 머신 파일',
    side_machine_xml3: '구 버전 사이드 홀 머신 XML3 파일',
    side_machine_txt: '구 버전 사이드 홀 머신 TXT 파일',
    side_machine_nc: '구 버전 사이드 홀 머신 NC 파일',
    dock56F: '5/6면 드릴 파일',
    ptp: 'PTP 파일',
    aio: '일체기 파일',
    aio_anc: '일체기 전면 ANC 파일',
    labeling_1: '라벨링 머신 파일 1',
    labeling_2: '라벨링 머신 파일 2',
    labeling_3: '라벨링 머신 파일 3',
    robotic_arm: '로봇 암 파일',
    label_image: '라벨 이미지 파일',
    label_pdf: '라벨 PDF 파일',
    paiban_image: '타이포그래피 이미지 파일',
    paiban_pdf: '타이포그래피 이미지 PDF 파일',
    engraving: '조각 기계',
    electronic: '전자 톱',
    side_hole: '사이드 홀 머신',
    drilling: '5/6면 드릴',
    labeling: '라벨링 머신',
    robotic: '로봇 암',
    label: '라벨',
    warningTip: '참고: 중괄호 【{}】 및 내용은 완전성을 유지해야 하며 수동으로 삭제/추가하지 마세요!',
    fileClassifyError: '이 파일은 {classifyNames}에 따라 분류할 수 없습니다',
    folderClassifyByTextureColorThickSize: '색상, 재질, 두께, 대판 크기에 따라 다른 폴더로 분류(라벨 파일 함께)',
    unnamed: '이름 없음',
    specialText: '특별한',
    surplusText: '잉여 자재',
    normalText: '일반적인',
    plankText1: '판재',
    resetTemplate: '템플릿 초기화',
    resetTemplateConfirm: '템플릿을 초기화하시겠습니까?',
    clearTemplate: '템플릿 비우기',
    clearTemplateConfirm: '템플릿을 비우시겠습니까?',
    legendFixedFolder: '고정 폴더',
    legendClassifyFolder: '분류 폴더',
    legendFixedTag: '고정 데이터',
    legendNormalTag: '동적 데이터',
    legendClassifyTag: '분류 동적 데이터',
    door_wall_aio: '벽과 장롱을 만드는 기계',
    noPermission: '현재 사용자 지정 폴더 권한이 없습니다. 사용 전 영업팀에 문의하여 구매해 주세요.',
    enableCustomFolder: '사용자 지정 폴더 활성화',
    exporttagTip: '태그 PDF와 이미지를 동시에 내보낼 때, 기본적으로 PDF가 전송됩니다'
    },
  paibanTask: {
    pausedTip: '일시 중지된 작업',
    deleteTip: '«{taskBatch}» 작업을 삭제하시겠습니까? 삭제 후에는 복구할 수 없습니다.',
    continueTip: '작업 계속',
    completed: '완료',
    failed: '작업 실패',
    paused: '일시 중지된 작업',
    pending: '대기 중인 작업',
    running: '작업 진행 중',
    extraTip: '배치 작업은 지난 일주일 데이터만 표시됩니다. 작업을 완료한 후 수동으로 작업을 저장하십시오!',
    taskStatus: '작업 상태',
    createTaskTip: '배치 작업 생성, 배치 후크로 이동',
    taskBatchTitle: '작업 배치',
    relatedOrderNosTitle: '관련 주문 번호',
    progressTitle: '배치 진행률',
    boardCountTitle: '보드 사용량 추정',
    optimizedAreaTitle: '최적화된 면적 추정',
    productionLineTitle: '생산 라인',
    operationTitle: '작업',
    optimizeRateTitle: '최적화율 추정',
    optimizeRateTip: '자동으로 잘린 낭비 자재의 최적화 비율이 계산되지 않습니다.',
    optimizeRateTip2: '특정 최적화율은 배치 페이지를 기반으로 합니다.',
    boardCountTip: '배치 페이지를 기반으로 하는 특정 데크 사용량',
    optimizedAreaTip: '최적화된 면적이 배치 페이지를 기반으로 합니다.',
    paibanSettingTip: '현재 작업 생산 라인 설정이 수정되었습니다. 현재 배치 결과는 실제 생산 내보내기 파일과 충돌할 수 있습니다. 생산 재배치를 권장합니다.',
    dataException: '데이터 예외, 페이지를 새로 고치고 다시 시도하십시오.'
    },
  paibanSetting: {
    advancedSetting: '고급 설정',
    advancedFeature: '고급 기능',
    surplusCutSpeedUp: '자동 속도 증가 잔여 재료 절단',
    surplusCutSpeedUpTip4: '기능 개발 중, 잠시 후 다시 시도해주세요',
    surplusCutSpeedUpTip: '자투리 배치 간격이 자동으로 0으로 설정됩니다',
    surplusCutSpeedUpTip2: '자투리 절단 시 이미 절단된 경로와 마감 경로를 자동으로 건너뛰어 절단 효율을 높입니다',
    surplusCutSpeedUpTip3: '이 기능은 조각기와 한 바퀴 조각기에만 적용됩니다 (공통 모서리 컷 및 공통 모서리 가속과 함께 사용하지 마세요)',
    surplusCutSpeedUpTip5: '조각기 및 한 바퀴 조각기에만 효과가 있습니다',
    featureDisplay: '기능 표시',
    featureDisplayTip: '이 페이지는 기능 진입점 표시 여부만 제어하며, 기능 자체의 사용 여부 및 파라미터 설정은 변경하지 않습니다'
    },
  alignedPlan: {
    deepSearch: '깊은 검색',
    deepSearchTip: '전용 기능: 재배자를 통해 계산 깊이를 높여 더 나은 배자 결과를 얻을 수 있습니다',
    deepSearchTip2: 'Deep Search 업그레이드 후 재배자로 계산 깊이를 높여 더 나은 결과를 얻을 수 있습니다. 현재 체험 가능',
    deepSearchTip3: 'Deep Search가 더 판재를 절약하는 방안을 제시합니다',
    deepSearchTip4: '현재 Deep Search 배자 권한이 없습니다. 구매를 위해 영업팀에 문의하세요.',
    deepSearchTip5: 'Deep Search 업그레이드 후 전용 서버 연산력으로 배자 품질을 높일 수 있습니다. 현재 미리보기 가능'
    },
  assistant: {
    title: 'AI 도우미',
    welcome: '저는 클라우드 네스팅 지능형 비서입니다. 소프트웨어 기능을 설명하고 데이터를 조회하며 해당 페이지로 안내해 드립니다.',
    close: '패널 닫기'
    }
  }